export const products = [
  {
    id: 1,
    name: "3 Axis CNC Router Machine",
    nameAr: "3 Axis CNC Router ماكينة",
    rate: 5,
    reviews: [
      {
        id: 1,
        userName: "عبدالله العتيبي",
        rating: 5,
        comment:
          "المنتج ممتاز والتغليف جيد، والأداء حتى الآن جدًا ممتاز. شكرًا لكم",
        createdAt: "Jul 2026"
      },
      {
        id: 2,
        userName: "",
        rating: 4,
        comment:
          "Good product Packaging was nice",
        createdAt: "Jul 2026"
      },
      {
        id: 3,
        userName: "فيصل القحطاني",
        rating: 5,
        comment:
          "خدمة العملاء كانت متعاونة وتم الرد على جميع استفساراتي تجربة شراء موفقة بإذن الله",
        createdAt: "June 2026"
      }
    ],

    overview:
      "Reliable, accurate, and versatile CNC cutting for wood, acrylic, plastics, and more.",
    overviewAr:
      "دقة، استقرار، وتعدد استخدامات في قص وحفر المواد المختلفة مثل الخشب والأكريليك والبلاستيك وأكثر. تعد ماكينة 3 Axis CNC Router الخيار الأساسي والأكثر انتشارًا في سوق التصنيع، لأنها توفر قص وحفر وتفريز عالي الدقة مع حركة متزامنة على محاور X و Y و Z. تقدم أداء ثابت وجودة تشطيب ممتازة، مما يجعلها مثالية لورش النجارة، مصانع الأثاث، صناعة اللوحات الإعلانية، أعمال الأكريليك، النماذج الأولية، والتصنيع العام. خيار ممتاز يجمع بين الأداء والتكلفة والمرونة — مناسب للورش الصغيرة والمصانع الكبيرة.",

    image: "/products/3 Axis CNC Router Machine.jfif",
    image_small: "/products/3 Axis CNC Router Machine.jfif",
    video: "/../products/cnc machine.mp4",
    slug: "3-axis-cnc-router-machine",

    title: "3 Axis CNC Router Machine",
    titleAr: "ماكينة راوتر CNC ثلاثية المحاور",

    desc: "3 Axis CNC Router machine for woodworking, MDF, acrylic, plastic, and sheet material processing. Sigma Machines supplies high-quality CNC routers in Egypt with precision cutting, engraving, and milling capabilities. Ideal for furniture manufacturing, signage production, and industrial applications. Looking for a CNC router Egypt supplier, CNC machine Egypt solutions, or CNC router machines for sale? Discover reliable performance, competitive CNC router prices, and professional local support.",
    descAr: "ماكينة 3 Axis CNC Router احترافية للقص والحفر والتفريز على الخشب وMDF والأكريليك والبلاستيك والمواد المسطحة المختلفة. توفر سيجما ماشينز ماكينات CNC عالية الجودة في مصر بدقة تشغيل ممتازة وأداء موثوق لمصانع الأثاث والإعلانات والتطبيقات الصناعية. إذا كنت تبحث عن ماكينة CNC خشب، أو ماكينة راوتر CNC للبيع، أو ترغب في معرفة سعر ماكينة راوتر CNC وسعر ماكينة CNC خشب، فهذه الماكينة توفر الحل المثالي مع دعم فني وخدمة ما بعد البيع. لمعرفه أسعار ماكينات CNC بالسعودية تواصل معنا",

    details: {
      keyFeatures: [
        {
          title: "High-Precision 3-Axis Motion System",
          titleAr: "نظام حركة دقيق على ثلاثة محاور",
          points: [
            "Accurate movement on X, Y & Z axes",
            "Supports 2D, 2.5D, and basic 3D carving",
            "Smooth contour cutting with minimal vibration",
            "Ideal for engraving, profiling, pocketing, and drilling",
          ],
          pointsAr: [
            "حركة متزامنة على محاور X,Y,Z",
            "يدعم أعمال 2D و2.5D وأساسيات 3D",
            "قص ناعم بدون اهتزاز",
            "مثالي للنقش والتفريغ والقص والتثقيب",
          ],
        },
        {
          title: "Industrial-Grade Structure",
          titleAr: "هيكل صناعي قوي",
          points: [
            "Heavy-duty steel welded frame",
            "Reinforced gantry structure",
            "HIWIN linear guide rails",
            "Rack & pinion transmission on X and Y axes",
            "Ball screw for accurate Z-axis motion",
          ],
          pointsAr: [
            "هيكل فولاذي ملحوم عالي التحمل",
            "جسر مُدعّم لتحمل ضغط العمل",
            "مسارات HIWIN",
            "نظام رف وترس لمحوري X/Y",
            "لولب كروي لمحور Z لضمان أعلى دقة",
          ],
        },
        {
          title: "Powerful Spindle Options",
          titleAr: "خيارات سبندل متعددة",
          points: [
            "3.2kW / 4.5kW / 6kW / 9kW spindle options",
            "Air-cooled or water-cooled",
            "Up to 24,000 RPM",
            "Suitable for hardwood, MDF, acrylic, plastics, and foam",
          ],
          pointsAr: [
            "3.2kW / 4.5kW / 6kW / 9kW",
            "تبريد هوائي أو مائي",
            "سرعة تصل إلى 24,000 دورة",
            "مناسب للخشب، MDF، الأكريليك، البلاستيك، الفوم وأكثر",
          ],
        },
        {
          title: "Smart CNC Controller",
          titleAr: "وحدة تحكم ذكية",
          points: [
            "NcStudio, RichAuto DSP, Mach3/Mach4, Syntec (optional)",
            "Easy operation and smooth toolpath handling",
            "USB file transfer",
            "Supports G-code and CAM software",
          ],
          pointsAr: [
            "أنظمة NcStudio / RichAuto DSP / Mach3 / Mach4 / Syntec (اختياري)",
            "تشغيل سهل ومعالجة مسارات سلسة",
            "نقل ملفات USB",
            "يدعم G-code وجميع برامج CAM",
          ],
        },
        {
          title: "Vacuum Table & Dust Collection (Optional)",
          titleAr: "طاولة شفط وتجميع نشارة (اختياري)",
          points: [
            "Strong vacuum hold-down",
            "Dust shoe and collector system",
            "Cleaner cuts and reduced cleanup time",
          ],
          pointsAr: [
            "تثبيت قوي للشرائح",
            "نظام شفط للتنظيف",
            "جودة قص أعلى + تقليل وقت التنظيف",
          ],
        },
      ],

      workingArea: ["1300×2500 mm", "1500×3500 mm", "2000×4000 mm", "2000×6000 mm"],
      workingAreaAr: ["1300×2500 مم", "1500×3500 مم", "2000×4000 مم", "2000×6000 مم"],

      applications: [
        {
          category: "Woodworking & Furniture",
          categoryAr: "صناعة الخشب والأثاث",
          items: [
            "MDF doors",
            "Cabinet panels",
            "Decorative wall panels",
            "2.5D carving",
            "Furniture components",
          ],
          itemsAr: [
            "أبواب MDF",
            "أبواب خزائن",
            "ديكورات حائط",
            "نحت 2.5D",
            "أجزاء الأثاث",
          ],
        },
        {
          category: "Signage & Advertising",
          categoryAr: "الدعاية والإعلان",
          items: [
            "Acrylic letters",
            "Engraved signs",
            "PVC, foam & composite sheets",
            "2D & 3D logos",
          ],
          itemsAr: [
            "حروف أكريليك",
            "لوحات محفورة",
            "PVC – فوم – مواد مركبة",
            "شعارات 2D و3D",
          ],
        },
        {
          category: "Plastic & Acrylic Fabrication",
          categoryAr: "تشكيل الأكريليك والبلاستيك",
          items: ["Display stands", "Lightboxes", "Retail fixtures", "Precision cuts"],
          itemsAr: ["ستاندات العرض", "الليت بوكس", "تجهيزات محلات", "قصات دقيقة"],
        },
        {
          category: "Prototyping & Engineering Models",
          categoryAr: "النماذج الأولية والتجهيزات الهندسية",
          items: ["Foam patterns", "Casting molds", "Architectural models"],
          itemsAr: ["فراغات الفوم", "قوالب صب", "نماذج معمارية"],
        },
        {
          category: "General Manufacturing",
          categoryAr: "التصنيع العام",
          items: ["Drilling", "Pocketing", "Contour cutting", "Engraving & marking"],
          itemsAr: ["تثقيب", "تفريغ", "قص كونتور", "نقش وترقيم"],
        },
      ],

      advantages: [
        "Stable and reliable for long working hours",
        "Excellent performance-to-price ratio",
        "Easy to operate and learn",
        "Works on many material types",
        "High-speed cutting with smooth finish",
        "Low maintenance and long lifespan",
      ],
      advantagesAr: [
        "استقرار عالي للعمل لساعات طويلة",
        "أداء ممتاز مقابل السعر",
        "سهل التشغيل والتعلم",
        "يعمل على مواد كثيرة",
        "سرعة عالية وتشطيب ناعم",
        "صيانة قليلة وعمر طويل",
      ],
    },

    TitleTag: "3 Axis CNC Router | Wood, MDF & Acrylic Cutting Machine",
    MetaDescription:
      "High-performance 3 Axis CNC Router for woodworking, furniture, acrylic cutting, sign making & more. Fast cutting, high accuracy & stable performance.",
    Keywords:
      "axis CNC router, wood CNC machine, MDF CNC cutting, acrylic CNC router, CNC engraving machine , 3 Axis CNC Router, CNC Router Egypt, CNC Machine Egypt, Wood CNC Machine, CNC Router Machine for Sale, CNC Router Price Egypt, Woodworking CNC Router, MDF CNC Cutting Machine, Industrial CNC Router, CNC Engraving Machine, Furniture Manufacturing CNC, Sigma Machines Egypt , ماكينة cnc , cnc router, cnc operator ",

    TitleTagAr: "ماكينة CNC خشب 3 محاور | راوتر قص وتقطيع MDF وأكريليك | سيجما ماشينز",
    MetaDescriptionAr:
      "ماكينة 3 Axis CNC Router عالية الأداء للخشب والأكريليك وصناعة الأثاث واللوحات الإعلانية. دقة عالية وتشغيل ثابت وسرعة قص ممتازة.",
    KeywordsAr:
      "راوتر CNC ثلاثي المحاور, ماكينة CNC خشب, قص MDF, قص أكريليك, ماكينة تفريغ CNC , 3 Axis CNC Router, CNC Router Egypt, CNC Machine Egypt, Wood CNC Machine, CNC Router Machine for Sale, CNC Router Price Egypt, Woodworking CNC Router, MDF CNC Cutting Machine, Industrial CNC Router, CNC Engraving Machine, Furniture Manufacturing CNC, Sigma Machines Egypt , ماكينة cnc , cnc router , cnc operator"
  },

  {
    id: 2,
    name: "4 Axis CNC Router Machine",
    nameAr: "4 Axis CNC Router ماكينة",
    rate: 5,
    reviews: [
      {
        id: 1,
        userName: "محمد الشهري",
        rating: 5,
        comment:
          "وصل الطلب في الوقت المحدد وكانت المواصفات مطابقة تمامًا لما هو معروض في الموقع. تجربة ممتازة وسأتعامل معكم مرة أخرى.",
        createdAt: "May 2026"
      }
    ],

    overview:
      "Advanced 4-Axis Machining with Tilting Spindle for Angled Cutting & Deep 3D Carving.",
    overviewAr:
      "تقنية متقدمة للقص والنحت بزاويا مختلفة بفضل دوران/ميلان السبندل نفسه. ماكينة 4 Axis CNC هنا ليست نظام Rotary، بل حركة دوران للسبندل على محور B، مما يسمح بالقص من زوايا لا يمكن الوصول لها بماكينة 3 محاور. مثالية لقص الزوايا، التشطيب المائل، الأعمال الفنية، النحت العميق، والتشكيلات المعقدة.",

    image: "/products/router-550x750.png",
    image_small: "/products/router-350x370.png",
    slug: "4-axis-cnc-router-laser-machine",

    title: "4 Axis CNC Router Machine",
    titleAr: "ماكينة راوتر CNC رباعية المحاور",

    desc: "The 4-axis CNC router features a tilting spindle for advanced machining, allowing angled cuts, undercuts, multi-surface shaping, and deep 3D carving without flipping the workpiece.",
    descAr:
      "تتميز ماكينة 4 محاور CNC بسبندل قابل للميلان لتنفيذ عمليات قص ونحت متقدمة، مما يسمح بالقص بزاويا مختلفة، وتنفيذ الانحدارات، وتشكيل الأسطح متعددة الاتجاهات، والنحت العميق بدون الحاجة لقلب الخامة.",

    details: {
      keyFeatures: [
        {
          title: "Tilting Spindle (B-Axis on the Head)",
          titleAr: "سبندل متحرك قابل للميلان (محور B)",

          points: [
            "Spindle rotates/tilts around the B-axis",
            "No need to flip the workpiece",
            "Ideal for angled cuts, chamfers, and curved surfaces",
            "Supports true 4-axis simultaneous machining",
            "Perfect for deep 3D sculptures and complex contours"
          ],

          pointsAr: [
            "دوران/ميلان السبندل على رأس الماكينة",
            "بدون الحاجة لقلب الخامة",
            "مثالي للقص المائل والانحناءات",
            "يدعم تشغيل 4 محاور متزامنة",
            "أداء ممتاز في النحت العميق"
          ]
        },

        {
          title: "High-Performance Cutting Capability",
          titleAr: "قدرات قص عالية",

          points: [
            "Executes undercuts and negative angles",
            "Carves deep 3D shapes smoothly",
            "Cuts multi-directional surfaces in a single setup",
            "Reduces manual finishing significantly"
          ],

          pointsAr: [
            "تنفيذ الانحدارات والزاويا السالبة",
            "نحت 3D عميق وسلس",
            "قص متعدد الاتجاهات في نفس العملية",
            "يقلل أعمال التشطيب اليدوي"
          ]
        },

        {
          title: "Industrial-Grade Machine Structure",
          titleAr: "هيكل صناعي عالي القوة",

          points: [
            "Heavy-duty welded steel body",
            "Reinforced gantry for tilting spindle load",
            "HIWIN linear guide rails",
            "Rack & pinion transmission for X/Y axes",
            "Ball screw Z-axis for maximum accuracy"
          ],

          pointsAr: [
            "هيكل فولاذي مُعزز",
            "جسر قوي لتحمل ضغط ميلان السبندل",
            "مسارات HIWIN",
            "رف وترس لمحاور X/Y",
            "لولب كروي لمحور Z"
          ]
        },

        {
          title: "Powerful Spindle Options",
          titleAr: "خيارات سبندل قوية",

          points: [
            "6kW / 9kW / 12kW spindle power",
            "Air-cooled or water-cooled options",
            "Up to 24,000 RPM",
            "Suitable for hardwood, MDF, foam, acrylic, and composites"
          ],

          pointsAr: [
            "6kW – 9kW – 12kW",
            "تبريد هوائي/مائي",
            "حتى 24,000 دورة",
            "مناسب للخشب – MDF – الفوم – الأكريليك – المواد المركّبة"
          ]
        },

        {
          title: "Smart 4-Axis CNC Controller",
          titleAr: "تحكم ذكي لأربع محاور",

          points: [
            "Supports Syntec, NcStudio, RichAuto, and OSAI",
            "Smooth interpolation across X, Y, Z, and A axes",
            "Supports 4-axis G-code",
            "Auto tool calibration",
            "High-precision toolpath control"
          ],

          pointsAr: [
            "متوافق مع Syntec – NcStudio – RichAuto – OSAI",
            "انسيابية حركة X,Y,Z,B",
            "G-code خاص 4 محاور",
            "معايرة أوتوماتيكية للأداة",
            "تحكم عالي الدقة في مسار الأداة"
          ]
        }
      ],

      workingArea: ["1500 × 3500 mm", "2000 × 4000 mm", "2000 × 6000 mm"],
      workingAreaAr: ["1500×3500 مم", "2000×4000 مم", "2000×6000 مم"],

      applications: [
        {
          category: "High-End Furniture Manufacturing",
          categoryAr: "الأثاث الفاخر",

          items: [
            "Curved doors",
            "Sculpted chair and table components",
            "Multi-angle joints",
            "Artistic wooden structures"
          ],
          itemsAr: [
            "أبواب منحنية",
            "أجزاء منحوته",
            "وصلات متعددة الزوايا",
            "قطع ديكور فنية"
          ]
        },

        {
          category: "3D Carving & Artistic Production",
          categoryAr: "النحت والفنون",

          items: ["Deep 3D sculpting", "Organic and artistic shapes", "Complex multi-angle carvings"],
          itemsAr: ["نحت 3D عميق", "أشكال معقدة", "مجسمات عضوية"]
        },

        {
          category: "Mold & Prototype Production",
          categoryAr: "القوالب والنماذج",

          items: ["Foam molds", "Wooden patterns", "Multi-surface shaping without repositioning"],
          itemsAr: ["قوالب فوم", "نماذج خشب", "تشكيل متعدد الأسطح"]
        },

        {
          category: "Architectural Decoration",
          categoryAr: "الديكور المعماري",

          items: ["Curved wall panels", "Multi-layer decorative elements", "Sculpted columns"],
          itemsAr: ["ألواح منحنية", "عناصر ديكور متعدد الطبقات", "أعمدة منحوتة"]
        }
      ],

      advantages: [
        "True 4-axis machining with spindle rotation",
        "Cuts angles impossible for 3-axis machines",
        "No need to flip or reposition material",
        "Faster and more accurate multi-surface machining",
        "Excellent finishing quality"
      ],

      advantagesAr: [
        "تشغيل 4 محاور حقيقي",
        "قص من زوايا مستحيلة على 3 محاور",
        "يلغي قلب الخامة",
        "سرعة ودقة أعلى",
        "جودة تشطيب ممتازة"
      ]
    },

    TitleTag: "4 Axis CNC Router | Tilting Spindle | 3D Carving & Angled Cutting",
    TitleTagAr: "ماكينة CNC رباعية المحاور | سبندل مائل | نحت 3D وقص بزاويا مختلفة",

    MetaDescription:
      "Advanced 4 Axis CNC Router with tilting spindle for 3D carving, mold making, angled cutting, and multi-surface machining.",
    MetaDescriptionAr:
      "ماكينة CNC رباعية المحاور مع سبندل مائل للنحت ثلاثي الأبعاد، صناعة القوالب، القص المائل، وتشكيل الأسطح متعددة الاتجاهات.",

    Keywords:
      "4 axis CNC router, tilting spindle, 3D carving CNC machine, multi-surface machining, advanced CNC router",
    KeywordsAr:
      "ماكينة CNC 4 محاور، سبندل مائل، نحت ثلاثي الأبعاد، قص متعدد الاتجاهات، ماكينة راوتر متقدمة",

    SEOContent:
      "The 4 Axis CNC Router with a tilting spindle performs angled cutting, multi-face machining, and complex 3D carving.",
    SEOContentAr:
      "تقوم ماكينة CNC رباعية المحاور المزودة بسبندل مائل بعمليات قص من زوايا مختلفة، تشكيل متعدد الأسطح، ونحت ثلاثي الأبعاد مع دقة عالية وبدون قلب الخامة."
  },

  {
    id: 3,
    name: "5 Axis CNC Router Machine",
    nameAr: " 5 Axis CNC Router ماكينة",
    rate: 4,
    reviews: [
      {
        id: 1,
        userName: "خالد المطيري",
        rating: 4,
        comment:
          "المنتج جيد والجودة مرضية، لكن استغرق الشحن وقتًا أطول من المتوقع. بشكل عام التجربة كانت جيدة وسأكرر الشراء عند الحاجة.",
        createdAt: "Jun 2026"
      }
    ],

    overview:
      "Ultimate 5-Axis Machining for Complex 3D Surfaces, Deep Sculpting & Multi-Angle Cutting.",
    overviewAr:
      "تقنية الخمسة محاور هي قمة ما وصلت له تكنولوجيا القصّ والنحت ثلاثي الأبعاد. ماكينة 5 Axis CNC Router مزودة برأس سبندل يتحرك ويميل ويدور بالكامل (محور B + محور C)، مما يسمح للأداة بالوصول للقطعة من أي اتجاه تقريبًا دون الحاجة لقلب الخامة. مثالية للنحت العميق، الأشكال العضوية، القوالب الصناعية، الأجزاء الهندسية، والأعمال المعقدة متعددة الزوايا.",

    image: "/products/5 Axis CNC Router Machine.jfif",
    image_small: "/products/5 Axis CNC Router Machine.jfif",
    slug: "5-axis-cnc-router-machine",

    title: "5 Axis CNC Router Machine",
    titleAr: "ماكينة راوتر CNC خمس محاور",

    desc:
      "The 5-axis CNC router features a tilting and rotating spindle head (B-axis + C-axis), enabling full multi-directional machining for complex 3D shapes, molds, sculptures, and high-precision industrial components.",
    descAr:
      "ماكينة 5 محاور تأتي برأس سبندل قابل للميلان والدوران (محور B + محور C) مما يوفر تشغيل كامل متعدد الاتجاهات للقص والنحت ثلاثي الأبعاد، القوالب، التماثيل، والأجزاء الصناعية عالية الدقة.",

    details: {
      keyFeatures: [
        {
          title: "Dual-Axis Tilting Spindle Head (B-axis + C-axis)",
          titleAr: "رأس سبندل متحرك بمحورين (B + C)",
          points: [
            "Spindle tilts on B-axis and rotates on C-axis",
            "Supports full 5-axis simultaneous machining",
            "Perfect for undercuts, compound angles, and curved surfaces",
            "Tool can approach the workpiece from any direction",
            "Eliminates repositioning or flipping the material"
          ],
          pointsAr: [
            "ميلان ودوران كامل للسبندل على محوري B و C",
            "تشغيل 5 محاور متزامن بالكامل",
            "معالجة الانحدارات والقصات المركبة والانحناءات",
            "الوصول إلى القطعة من أي زاوية",
            "إلغاء الحاجة لقلب الخامة أو إعادة تثبيتها"
          ]
        },
        {
          title: "True 5-Axis Interpolation",
          titleAr: "تشغيل 5 محاور حقيقي",
          points: [
            "Smooth and accurate 5-axis toolpath execution",
            "Ideal for organic shapes, sculptures, and molds",
            "Perfect for aerospace-grade surface machining",
            "Delivers ultra-smooth finishing with minimal handwork"
          ],
          pointsAr: [
            "تحكم ناعم ودقيق في مسار الأداة",
            "مثالي للأشكال العضوية والتماثيل والقوالب",
            "تشغيل مثالي لمكونات صناعية معقدة",
            "تشطيب عالي الجودة مع تقليل العمل اليدوي"
          ]
        },
        {
          title: "High-Strength Heavy-Duty Structure",
          titleAr: "هيكل صناعي فائق القوة",
          points: [
            "Reinforced steel frame designed for 5-axis torque",
            "Gantry engineered to support tilting-head spindle weight",
            "HIWIN/PMI linear guide rails",
            "Rack & pinion transmission on X/Y axes",
            "Ball screw Z-axis for maximum accuracy",
            "Rigid construction for vibration-free machining"
          ],
          pointsAr: [
            "هيكل فولاذي مُدعّم لتحمل عزم تشغيل 5 محاور",
            "جسر قوي لتحمل وزن رأس السبندل المائل",
            "سكك حركة HIWIN/PMI عالية الجودة",
            "نظام رف وترس لمحوري X و Y",
            "لولب كروي لمحور Z لضمان أعلى دقة",
            "ثبات عالي وتشغيل بدون اهتزاز"
          ]
        },
        {
          title: "High-Performance Spindle Options",
          titleAr: "خيارات سبندل عالية الأداء",
          points: [
            "9kW / 12kW / 15kW HSD or equivalent",
            "Air-cooled or water-cooled",
            "Up to 24,000 RPM",
            "Supports long-duration 5-axis machining cycles"
          ],
          pointsAr: [
            "خيارات سبندل 9kW / 12kW / 15kW",
            "تبريد هوائي أو مائي",
            "سرعة حتى 24,000 RPM",
            "مناسب للتشغيل الطويل والمستمر"
          ]
        },
        {
          title: "Advanced 5-Axis CNC Controller",
          titleAr: "نظام تحكم متطور لتشغيل 5 محاور",
          points: [
            "Syntec 5-axis, OSAI 5-axis, Siemens/Fanuc (optional)",
            "Supports full 5-axis simultaneous machining",
            "5-axis RTCP (Rotational Tool Center Point)",
            "Tool length compensation",
            "Smooth 5-axis surface processing",
            "High-speed data handling and precision control"
          ],
          pointsAr: [
            "Syntec 5-axis – OSAI – Siemens – Fanuc (اختياري)",
            "تشغيل 5 محاور كامل بالتزامن",
            "تقنية RTCP للتحكم بمركز دوران الأداة",
            "تعويض طول الأداة",
            "معالجة ناعمة للأسطح المعقدة",
            "تحكم سريع ودقيق بالمعالجة"
          ]
        }
      ],

      workingArea: ["1500×3500 mm", "2000×4000 mm", "2000×6000 mm"],
      workingAreaAr: ["1500×3500 مم", "2000×4000 مم", "2000×6000 مم"],

      applications: [
        {
          category: "High-End Furniture & Woodworking",
          categoryAr: "الأثاث الراقي والخشب الفاخر",
          items: [
            "Sculpted chair bodies",
            "Curved and twisted panels",
            "Artistic wooden structures",
            "Complex multi-angle joints"
          ],
          itemsAr: [
            "هياكل كراسي منحوتة",
            "ألواح خشبية منحنية ومعقدة",
            "أعمال فنية خشبية",
            "وصلات متعددة الزوايا"
          ]
        },
        {
          category: "3D Sculpture & Artistic Production",
          categoryAr: "النحت ثلاثي الأبعاد والأعمال الفنية",
          items: [
            "Life-size sculptures",
            "Organic 3D forms",
            "Art installations",
            "Decorative shapes"
          ],
          itemsAr: [
            "تماثيل كبيرة الحجم",
            "أشكال ثلاثية الأبعاد عضوية",
            "تركيبات فنية",
            "ديكورات وتصاميم فنية"
          ]
        },
        {
          category: "Mold & Prototype Manufacturing",
          categoryAr: "تصنيع القوالب والنماذج الأولية",
          items: [
            "Automotive molds",
            "3D surface molds",
            "Foam, wood, and resin patterns",
            "Large prototypes with undercuts"
          ],
          itemsAr: [
            "قوالب سيارات",
            "قوالب أسطح ثلاثية الأبعاد",
            "نماذج فوم وخشب ورزين",
            "نماذج كبيرة بانحدارات عميقة"
          ]
        },
        {
          category: "Aerospace & Marine Components",
          categoryAr: "مكونات الطيران والبحرية",
          items: [
            "Composite shaping",
            "Aerodynamic components",
            "Multi-surface trimming",
            "Precision machining"
          ],
          itemsAr: [
            "تشكيل المواد المركبة",
            "أجزاء انسيابية",
            "قص متعدد الأسطح",
            "تشغيل دقيق لقطع معقدة"
          ]
        },
        {
          category: "Architectural & Interior Design",
          categoryAr: "العمارة والديكور الداخلي",
          items: [
            "3D wall panels",
            "Sculpted columns",
            "Organic interior structures",
            "Custom artistic installations"
          ],
          itemsAr: [
            "ألواح حائط ثلاثية الأبعاد",
            "أعمدة منحوتة",
            "هياكل داخلية عضوية",
            "تصاميم فنية خاصة"
          ]
        }
      ],

      advantages: [
        "Allows machining from any angle or direction",
        "No need to flip or reposition the workpiece",
        "Perfect for extremely complex 3D geometries",
        "High-precision sculpting and mold production",
        "Reduced manual finishing work",
        "Ultra-smooth surface quality",
        "Maximum flexibility for advanced manufacturing"
      ],
      advantagesAr: [
        "الوصول لأي سطح من أي زاوية",
        "عدم الحاجة لقلب أو إعادة تثبيت الخامة",
        "مثالية للأشكال ثلاثية الأبعاد المعقدة جدًا",
        "نحت عالي الدقة وتصنيع قوالب احترافي",
        "تقليل كبير في العمل اليدوي",
        "تشطيب سطحي فائق النعومة",
        "أقصى مرونة لتطبيقات التصنيع المتقدمة"
      ]
    },

    TitleTag: "5 Axis CNC Router | A&C Axis | Advanced 3D Machining",
    MetaDescription:
      "Professional 5 Axis CNC Router with B and C rotating spindle for deep 3D carving, molds, prototypes, and multi-angle machining.",
    Keywords:
      "5 axis CNC router, B&C axis CNC, 5 axis machining, 3D sculpting CNC, mold CNC machine",

    TitleTagAr: "ماكينة راوتر CNC خمس محاور | نحت ثلاثي الأبعاد وقوالب احترافية",
    MetaDescriptionAr:
      "ماكينة CNC خمس محاور برأس متحرك (B + C) للنحت العميق والتصنيع ثلاثي الأبعاد والقوالب الكبيرة والهندسية بدقة عالية وتشغيل مستمر.",
    KeywordsAr:
      "راوتر CNC خمس محاور, ماكينة نحت 5 محاور, ماكينة قوالب 5 محاور, نحت ثلاثي الأبعاد, CNC صناعي متقدم"
  },

  {
    id: 4,
    name: "Rotary Axis CNC Router Machine",
    nameAr: "ماكينة CNC Router بمحور دوار (Rotary Axis)",
    rate: 0,

    overview:
      "Precision machining for cylindrical, curved, and 3D round components with full 360° rotary axis control.",
    overviewAr:
      "مصممة خصيصًا للقصّ والنحت على القطع الأسطوانية والدائرية. مزودة بمحور دوار (A-axis) يوفر معالجة كاملة بزاوية 360° لتصنيع الأعمدة، القوائم، الأرجل، القوالب، التماثيل، والمجسمات ثلاثية الأبعاد. تعمل كـ 3 محاور عادية + محور دوار لتوفير تشغيل 4 محاور كامل.",

    image: "/products/Rotary Axis CNC Router Machine.jfif",
    image_small: "/products/Rotary Axis CNC Router Machine.jfif",
    slug: "rotary-axis-cnc-router-machine",

    title: "Rotary Axis CNC Router Machine",
    titleAr: "ماكينة راوتر CNC بمحور دوار",

    desc:
      "The Rotary Axis CNC Router is engineered for precision machining of cylindrical, round, and 3D curved components using an integrated A-axis system that enables full 360-degree carving and multi-sided processing.",
    descAr:
      "ماكينة المحور الدوّار مصممة خصيصًا لقص ونحت القطع الأسطوانية والدائرية باستخدام نظام محور A الذي يسمح بدوران 360 درجة للنحت العميق والعمل متعدد الجوانب بدقة عالية.",

    details: {
      keyFeatures: [
        {
          title: "High-Precision Rotary Axis (A-Axis)",
          titleAr: "محور دوار عالي الدقة (A-axis)",
          points: [
            "Full 360° continuous rotation",
            "Heavy-duty chuck and tailstock support",
            "Supports long and heavy cylindrical workpieces",
            "Perfect synchronization with XYZ axes",
            "Ideal for spirals, 3D round carving, and deep sculpting"
          ],
          pointsAr: [
            "دوران كامل 360°",
            "مزود بظرف أمامي وذيل خلفي",
            "تحمل ممتاز للقطع الأسطوانية الطويلة والثقيلة",
            "تزامن كامل بين المحور الدوار ومحاور XYZ",
            "مثالي للقصّ الحلزوني والنحت الدائري والنحت العميق"
          ]
        },

        {
          title: "Flexible Rotary Installation Options",
          titleAr: "خيارات تركيب مرنة للمحور الدوار",
          points: [
            "Fixed rotary axis mounted on the bed for dedicated turning work",
            "Detachable rotary axis for switching between flat and rotary jobs",
            "Suitable for workshops requiring multi-function operation"
          ],
          pointsAr: [
            "محور دوار ثابت على الطاولة للعمل الدائم",
            "محور دوار قابل للفك للتنقل بين الأعمال المسطحة وأعمال الدوران",
            "مناسب للورش التي تحتاج وظائف متعددة"
          ]
        },

        {
          title: "Powerful Spindle Options",
          titleAr: "خيارات سبندل قوية",
          points: [
            "3.2kW / 4.5kW / 6kW / 9kW spindle configurations",
            "Air-cooled or water-cooled options",
            "Up to 24,000 RPM",
            "Stable for long-duration 3D carving operations"
          ],
          pointsAr: [
            "خيارات سبندل 3.2kW / 4.5kW / 6kW / 9kW",
            "تبريد هوائي أو مائي",
            "سرعة حتى 24,000 RPM",
            "ثبات عالي لتشغيل النحت ثلاثي الأبعاد لفترات طويلة"
          ]
        },

        {
          title: "Strong Mechanical Structure",
          titleAr: "هيكل صناعي متين",
          points: [
            "Heavy-duty steel welded body",
            "HIWIN linear guide rails",
            "Rack & pinion transmission for X and Y axes",
            "Ball screw Z-axis for maximum accuracy",
            "Vibration-free machining under heavy carving loads"
          ],
          pointsAr: [
            "هيكل فولاذي ملحوم عالي التحمل",
            "سكك حركة HIWIN عالية الجودة",
            "نظام رف وترس لمحوري X و Y",
            "لولب كروي لمحور Z لأعلى دقة",
            "تشغيل ثابت بدون اهتزاز حتى تحت الأحمال الثقيلة"
          ]
        },

        {
          title: "Advanced CNC Controller",
          titleAr: "نظام تحكم متطور",
          points: [
            "Supports rotary interpolation",
            "Compatible with Syntec 6MB, RichAuto, NcStudio 4-axis, Mach3/4",
            "Smooth coordinated 4-axis motion",
            "Automatic tool calibration",
            "Accurate feed-to-rotation synchronization"
          ],
          pointsAr: [
            "يدعم تشغيل المحور الدوار (Rotary Interpolation)",
            "متوافق مع Syntec – RichAuto – NcStudio – Mach4",
            "حركة منسقة وسلسة لأربعة محاور",
            "معايرة أوتوماتيكية للأداة",
            "مزج عالي الدقة بين سرعة التغذية ودوران المحور"
          ]
        }
      ],

      workingArea: ["1500×3500 mm", "2000×4000 mm", "2000×6000 mm"],
      workingAreaAr: ["1500×3500 مم", "2000×4000 مم", "2000×6000 مم"],

      applications: [
        {
          category: "Woodworking & Furniture",
          categoryAr: "الأخشاب والأثاث",
          items: [
            "Table legs",
            "Chair legs",
            "Bed posts",
            "Decorative spindles",
            "Porch columns",
            "Handrails and staircase balusters"
          ],
          itemsAr: [
            "أرجل الطاولات",
            "أرجل الكراسي",
            "قوائم السرير",
            "أعمدة زخرفية",
            "أعمدة شرفة",
            "درابزين السلالم والقوائم الدائرية"
          ]
        },

        {
          category: "3D Sculpture & Art",
          categoryAr: "النحت ثلاثي الأبعاد والأعمال الفنية",
          items: [
            "Human and animal statues",
            "Totem poles",
            "Complex cylindrical carvings",
            "Custom artistic pieces"
          ],
          itemsAr: [
            "تماثيل بشرية وحيوانية",
            "أعمال توتم",
            "منحوتات أسطوانية معقدة",
            "أعمال فنية مخصصة"
          ]
        },

        {
          category: "Architectural & Interior Elements",
          categoryAr: "العناصر المعمارية والديكور",
          items: [
            "Ornamental pillars",
            "Decorative columns",
            "Curved moldings",
            "3D wooden ornaments"
          ],
          itemsAr: [
            "أعمدة زخرفية",
            "قوالب منحنية",
            "أشكال خشبية ثلاثية الأبعاد",
            "ديكورات داخلية فنية"
          ]
        },

        {
          category: "Advertising & Display",
          categoryAr: "الإعلان والعرض",
          items: [
            "Custom cylindrical displays",
            "3D totem structures",
            "Rounded signage components"
          ],
          itemsAr: [
            "مجسمات عرض أسطوانية",
            "هياكل توتم",
            "مكونات لافتات دائرية"
          ]
        },

        {
          category: "Crafts & Handmade Production",
          categoryAr: "الحرف اليدوية والإنتاج اليدوي",
          items: [
            "Handcrafted wooden cylinders",
            "Decorative cylindrical items"
          ],
          itemsAr: [
            "اسطوانات خشبية مصنوعة يدويًا",
            "قطع أسطوانية زخرفية"
          ]
        }
      ],

      advantages: [
        "True 360° rotary machining capability",
        "Ideal for cylindrical, round, and multi-sided components",
        "Much faster than manual lathe carving",
        "High precision for deep and detailed 3D carving",
        "Functions as both flat-bed CNC and rotary CNC",
        "Supports long, large, and heavy work materials"
      ],
      advantagesAr: [
        "دوران حقيقي 360°",
        "مثالية للقطع الأسطوانية والدائرية ومتعددة الجوانب",
        "أسرع بكثير من النحت اليدوي",
        "دقة عالية للتفاصيل العميقة",
        "تعمل كراوتر مسطح + راوتر بمحور دوار",
        "تدعم القطع الطويلة والثقيلة"
      ]
    },

    TitleTag: "Rotary Axis CNC Router | 4 Axis CNC for Cylindrical Machining",
    MetaDescription:
      "Rotary Axis CNC Router for columns, table legs, balusters, sculptures, and cylindrical 3D carving with high precision.",
    Keywords:
      "rotary axis CNC router, 4 axis CNC, column CNC machine, cylinder CNC carving, CNC lathe router",

    TitleTagAr: "ماكينة راوتر CNC بمحور دوار | نحت أسطواني 4 محاور",
    MetaDescriptionAr:
      "ماكينة CNC بمحور دوار (A-axis) للنحت الأسطواني، الأعمدة، الأرجل، التماثيل والمجسمات الدائرية بدقة عالية وتشغيل 4 محاور كامل.",
    KeywordsAr:
      "ماكينة CNC محور دوار, راوتر 4 محاور, نحت أسطواني, نحت 360 درجة, CNC أعمدة خشب",

    SEOContent: ""
  },

  {
    id: 5,
    name: "3 Axis ATC CNC Router Machine",
    nameAr: "ماكينة راوتر CNC ثلاثية المحاور ATC (تغيير أدوات أوتوماتيكي)",
    rate: 5,

    reviews: [
      {
        id: 1,
        userName: "عبدالعزيز الحربي",
        rating: 5,
        comment:
          "الماكينة ممتازة جدً تعمل بكفاءة عالية وتبديل الأدوات تلقائيًا وفر علينا الكثير من الوقت في الإنتاج. دقة القص والتشطيب رائعة وأنصح بها لأي ورشة تبحث عن الجودة والاعتمادية",
        createdAt: "Jul 2026"
      }
    ],

    overview:
      "High-speed CNC machining with automatic tool changing for maximum productivity and multi-tool operations.",
    overviewAr:
      "مصممة للمصانع التي تحتاج سرعة + دقة + تنوع أدوات بدون توقف. نظام تغيير الأدوات الأوتوماتيكي ATC يسمح بتبديل عدة أدوات خلال ثوانٍ، مما يقلل وقت التوقف ويزيد الإنتاجية. مناسبة لصناعة الأثاث، اللوحات الإعلانية، النجارة، الأكريليك، البلاستيك، الألومنيوم، والإنتاج الضخم.",

    image: "/products/3 Axis ATC CNC Router Machine.jfif",
    image_small: "/products/3 Axis ATC CNC Router Machine.jfif",
    slug: "3-axis-atc-cnc-router-machine",

    title: "3 Axis ATC CNC Router Machine",
    titleAr: "ماكينة راوتر CNC ثلاثية المحاور ATC",

    desc:
      "The 3 Axis ATC CNC Router is built for fast, accurate, and continuous production. Its automatic tool-changing system enables multi-step machining without manual intervention, making it ideal for woodworking, signage, plastics, aluminum, and mass manufacturing.",
    descAr:
      "ماكينة ATC ثلاثية المحاور مصممة للإنتاج السريع والدقيق والمستمر. نظام تغيير الأدوات الأوتوماتيكي يسمح بتنفيذ العمليات متعددة الخطوات بدون تدخل يدوي، مما يجعلها مثالية للنجارة، الإعلانات، الأكريليك، البلاستيك، الألومنيوم، والإنتاج الضخم.",

    details: {
      keyFeatures: [
        {
          title: "Automatic Tool Changer (ATC)",
          titleAr: "نظام تغيير الأدوات الأوتوماتيكي (ATC)",
          points: [
            "Available with 6 / 8 / 12 tool magazines",
            "Fast and smooth automatic tool switching",
            "Supports complex multi-step jobs",
            "Ideal for designs requiring multiple bits",
            "Reduces downtime and increases productivity"
          ],
          pointsAr: [
            "مخزن أدوات 6 أو 8 أو 12 أداة",
            "تبديل فوري وسلس للأدوات",
            "يدعم الأعمال متعددة الأدوات",
            "مثالي للتصميمات التي تحتاج عدة رؤوس",
            "يقلل وقت التوقف ويرفع الإنتاجية"
          ]
        },

        {
          title: "High-Performance Spindle",
          titleAr: "سبندل عالي الأداء",
          points: [
            "6kW / 9kW / 12kW HSD or HQD spindles",
            "Air-cooled or water-cooled options",
            "Up to 24,000 RPM",
            "Stable for continuous long-hour machining",
            "Suitable for wood, MDF, acrylic, plastics, aluminum, ACP, composites"
          ],
          pointsAr: [
            "سبندل 6kW / 9kW / 12kW HSD أو HQD",
            "تبريد هوائي أو مائي",
            "سرعة حتى 24,000 RPM",
            "ثبات كامل للتشغيل لساعات طويلة",
            "مناسب للخشب – MDF – الأكريليك – البلاستيك – الألومنيوم – ACP"
          ]
        },

        {
          title: "Heavy-Duty Industrial Structure",
          titleAr: "هيكل صناعي قوي",
          points: [
            "Reinforced steel welded frame",
            "Helical rack & pinion on X/Y axes",
            "Taiwan HIWIN linear guide rails",
            "Ball screw Z-axis for high precision",
            "Zero vibration at high speeds"
          ],
          pointsAr: [
            "هيكل فولاذي ملحوم عالي المتانة",
            "نظام رف وترس حلزوني لمحوري X و Y",
            "سكاكي HIWIN الأصلية",
            "لولب كروي لمحور Z لأعلى دقة",
            "بدون اهتزاز حتى عند السرعات العالية"
          ]
        },

        {
          title: "Smart CNC Controller",
          titleAr: "نظام تحكم ذكي",
          points: [
            "Compatible with Syntec, RichAuto, NcStudio, Mach3/4",
            "Supports multi-layer machining",
            "High-speed interpolation",
            "Automatic tool height calibration",
            "Advanced protection and safety features"
          ],
          pointsAr: [
            "متوافق مع Syntec – RichAuto – NcStudio – Mach4",
            "يدعم التشغيل متعدد الطبقات",
            "مسارات تشغيل عالية السرعة",
            "معايرة أوتوماتيكية لطول الأداة",
            "خصائص حماية وتشغيل آمن"
          ]
        }
      ],

      workingArea: [
        "1300 × 2500 mm",
        "1500 × 3500 mm",
        "2000 × 4000 mm",
        "2000 × 6000 mm"
      ],
      workingAreaAr: [
        "1300 × 2500 مم",
        "1500 × 3500 مم",
        "2000 × 4000 مم",
        "2000 × 6000 مم"
      ],

      applications: [
        {
          category: "Furniture Production",
          categoryAr: "صناعة الأثاث",
          items: [
            "MDF door carving",
            "Cabinet panels",
            "Decorative wall panels",
            "Nested-based manufacturing (NBM)",
            "Joinery and slotting"
          ],
          itemsAr: [
            "حفر أبواب MDF",
            "أبواب ودواليب المطابخ",
            "ألواح ديكور",
            "تصنيع بنظام NBM",
            "تعشيقات وقواطع خشبية"
          ]
        },

        {
          category: "Signage & Advertising",
          categoryAr: "الإعلان واللوحات",
          items: [
            "Acrylic cutting",
            "PVC board shaping",
            "3D letters",
            "ACP cutting",
            "Complex contour profiles"
          ],
          itemsAr: [
            "قص أكريليك",
            "تشكيل PVC",
            "حروف بارزة 3D",
            "قص ألواح ألومنيوم ACP",
            "مسارات قطع معقدة"
          ]
        },

        {
          category: "Woodworking Industry",
          categoryAr: "صناعة الأخشاب",
          items: [
            "Relief carving",
            "3D engraving",
            "Artistic wooden designs",
            "Moldings and frames"
          ],
          itemsAr: [
            "نحت ريليف",
            "نحت ثلاثي الأبعاد",
            "تصميمات خشبية فنية",
            "قوالب وإطارات"
          ]
        },

        {
          category: "Aluminum & Non-Ferrous Materials",
          categoryAr: "الألومنيوم والمواد غير الحديدية",
          items: [
            "Thin aluminum cutting",
            "Patterns and fixtures",
            "Composite machining"
          ],
          itemsAr: [
            "قص ألواح ألومنيوم رقيقة",
            "قوالب وتجهيزات",
            "تشغيل خامات مركّبة"
          ]
        },

        {
          category: "Plastic Fabrication",
          categoryAr: "تشكيل البلاستيك",
          items: [
            "Acrylic displays",
            "PVC/ABS components",
            "Industrial plastic parts"
          ],
          itemsAr: [
            "وحدات عرض أكريليك",
            "قطع PVC / ABS",
            "أجزاء بلاستيك صناعية"
          ]
        }
      ],

      advantages: [
        "Fully automatic multi-tool workflow",
        "No manual tool change delays",
        "Ideal for long, complex jobs",
        "High precision and industrial rigidity",
        "Supports a wide range of materials",
        "Suitable for large factories and mass production"
      ],
      advantagesAr: [
        "تشغيل كامل متعدد الأدوات بدون تدخل",
        "إلغاء وقت تغيير الأداة اليدوي",
        "مثالية للأعمال الطويلة والمعقدة",
        "دقة وثبات صناعي عالي",
        "متوافقة مع العديد من المواد",
        "مناسبة للمصانع الكبيرة والإنتاج الضخم"
      ]
    },

    TitleTag: "3 Axis ATC CNC Router | Automatic Tool Changer | High-Speed Machining",
    MetaDescription:
      "3 Axis ATC CNC Router with automatic tool changer for high-speed, continuous machining of wood, acrylic, plastics, composites, and aluminum.",
    Keywords:
      "ATC CNC router, automatic tool changer, 3 axis CNC machine, woodworking CNC, acrylic CNC, aluminum CNC, industrial CNC router",

    TitleTagAr: "ماكينة راوتر CNC ATC ثلاث محاور | تغيير أدوات أوتوماتيكي",
    MetaDescriptionAr:
      "ماكينة راوتر CNC ATC ثلاثية المحاور مزودة بنظام تغيير أدوات أوتوماتيكي للإنتاج السريع والمستمر، مناسبة للخشب والأكريليك والبلاستيك والألومنيوم.",
    KeywordsAr:
      "ماكينة CNC ATC, راوتر تغيير أدوات أوتوماتيكي, CNC ثلاثي المحاور, ماكينة راوتر خشب, ماكينة قص أكريليك, CNC ألومنيوم",

    SEOContent: ""
  },

  {
    id: 6,
    name: "4 Axis ATC CNC Router Machine",
    nameAr: "ماكينة راوتر CNC رباعية المحاور ATC",
    rate: 4,

    reviews: [
      {
        id: 1,
        userName: "تركي الدوسري",
        rating: 4,
        comment:
          "الماكينة أداؤها ممتاز ودقة الحفر جيدة",
        createdAt: "Jun 2026"
      }
    ],


    overview:
      "Advanced 4-Axis Machining with a Fully Automatic Tool Changer. The 4 Axis ATC CNC Router (Tilting Spindle Type) is designed for advanced 3D machining, angled cutting, and complex contour processing.",
    overviewAr:
      "ماكينة ATC رباعية المحاور مع رأس سبندل قابل للميلان — وليست بمحور دوّار — مناسبة للأعمال ثلاثية الأبعاد المعقدة، القص المائل، والنحت العميق. تجمع بين قوة الـ ATC ودقة الميلان 4 محاور في ماكينة واحدة.",

    image: "/products/4 Axis ATC CNC Router Machine.jfif",
    image_small: "/products/4 Axis ATC CNC Router Machine.jfif",
    slug: "4-axis-atc-cnc-router-machine",

    title: "Production Details Of 4 Axis ATC CNC Router Machine",
    titleAr: "تفاصيل إنتاج ماكينة راوتر CNC رباعية المحاور ATC",

    desc:
      "The 4-axis ATC CNC router with a tilting spindle offers advanced machining for complex angles, deep 3D carving, and multi-surface processing.",
    descAr:
      "ماكينة 4 محاور ATC المزودة بسبندل مائل توفر قدرات تشغيل متقدمة للزوايا المعقدة، النحت ثلاثي الأبعاد العميق، والمعالجة متعددة الأسطح.",

    details: {
      keyFeatures: [
        {
          title: "Tilting Spindle 4-Axis",
          titleAr: "سبندل مائل رباعي المحاور",

          points: [
            "Angled cutting",
            "Beveled edges",
            "Undercuts",
            "Deep 3D surface machining",
            "Multi-face machining without flipping the material",
            "Perfect for complex 3D molds and patterns"
          ],
          pointsAr: [
            "قص بزاويا مختلفة",
            "حواف مائلة",
            "انحدارات Undercuts",
            "نحت ثلاثي الأبعاد عميق",
            "تشغيل متعدد الأسطح بدون قلب المادة",
            "مثالية للقوالب المعقدة والنماذج ثلاثية الأبعاد"
          ]
        },

        {
          title: "Automatic Tool Changer (ATC)",
          titleAr: "نظام تغيير الأدوات الأوتوماتيكي (ATC)",

          points: [
            "6 / 8 / 12-tool magazine options",
            "Fast, precise tool switching",
            "Ideal for multi-step 3D jobs",
            "Reduces production time and operator labor"
          ],
          pointsAr: [
            "خيارات مخزن أدوات: 6 / 8 / 12 أدوات",
            "تبديل سريع ودقيق",
            "مثالي للأعمال متعددة المراحل",
            "تقليل زمن التشغيل وجهد العامل"
          ]
        },

        {
          title: "High-Performance Tilting Spindle",
          titleAr: "سبندل عالي الأداء قابل للميلان",

          points: [
            "9kW / 12kW spindle options",
            "0–24000 RPM",
            "Stable during angled operations",
            "Suitable for long production hours"
          ],
          pointsAr: [
            "خيارات سبندل: 9kW أو 12kW",
            "سرعة حتى 24,000 RPM",
            "ثبات ممتاز أثناء القص المائل",
            "مناسب للتشغيل الاحترافي لساعات طويلة"
          ]
        },

        {
          title: "Heavy-Duty Industrial Structure",
          titleAr: "هيكل صناعي قوي",

          points: [
            "Thick welded steel frame",
            "Reinforced gantry for tilting torque",
            "HIWIN linear guides",
            "Helical rack & pinion on X/Y",
            "Ball screw Z-axis for high precision"
          ],
          pointsAr: [
            "هيكل فولاذي سميك ملحوم",
            "جسر مُدعّم لتحمل عزم الميلان",
            "سكاك HIWIN عالية الجودة",
            "رف وترس حلزوني لمحوري X/Y",
            "لولب كروي لمحور Z لضمان أعلى دقة"
          ]
        },

        {
          title: "Advanced 4-Axis Controller",
          titleAr: "نظام تحكم متطور لأربعة محاور",

          points: [
            "Supports 4-axis interpolation",
            "3D & multi-surface machining",
            "Automatic tool calibration",
            "Smooth motion control"
          ],
          pointsAr: [
            "دعم تشغيل 4 محاور حقيقي",
            "معالجة ثلاثية الأبعاد ومتعددة الأسطح",
            "معايرة أوتوماتيكية للأدوات",
            "تحكم حركة ناعم وثابت"
          ],

          controllers: ["Syntec", "NcStudio 4-axis", "RichAuto 4-axis", "Osai (optional)"],
          controllersAr: ["Syntec", "NcStudio", "RichAuto", "Osai (اختياري)"]
        }
      ],

      workingArea: ["1500×3500 mm", "2000×4000 mm", "2000×6000 mm"],
      workingAreaAr: ["1500×3500 مم", "2000×4000 مم", "2000×6000 مم"],

      applications: [
        {
          category: "3D Carving & Artistic Woodwork",
          categoryAr: "النحت ثلاثي الأبعاد والأعمال الفنية",

          items: [
            "Deep 3D sculptures",
            "Complex reliefs",
            "Curved surface carving",
            "Artistic elements"
          ],
          itemsAr: [
            "نحت 3D عميق",
            "ريليفات معقدة",
            "نحت أسطح منحنية",
            "عناصر فنية"
          ]
        },

        {
          category: "Mold Making",
          categoryAr: "تصنيع القوالب",

          items: ["Foam molds", "Wooden molds", "Prototypes", "Casting patterns"],
          itemsAr: ["قوالب فوم", "قوالب خشب", "نماذج أولية", "أنماط صب"]
        },

        {
          category: "Furniture Manufacturing",
          categoryAr: "تصنيع الأثاث",

          items: ["Curved chair legs", "Slanted surfaces", "Decorative angles", "Multi-level panels"],
          itemsAr: [
            "أرجل كراسي منحنية",
            "أسطح مائلة",
            "زوايا ديكورية",
            "ألواح متعددة المستويات"
          ]
        },

        {
          category: "Architectural & Interior Design",
          categoryAr: "العمارة والديكور الداخلي",

          items: ["Curved CNC panels", "Complex ceilings", "Column bases", "3D wall panels"],
          itemsAr: [
            "ألواح CNC منحنية",
            "أسقف معمارية معقدة",
            "قواعد أعمدة",
            "ألواح حائط ثلاثية الأبعاد"
          ]
        },

        {
          category: "Advertising & Acrylic Work",
          categoryAr: "الإعلانات والأكريليك",

          items: ["Angled acrylic cuts", "3D signage", "Deep engraving"],
          itemsAr: ["قص أكريليك بزاويا", "لافتات ثلاثية الأبعاد", "حفر عميق"]
        }
      ],

      advantages: [
        "4-axis tilting spindle for advanced geometry",
        "No manual flipping required",
        "More accuracy than rotary tables",
        "ATC system increases productivity",
        "Ideal for large 3D & multi-surface jobs",
        "Works with wood, MDF, foam, plastics, and some aluminum"
      ],
      advantagesAr: [
        "محور رابع حقيقي للميلان",
        "لا حاجة لقلب المادة",
        "دقة أعلى من المحور الدوّار",
        "إنتاجية أعلى بفضل ATC",
        "مثالية للأعمال ثلاثية الأبعاد المعقدة",
        "تعمل على الخشب، MDF، الفوم، البلاستيك وبعض الألومنيوم"
      ]
    }
  },

  {
    id: 7,
    name: "Multi-Spindle CNC Router",
    nameAr: "ماكينة راوتر CNC متعددة رؤوس القطع",
    rate: 0,

    overview:
      "High-efficiency CNC router designed for mass production, allowing multiple spindles to operate simultaneously for maximum workflow output.",
    overviewAr:
      "إنتاجية عالية وتشغيل جماعي في نفس الوقت. ماكينة Multi-Spindle CNC Router مصممة لخطوط الإنتاج التي تحتاج سرعة، جودة ثابتة، وقدرة على تشغيل عدة قطع في ضربة واحدة. وجود عدة سبندلات تعمل بالتزامن يرفع الإنتاجية بشكل كبير ويقلل الوقت والتكلفة، مما يجعلها مثالية لمصانع الأثاث، الورش، والمصانع التي تعتمد على التشغيل الكمي.",

    image: "/products/Multi-Spindle CNC Router.jfif",
    image_small: "/products/Multi-Spindle CNC Router.jfif",
    slug: "multi-spindle-cnc-router",

    title: "Production Process Of Multi-Spindle CNC Router",
    titleAr: "تفاصيل إنتاج ماكينة راوتر CNC متعددة رؤوس القطع",

    desc:
      "The Multi-Spindle CNC Router is built for mass production, with multiple spindles working simultaneously for maximum efficiency and output.",
    descAr:
      "ماكينة Multi-Spindle CNC Router مخصصة للإنتاج الكمي، حيث تعمل عدة سبندلات في نفس الوقت لتحقيق أعلى كفاءة وأعلى إنتاجية.",

    details: {
      keyFeatures: [
        {
          title: "Multiple Spindles Working Simultaneously",
          titleAr: "عدة سبندلات تعمل بالتزامن",

          points: [
            "Available in 2, 3, 4, or 6 spindles",
            "Machine multiple identical parts at once",
            "Increase output by 2×–6×",
            "Highly efficient for batch manufacturing"
          ],
          pointsAr: [
            "تتوفر بتكوينات 2 / 3 / 4 / 6 سبندلات",
            "تشغيل عدة قطع في نفس اللحظة",
            "زيادة الإنتاجية من 2× إلى 6×",
            "فعالة جداً في التشغيل الكمي"
          ]
        },

        {
          title: "Powerful High-Speed Spindles",
          titleAr: "سبندلات قوية وعالية السرعة",

          points: [
            "1.5kW / 2.2kW / 3.2kW / 4.5kW options",
            "Air-cooled or water-cooled",
            "Reliable performance for long operation hours",
            "Suitable for wood, MDF, acrylic, PVC, foam, soft aluminum"
          ],
          pointsAr: [
            "خيارات سبندل: 1.5kW / 2.2kW / 3.2kW / 4.5kW",
            "تبريد هوائي أو مائي",
            "أداء ثابت لساعات تشغيل طويلة",
            "مناسبة للخشب، MDF، الأكريليك، PVC، الفوم، والألمنيوم الخفيف"
          ]
        },

        {
          title: "Rigid Heavy-Duty Structure",
          titleAr: "هيكل صناعي ثقيل",

          points: [
            "Thick steel welded frame",
            "Reinforced gantry",
            "Vibration-free operation",
            "Long-term accuracy during continuous production"
          ],
          pointsAr: [
            "شاسيه فولاذي سميك",
            "جسر مقوى",
            "تشغيل بدون اهتزاز",
            "دقة طويلة المدى حتى مع التشغيل المستمر"
          ]
        },

        {
          title: "High-Precision Transmission System",
          titleAr: "نظام حركة عالي الدقة",

          points: [
            "HIWIN linear guide rails",
            "Ball screw Z-axis",
            "Rack & pinion motion for X/Y",
            "Repeatability ±0.03mm"
          ],
          pointsAr: [
            "سكك HIWIN",
            "لولب كروي لمحور Z",
            "رف وترس لمحوري X/Y",
            "دقة تكرارية ±0.03 مم"
          ]
        },

        {
          title: "Multiple Working Modes",
          titleAr: "وضعيات تشغيل متعددة",

          points: [
            "Synchronized Mode: all spindles work together",
            "Independent Mode (optional): each spindle works separately",
            "Perfect for switching between bulk and custom production"
          ],
          pointsAr: [
            "وضع التزامن: كل السبندلات تعمل نفس الشغل",
            "وضع مستقل (اختياري): كل سبندل يعمل على تصميم مختلف",
            "مثالية للجمع بين الإنتاج الكمي والتشغيل المتنوع"
          ]
        },

        {
          title: "Advanced CNC Controller",
          titleAr: "كنترول متطور",

          points: [
            "Supports RichAuto, NcStudio, Mach3/4, Syntec",
            "Multi-spindle synchronization",
            "Fast data processing",
            "Smooth motion control"
          ],
          pointsAr: [
            "يدعم RichAuto – NcStudio – Mach3 – Syntec",
            "تزامن السبندلات",
            "معالجة بيانات عالية السرعة",
            "تحكم ناعم بالحركة"
          ]
        },

        {
          title: "Vacuum Table & T-Slot Bed",
          titleAr: "سرير تفريغ وفتحات T-Slot",

          points: [
            "Strong suction for batch production",
            "Securely holds multiple sheets",
            "Reduces vibration for cleaner results"
          ],
          pointsAr: [
            "شفط قوي للتشغيل الجماعي",
            "يثبت عدة ألواح في نفس الوقت",
            "يقلل الاهتزاز للحصول على تشطيب أنظف"
          ]
        }
      ],

      workingArea: [
        "1300×2500 mm",
        "1500×3500 mm",
        "2000×4000 mm",
        "2000×6000 mm"
      ],
      workingAreaAr: [
        "1300×2500 مم",
        "1500×3500 مم",
        "2000×4000 مم",
        "2000×6000 مم"
      ],

      applications: [
        {
          category: "Furniture Manufacturing",
          categoryAr: "تصنيع الأثاث",

          items: ["Cabinet doors", "MDF panels", "Decorative pieces", "Chairs, tables"],
          itemsAr: ["أبواب خزائن", "ألواح MDF", "ديكورات خشبية", "كراسي وطاولات"]
        },

        {
          category: "Woodworking & Carving",
          categoryAr: "الحفر والديكور",

          items: ["Relief carving", "Pattern duplication", "Artistic panels", "Batch parts"],
          itemsAr: ["ريليفات", "تكرار نماذج", "ألواح فنية", "قطع خشبية متكررة"]
        },

        {
          category: "Sign-Making",
          categoryAr: "اللوحات الإعلانية",

          items: ["3D letters", "Acrylic signs", "PVC cutting", "Foam designs"],
          itemsAr: ["حروف ثلاثية الأبعاد", "لوحات أكريليك", "قص PVC", "أعمال فوم"]
        },

        {
          category: "Interior Decoration",
          categoryAr: "الديكور الداخلي",

          items: ["Wall panels", "Partitions", "Ceilings", "Custom engravings"],
          itemsAr: ["ألواح حائط", "فواصل", "تصاميم الأسقف", "حفر مخصص"]
        },

        {
          category: "Mass Production Workshops",
          categoryAr: "ورش الإنتاج الكمي",

          items: ["Identical pieces", "Commercial orders", "Batch machining"],
          itemsAr: ["قطع متطابقة", "طلبيات تجارية كبيرة", "تشغيل كمي"]
        }
      ],

      advantages: [
        "2–6× higher productivity",
        "Uniform quality",
        "Lower labor cost",
        "Perfect for bulk manufacturing",
        "Strong spindle performance",
        "Stable structure",
        "Easy to operate"
      ],
      advantagesAr: [
        "إنتاجية أعلى من 2× إلى 6×",
        "جودة ثابتة بين كل القطع",
        "تكلفة تشغيل أقل",
        "مناسب للطلبيات الكبيرة",
        "سبندلات قوية",
        "هيكل مستقر ودقيق",
        "سهل التشغيل والصيانة"
      ]
    },

    TitleTag: "Multi-Spindle CNC Router Machine | High-Production CNC",
    MetaDescription:
      "High-efficiency multi-spindle CNC router for mass production, furniture manufacturing, woodworking, acrylic cutting, and batch processing with 2–6 synchronized spindles.",
    Keywords:
      "multi spindle cnc router, multi head cnc, batch cnc machining, woodworking cnc, furniture cnc machine",

    SEOContent: ""
  },

  {
    id: 8,
    name: "Multi-Process CNC Router",
    nameAr: "ماكينة راوتر CNC متعددة العمليات",
    rate: 0,

    image: "/products/Multi-Process CNC Router.jfif",
    image_small: "/products/Multi-Process CNC Router.jfif",
    slug: "multi-process-cnc-router",

    title: "Production Process Of Multi-Process CNC Router",
    titleAr: "تفاصيل إنتاج ماكينة راوتر CNC متعددة العمليات",

    desc: "The Multi-Process CNC Router uses several independent spindles, each carrying a different tool, allowing fast multi-step machining with zero downtime.",
    descAr:
      "ماكينة Multi-Process CNC Router تحتوي على عدة سبندلات مستقلة، كل سبندل يحمل أداة مختلفة، مما يسمح بتنفيذ عدة خطوات في نفس التشغيل بدون توقف أو وقت ضائع.",

    overview: `
High-Speed Production with Multiple Tools Ready at the Same Time

The Multi-Process CNC Router is designed for high-efficiency workshops and factories that require continuous production without delays caused by manual tool changes.
Each spindle holds a different tool (bit), enabling the machine to switch operations automatically by shifting to the correct spindle—without any ATC system.
This makes it ideal for high-volume woodworking, furniture manufacturing, panel cutting, engraving, and decorative CNC projects.
`,
    overviewAr: `
إنتاج عالي السرعة مع عدة أدوات جاهزة في نفس الوقت

ماكينة Multi-Process CNC Router مصممة للورش والمصانع التي تحتاج تشغيل مستمر بدون فقد وقت نتيجة تبديل الأدوات اليدوي.
كل سبندل يحمل أداة مختلفة، مما يسمح للجهاز بالانتقال تلقائياً لأداة معينة بدون نظام ATC.
مثالية لورش الأثاث، الديكور، تقطيع الألواح، الحفر، والزخارف.
`,

    details: {
      keyFeatures: [
        {
          title: "3 or 4 Independent Spindles",
          titleAr: "3 أو 4 سبندلات مستقلة",

          points: [
            "Each spindle carries a different tool",
            "Common tools: end mill, V-bit, ball nose, engraving bit, drill bit",
            "Allows multiple operations in a single setup",
            "No need to stop the machine to change tools"
          ],
          pointsAr: [
            "كل سبندل يحمل أداة مختلفة",
            "أدوات شائعة: End mill – V-bit – Ball nose – ريشة نقش – ريشة حفر",
            "يسمح بتنفيذ عدة عمليات في نفس التجهيز",
            "بدون الحاجة لإيقاف الجهاز لتغيير الأداة"
          ]
        },

        {
          title: "Sequential Automatic Tool Switching",
          titleAr: "تبديل أدوات أوتوماتيكي بالتسلسل",

          points: [
            "Machine automatically shifts to the required spindle",
            "No ATC mechanism required",
            "Much faster than manual tool changes",
            "Zero downtime between machining steps"
          ],
          pointsAr: [
            "الجهاز ينتقل للسبندل المطلوب تلقائيًا",
            "لا يحتاج نظام ATC",
            "أسرع بكثير من التبديل اليدوي",
            "صفر وقت ضائع بين خطوات التشغيل"
          ]
        },

        {
          title: "High-Speed Air-Cooled Spindles",
          titleAr: "سبندلات عالية السرعة ومبردة بالهواء",

          points: [
            "4.5kW / 6kW spindle options",
            "18,000 to 24,000 RPM",
            "Very reliable for long production cycles",
            "Independent spindle control available"
          ],
          pointsAr: [
            "خيارات سبندل 4.5kW أو 6kW",
            "18,000 إلى 24,000 RPM",
            "ثابتة ومناسبة للتشغيل الطويل",
            "تحكم مستقل للسبندلات"
          ]
        },

        {
          title: "Perfect for Mass Production",
          titleAr: "مناسبة للإنتاج الكمي",

          points: [
            "Significantly faster cycle times",
            "Reduces operator workload",
            "Consistent quality across large batches",
            "Widely used in furniture and woodworking factories"
          ],
          pointsAr: [
            "وقت دورة أسرع بكثير",
            "تقلل مجهود المشغل",
            "جودة ثابتة عبر التشغيل الكبير",
            "تستخدم بشكل واسع في مصانع الأثاث والأخشاب"
          ]
        },

        {
          title: "Heavy-Duty Industrial Structure",
          titleAr: "هيكل صناعي قوي",

          points: [
            "Steel-welded machine frame",
            "HIWIN linear guide rails",
            "Rack & pinion transmission on X/Y",
            "Ball screw Z-axis for high precision",
            "Long service life and stable performance"
          ],
          pointsAr: [
            "هيكل فولاذي ملحوم",
            "سكك حركة HIWIN",
            "نظام رف وترس لمحوري X/Y",
            "لولب كروي لمحور Z بدقة عالية",
            "عمر طويل وأداء مستقر"
          ]
        }
      ],

      workingArea: ["1500×3500 mm", "2000×4000 mm", "2000×6000 mm"],
      workingAreaAr: ["1500×3500 مم", "2000×4000 مم", "2000×6000 مم"],

      applications: [
        {
          category: "Furniture Manufacturing",
          categoryAr: "تصنيع الأثاث",

          items: [
            "MDF doors",
            "Decorative wood panels",
            "3D designs",
            "Cabinet production",
            "Routing and engraving"
          ],
          itemsAr: [
            "أبواب MDF",
            "ألواح خشبية ديكورية",
            "تصميمات ثلاثية الأبعاد",
            "تصنيع الخزائن",
            "تفريز وحفر"
          ]
        },

        {
          category: "Wood Carving & Decoration",
          categoryAr: "النحت والديكور",

          items: ["2D and 3D relief", "Islamic patterns", "Frames and moldings", "Artistic decorative carving"],
          itemsAr: ["نحت 2D و3D", "نقوش إسلامية", "إطارات وقوالب", "نقوش فنية"]
        },

        {
          category: "Advertising Industry",
          categoryAr: "مجال الإعلانات",

          items: ["Acrylic letters", "PVC signage", "Foam board cutting", "Wooden advertising signs"],
          itemsAr: ["حروف أكريليك", "لوحات PVC", "قص الفوم", "لوحات إعلانية خشبية"]
        },

        {
          category: "Mass Production Jobs",
          categoryAr: "أعمال الإنتاج الكمي",

          items: ["Identical repeated parts", "Batch furniture components", "Large-scale engraving work"],
          itemsAr: ["قطع متطابقة", "مكونات أثاث تشغيل جماعي", "حفر على نطاق كبير"]
        }
      ],

      advantages: [
        "Multiple tools available instantly",
        "Perfect for multi-step machining",
        "Faster than manual tool changing",
        "More affordable than ATC CNC routers",
        "Reliable and ideal for continuous industrial production",
        "High accuracy and stable mechanical performance"
      ],
      advantagesAr: [
        "عدة أدوات جاهزة دائمًا",
        "مثالية للتشغيل متعدد الخطوات",
        "أسرع من تغيير الأدوات اليدوي",
        "أقل سعرًا من ماكينات ATC",
        "مثالية للتشغيل الصناعي المستمر",
        "دقة عالية وأداء ثابت"
      ]
    },

    TitleTag: "Multi-Process CNC Router | Multi-Tool Industrial CNC",
    MetaDescription:
      "High-efficiency Multi-Process CNC Router with 3 or 4 spindles for woodworking, furniture manufacturing, panel cutting, engraving, and mass production.",
    Keywords:
      "multi process cnc router, multi tool cnc, woodworking cnc machine, furniture cnc router, 4 spindle cnc",

    SEOContent: ""
  },

  {
    id: 9,
    name: "Stone CNC Router (Marble & Granite CNC)",
    nameAr: "ماكينة راوتر CNC للحجر (رخام / جرانيت)",
    rate: 0,
    image: "/products/Stone CNC Router.jfif",
    image_small: "/products/Stone CNC Router.jfif",
    slug: "stone-cnc-router",

    title: "Production Process Of Stone CNC Router",
    titleAr: "تفاصيل إنتاج ماكينة راوتر CNC للحجر",

    desc: "The Stone CNC Router is built for heavy-duty machining of marble, granite, quartz, and other dense materials with high accuracy and stability.",
    descAr:
      "ماكينة راوتر CNC للحجر مصممة خصيصًا لمعالجة الرخام والجرانيت والكوارتز والمواد الصلبة جدًا بدقة عالية وثبات كامل أثناء التشغيل.",

    overview: `
High-Strength CNC Machine for Marble, Granite, Quartz, and Solid Surface Processing
The Stone CNC Router is designed for powerful, accurate machining of extremely hard materials such as marble, granite, quartz, and artificial stone.
With its reinforced steel frame, water-cooled spindle, corrosion-resistant table, and heavy-load structure, it is ideal for stone fabrication factories, countertop workshops, monuments, and high-detail artistic engraving.
`,
    overviewAr: `
ماكينة قوية لمعالجة الرخام والجرانيت والكوارتز والحجر الصناعي
تم تصميم ماكينة راوتر CNC للحجر للتعامل مع أقسى وأصلب المواد مثل الرخام والجرانيت والكوارتز والحجر الصناعي بدقة عالية.
بفضل الشاسيه الفولاذي الثقيل والسبندل المبرد بالماء وصينية العمل المقاومة للصدأ، تعتبر مثالية لورش الرخام، تفصيل المطابخ والكاونترات، شواهد القبور، والنقش الفني عالي التفاصيل.
`,

    details: {
      keyFeatures: [
        {
          title: "Heavy-Duty Structure for Stone Processing",
          titleAr: "هيكل ثقيل جداً مناسب لمعالجة الحجر",

          points: [
            "Thick welded steel frame",
            "Reinforced gantry design",
            "High resistance to vibration",
            "Specially engineered for high-load cutting of hard stone",
            "Ensures accuracy even with deep, high-force cutting"
          ],
          pointsAr: [
            "شاسيه فولاذي سميك ملحوم",
            "جسر حركة مقوّى لتحمل الضغط العالي",
            "مقاومة عالية للاهتزاز أثناء القص",
            "مصمم خصيصًا للقص الثقيل للرخام والجرانيت",
            "ثبات عالي ودقة ممتازة حتى في القص العميق"
          ]
        },

        {
          title: "High-Power Water-Cooled Spindle",
          titleAr: "سبندل قوي بتبريد مائي",

          points: [
            "Available in 5.5kW / 7.5kW / 9kW / 11kW",
            "Ideal for cutting granite, marble, quartz, and stone surfaces",
            "Supports deep 3D carving and shaping",
            "Water cooling ensures stability during long machining cycles"
          ],
          pointsAr: [
            "قدرات سبندل 5.5kW / 7.5kW / 9kW / 11kW",
            "مثالي لقص الجرانيت والرخام والكوارتز",
            "يدعم نحت 3D عميق وتشكيل الحجر",
            "نظام تبريد مائي يمنع سخونة السبندل أثناء التشغيل الطويل"
          ]
        },

        {
          title: "Stainless Steel Water Tray & Cooling System",
          titleAr: "صينية ستانلس ونظام تبريد للمياه",

          points: [
            "Integrated stainless steel water tray",
            "Automatic water spray for wet cutting",
            "Corrosion-resistant working bed",
            "Efficient dust and chip removal",
            "Perfect for continuous stone cutting operations"
          ],
          pointsAr: [
            "صينية ستانلس ستيل ضد الصدأ",
            "رشاش مياه تلقائي للقص الرطب",
            "سرير عمل مقاوم للتآكل",
            "إزالة فعالة للغبار وبودرة الحجر",
            "مثالية للتشغيل المتواصل لأعمال الرخام"
          ]
        },

        {
          title: "Precision Motion System",
          titleAr: "نظام حركة عالي الدقة",

          points: [
            "HIWIN linear guide rails",
            "Helical rack and pinion for smooth motion",
            "High-torque stepper or servo motors",
            "Repeatability accuracy of ±0.05 mm",
            "Clean edge finishing and detailed carving"
          ],
          pointsAr: [
            "سكك حركة HIWIN عالية الجودة",
            "نظام رف وترس حلزوني لحركة أكثر سلاسة",
            "محركات عالية العزم (Stepper / Servo)",
            "دقة تكرار ±0.05 مم",
            "تشطيب حواف نظيف ونقش بتفاصيل عالية"
          ]
        },

        {
          title: "High-Load Working Table",
          titleAr: "سرير عمل يتحمل الأحمال الثقيلة",

          points: [
            "Heavy-duty stone table options",
            "Vacuum adsorption with clamps (optional)",
            "Anti-slip rubber pads",
            "Supports large stone slabs safely"
          ],
          pointsAr: [
            "سرير مخصص لتحمل ألواح الرخام والجرانيت الثقيلة",
            "نظام فاكيوم مع كلابات (اختياري)",
            "طبقات مطاطية مانعة للانزلاق",
            "يدعم الألواح الكبيرة بأمان كامل"
          ]
        },

        {
          title: "Industrial CNC Controller",
          titleAr: "وحدة تحكم CNC صناعية",

          points: [
            "Compatible with NcStudio, Weihong, Syntec, RichAuto",
            "Supports 3-axis and 4-axis machining",
            "Handles large 3D relief files smoothly",
            "Accurate curve motion control"
          ],
          pointsAr: [
            "متوافق مع NcStudio وWeihong وSyntec وRichAuto",
            "يدعم تشغيل 3 محاور و4 محاور",
            "تعامل ممتاز مع ملفات 3D كبيرة",
            "تحكم عالي الدقة في الحركات المنحنية"
          ]
        }
      ],

      workingArea: ["1500×3500 mm", "2000×4000 mm", "2000×6000 mm"],
      workingAreaAr: ["1500×3500 مم", "2000×4000 مم", "2000×6000 مم"],

      applications: [
        {
          category: "Marble & Granite Processing",
          categoryAr: "معالجة الرخام والجرانيت",

          items: [
            "Cutting and trimming",
            "Stone shaping",
            "Text and pattern engraving",
            "Edge polishing"
          ],
          itemsAr: [
            "قص وتقطيع الرخام والجرانيت",
            "تشكيل الحجر",
            "حفر النصوص والزخارف",
            "تلميع الحواف"
          ]
        },

        {
          category: "Kitchen & Bathroom Countertops",
          categoryAr: "مطابخ وسطحيات",

          items: [
            "Sink cutouts",
            "Countertop edge shaping",
            "Drilling faucet holes",
            "Custom countertop designs"
          ],
          itemsAr: [
            "تفريغ فتحة الحوض",
            "تشكيل حواف السطح",
            "حفر فتحات الخلاطات",
            "تصميمات مخصصة لأسطح المطابخ"
          ]
        },

        {
          category: "Monuments & Tombstones",
          categoryAr: "شواهد وقبور",

          items: [
            "Text engraving",
            "Deep 3D carving",
            "Portrait engraving on stone",
            "Decorative reliefs"
          ],
          itemsAr: [
            "حفر النصوص",
            "نحت ثلاثي الأبعاد عميق",
            "نقش الصور على الحجر",
            "نقوش وزخارف تذكارية"
          ]
        },

        {
          category: "Building Decoration",
          categoryAr: "الديكور المعماري",

          items: ["Floor medallions", "Wall stone art panels", "Mosaic patterns", "Columns and capitals"],
          itemsAr: ["مدليات أرضيات", "ألواح فنية حجرية", "زخارف موزاييك", "أعمدة وتيجان"]
        },

        {
          category: "Artistic Stone Carving",
          categoryAr: "أعمال فنية حجرية",

          items: ["3D sculptures", "Complex stone artworks", "Custom engraving"],
          itemsAr: ["تماثيل ثلاثية الأبعاد", "أعمال فنية حجرية معقدة", "نقوش مخصصة"]
        },

        {
          category: "Quartz & Artificial Stone",
          categoryAr: "كوارتز وحجر صناعي",

          items: ["Countertop machining", "Slotting and drilling", "Edge finishing and shaping"],
          itemsAr: ["تشغيل السطحيات", "فتح مجاري وحفر", "تشطيب وتشكيل الحواف"]
        }
      ],

      advantages: [
        "Engineered specifically for hard stone machining",
        "Extremely rigid structure with minimal vibration",
        "High-power spindle allows deep and fast stone cutting",
        "Excellent accuracy and clean surface finishing",
        "Long service life with industrial reliability",
        "Fully compatible with wet cutting systems",
        "Ideal for heavy-duty stone workshops"
      ],
      advantagesAr: [
        "مصممة خصيصًا لمعالجة الحجر الصلب",
        "هيكل شديد الصلابة مع اهتزاز شبه معدوم",
        "سبندل قوي يدعم القص العميق والسريع",
        "دقة عالية وتشطيب نظيف",
        "عمر تشغيل طويل وأداء صناعي ثابت",
        "متوافقة بالكامل مع أنظمة القص الرطب",
        "مثالية للورش عالية الأحمال"
      ]
    },

    TitleTag: "Stone CNC Router | Marble & Granite CNC Machine",
    MetaDescription:
      "Heavy-duty Stone CNC Router for marble, granite, and quartz cutting, shaping, engraving, and countertop fabrication. High-power spindle and industrial accuracy.",
    Keywords:
      "stone cnc router, marble cnc machine, granite cnc, quartz cnc cutting, stone engraving machine",

    SEOContent: ""
  },

  {
    id: 10,
    name: "Aluminum CNC Router",
    nameAr: "ماكينة راوتر CNC للألمنيوم",
    image: "",
    slug: "aluminum-cnc-router",
    title: "Production Process Of Aluminum CNC Router",
    titleAr: "تفاصيل إنتاج ماكينة راوتر CNC للألمنيوم",
    rate: 0,

    desc: "The Aluminum CNC Router is built for high-speed, high-accuracy milling, cutting, drilling, and engraving of aluminum and other non-ferrous materials.",
    descAr:
      "ماكينة راوتر CNC للألمنيوم مصممة خصيصًا لقص وتفريز الألمنيوم والمعادن غير الحديدية بدقة عالية وثبات ممتاز وتشطيب ناعم جداً، مما يجعلها مثالية للمصانع الهندسية والصناعات الدقيقة.",

    overview:
      "High-Speed, High-Accuracy Routing for Aluminum & Non-Ferrous Metals The Aluminum CNC Router is engineered for industrial manufacturing and precision engineering. With reinforced structure, precision linear guides, and high-speed spindle, it provides smooth cutting, tight tolerances, and excellent surface finish for aluminum, copper, brass, and other non-ferrous metals.",
    overviewAr:
      "ماكينة عالية السرعة والدقة لمعالجة الألمنيوم والمعادن غير الحديدية. تم تصميم ماكينة راوتر CNC للألمنيوم خصيصًا للتصنيع الصناعي والهندسة الدقيقة. بفضل الهيكل المقوى، نظام الحركة عالي الدقة، والسبندل عالي السرعة، توفر الآلة قصًا ناعمًا، تشطيبًا ممتازًا، وثباتًا كبيرًا أثناء العمل على الألمنيوم والنحاس والبرونز وغيرها من المعادن غير الحديدية.",

    details: {
      keyFeatures: [
        {
          title: "High-Speed Spindle for Aluminum Processing",
          titleAr: "سبندل عالي السرعة مخصص لمعالجة الألمنيوم",
          points: [
            "Powerful spindle (3.2kW – 9kW)",
            "Clean cutting of aluminum without burrs",
            "Stable temperature during long operation",
            "Mirror-like surface finishing",
            "Optional air-cooled or water-cooled configurations"
          ],
          pointsAr: [
            "سبندل قوي بقدرات من 3.2kW حتى 9kW",
            "قص نظيف بدون نتوءات",
            "درجة حرارة ثابتة أثناء التشغيل الطويل",
            "تشطيب ناعم للغاية يشبه المرآة",
            "خيارات تبريد هوائي أو مائي"
          ]
        },

        {
          title: "Rigid Machine Body for Vibration-Free Operation",
          titleAr: "هيكل صناعي صلب لمنع الاهتزاز",
          points: [
            "Heavy-duty welded steel frame",
            "Stress-relief treatment for stability",
            "Thickened gantry structure",
            "Ensures precise cuts on aluminum, copper, brass, and plastics"
          ],
          pointsAr: [
            "إطار فولاذي ملحوم ثقيل",
            "معالجة حرارية لتخفيف الإجهاد وزيادة الثبات",
            "هيكل جسر مقوّى",
            "يضمن دقة عالية عند قص الألمنيوم والنحاس والبرونز والبلاستيك"
          ]
        },

        {
          title: "Precision Linear Guides & Ball Screws",
          titleAr: "سكك خطية ولوالب كروية عالية الدقة",
          points: [
            "Hiwin/TBI ball screws",
            "Linear guide rails for smooth movement",
            "Repeatability up to ±0.02mm",
            "Zero backlash for high-precision machining"
          ],
          pointsAr: [
            "لوالب كروية Hiwin/TBI",
            "سكك خطية لحركة سلسة جدًا",
            "دقة تكرار تصل إلى ±0.02 مم",
            "بدون Backlash للحصول على أعلى دقة"
          ]
        },

        {
          title: "Mist Cooling / Lubrication System",
          titleAr: "نظام تبريد ضبابي (Mist Cooling)",
          points: [
            "Reduces heat during aluminum milling",
            "Improves tool life",
            "Ensures clean cutting edges",
            "Prevents chip welding"
          ],
          pointsAr: [
            "يقلل السخونة أثناء التفريز",
            "يطيل عمر أدوات القطع",
            "يحافظ على حواف قطع نظيفة",
            "يمنع التصاق الشُراد بالأداة"
          ]
        },

        {
          title: "Vacuum Table & Strong Suction",
          titleAr: "طاولة شفط قوية لتثبيت الألواح",
          points: [
            "Holds aluminum sheets firmly",
            "Prevents vibration",
            "Supports full-sheet operations",
            "Optional T-slot + vacuum hybrid table"
          ],
          pointsAr: [
            "تثبيت قوي لألواح الألمنيوم",
            "يمنع الاهتزاز أثناء القص",
            "يدعم تشغيل ألواح كاملة",
            "طاولة هجينة T-Slot + فاكيوم (اختياري)"
          ]
        },

        {
          title: "DSP or Industrial CNC Controller",
          titleAr: "وحدة تحكم CNC صناعية",
          points: [
            "Compatible with NcStudio, Syntec, RichAuto, Mach3/Mach4",
            "Supports multi-layer machining",
            "High-speed interpolation",
            "Handles large files and smooth curves"
          ],
          pointsAr: [
            "متوافق مع NcStudio وSyntec وRichAuto وMach3/Mach4",
            "يدعم تشغيل الطبقات المتعددة",
            "حركة Interpolation عالية السرعة",
            "تعامل ممتاز مع الملفات الكبيرة والمنحنيات الناعمة"
          ]
        }
      ],

      workingArea: ["1500×3500 mm", "2000×4000 mm", "2000×6000 mm"],
      workingAreaAr: ["1500×3500 مم", "2000×4000 مم", "2000×6000 مم"],

      applications: [
        {
          category: "Aluminum Sheet Cutting & Engraving",
          categoryAr: "قص وتفريغ ألواح الألمنيوم",
          items: ["Signage", "Decorative panels", "Machine covers"],
          itemsAr: ["لافتات", "ألواح ديكور", "أغلفة ماكينات"]
        },
        {
          category: "Industrial Aluminum Parts",
          categoryAr: "قطع ألومنيوم هندسية",
          items: ["Brackets", "Fixtures", "Aerospace components", "Automotive prototypes"],
          itemsAr: ["حاملات", "تجميعات", "مكونات طيران", "نماذج سيارات تجريبية"]
        },
        {
          category: "Mold Making",
          categoryAr: "صناعة القوالب",
          items: ["Soft aluminum molds", "Casting patterns", "Temperature-control channels"],
          itemsAr: ["قوالب ألمنيوم خفيف", "نماذج صب", "قنوات تبريد"]
        },
        {
          category: "Electronics & Enclosures",
          categoryAr: "صناعات إلكترونية وغلافات",
          items: ["Aluminum housings", "Heat sinks", "Controller boxes"],
          itemsAr: ["هياكل ألمنيوم", "مشتتات حرارة", "صناديق التحكم"]
        },
        {
          category: "Mechanical Prototyping",
          categoryAr: "نماذج صناعية",
          items: ["Custom parts", "Engineering samples", "R&D components"],
          itemsAr: ["قطع مخصصة", "نماذج هندسية", "مكونات R&D"]
        },
        {
          category: "Non-Ferrous Metal Machining",
          categoryAr: "تشغيل المعادن غير الحديدية",
          items: ["Copper", "Brass", "Composite materials", "Plastics & Acrylic"],
          itemsAr: ["نحاس", "برونز", "مواد مركبة", "بلاستيك وأكريليك"]
        }
      ],

      advantages: [
        "Extremely high accuracy",
        "Smooth finishing on aluminum",
        "High-speed cutting without vibration",
        "Long tool life thanks to cooling system",
        "Easy to operate and maintain"
      ],
      advantagesAr: [
        "دقة عالية جدًا",
        "تشطيب ناعم على الألمنيوم",
        "قص سريع بدون اهتزاز",
        "عمر طويل لأدوات القطع بفضل التبريد",
        "سهلة التشغيل والصيانة"
      ]
    },

    TitleTag: "Aluminum CNC Router | High-Precision Aluminum Cutting Machine",
    MetaDescription:
      "High-speed, high-accuracy Aluminum CNC Router for machining aluminum, copper, brass, and non-ferrous metals with excellent surface finishing.",
    Keywords: "aluminum cnc router, aluminum cutting machine, cnc for aluminum, aluminum machining",
    SEOContent: ""
  },

  {
    id: 11,
    name: "CO₂ Laser Cutting & Engraving Machine",
    nameAr: "ماكينة ليزر CO₂ للقص والحفر",
    image: "/../products/co2-550x750.png",
    image_small: "/../products/co2-350x370.png",
    slug: "co2-laser-cutting-engraving-machine",
    video: "/../products/co2 video.mp4",
    rate: 5,
    reviews: [
      {
        id: 3,
        userName: "",
        rating: 5,
        comment: "Excellent machine. Clean cutting edges and very accurate engraving results.",
        createdAt: "Jul 2026"
      },
      {
        id: 4,
        userName: "محمد الشهري",
        rating: 5,
        comment: "استخدمناها في ورشة الأكريليك والنتائج كانت أفضل من المتوقع.",
        createdAt: "Jun 2026"
      },
      {
        id: 5,
        userName: "",
        rating: 4,
        comment: "Good value for the price. Installation was easy and performance is reliable.",
        createdAt: "Jun 2026"
      },
      {
        id: 6,
        userName: "Sarah Johnson",
        rating: 5,
        comment: "Very impressed with the engraving quality. Works perfectly on wood and acrylic.",
        createdAt: "Jun 2026"
      },
      {
        id: 7,
        userName: "خالد المطيري",
        rating: 5,
        comment: "الماكينة قوية وسريعة، وجودة التصنيع ممتازة. أنصح بها لأصحاب المشاريع.",
        createdAt: "May 2026"
      },
      {
        id: 8,
        userName: "",
        rating: 5,
        comment: "Fast shipping, great packaging, and the machine worked perfectly out of the box.",
        createdAt: "May 2026"
      },
      {
        id: 9,
        userName: "Emily Carter",
        rating: 5,
        comment: "Accurate cutting, smooth operation, and excellent customer support.",
        createdAt: "May 2026"
      },
      {
        id: 10,
        userName: "سعود الحربي",
        rating: 5,
        comment: "جربناها على الخشب والجلد والأكريليك وكانت النتائج احترافية.",
        createdAt: "Apr 2026"
      },
      {
        id: 11,
        userName: "",
        rating: 4,
        comment: "Reliable machine with consistent cutting quality. Highly recommended.",
        createdAt: "Apr 2026"
      },
      {
        id: 12,
        userName: "Michael Brown",
        rating: 5,
        comment: "Easy to operate, powerful laser, and very precise engraving details.",
        createdAt: "Apr 2026"
      },
      {
        id: 13,
        userName: "ناصر الدوسري",
        rating: 5,
        comment: "بعد عدة أشهر من الاستخدام ما زالت تعمل بكفاءة عالية دون أي مشاكل.",
        createdAt: "Mar 2026"
      },
      {
        id: 14,
        userName: "",
        rating: 5,
        comment: "Amazing performance and excellent build quality. Worth every penny.",
        createdAt: "Mar 2026"
      },
      {
        id: 15,
        userName: "Ahmed Alotaibi",
        rating: 5,
        comment: "Perfect for our production line. Stable performance and clean engraving every time.",
        createdAt: "Feb 2026"
      }
    ],

    title: "CO₂ Laser Cutting & Engraving Machine",
    titleAr: "ماكينة ليزر CO₂ للقص والحفر",

    desc:
      "A high-precision CO₂ laser machine designed for fast, clean cutting and engraving on wood, acrylic, MDF, leather, fabric, rubber, and various non-metal materials.",
    descAr:
      "ماكينة ليزر CO₂ عالية الدقة مخصصة للقص والنقش السريع والنظيف على الخشب، الأكريليك، الـMDF، الجلد، القماش، المطاط، وغيرها من المواد غير المعدنية.",

    overview:
      "High-Precision Laser Cutting & Engraving for Wood, Acrylic, Leather, MDF & More. The CO₂ Laser Cutting & Engraving Machine is engineered for professional production, offering clean edges, high detail, smooth engraving, and stable performance for signage, crafts, décor, packaging, and industrial applications.",
    overviewAr:
      "قص ونقش ليزري عالي الدقة على الخشب، الأكريليك، الجلد، الـMDF، وغيرها. تم تصميم ماكينة ليزر CO₂ لتوفير حواف نظيفة، تفاصيل دقيقة، ونقش سلس يناسب الإعلانات، الحرف اليدوية، الديكور، التغليف، والاستخدامات الصناعية مع أداء ثابت وجودة ممتازة.",

    details: {
      keyFeatures: [
        {
          title: "High-Speed Cutting & Engraving",
          titleAr: "قص ونقش عالي السرعة",
          points: [
            "CO₂ laser tube (60W–500W)",
            "Fast, polished-edge cutting",
            "Ideal for detailed engraving",
            "Stable performance for long shifts"
          ],
          pointsAr: [
            "أنبوب ليزر CO₂ بقدرات من 60W حتى 500W",
            "قص سريع بحواف مصقولة",
            "مثالية للنقش التفصيلي",
            "أداء ثابت خلال ساعات العمل الطويلة"
          ]
        },

        {
          title: "Supports a Wide Range of Materials",
          titleAr: "يدعم مجموعة واسعة من المواد",
          points: [
            "Acrylic",
            "MDF & Wood",
            "Leather",
            "Fabric",
            "Rubber",
            "Plastic",
            "Paper & Cardboard",
            "Glass (surface engraving)"
          ],
          pointsAr: [
            "الأكريليك",
            "الخشب والـMDF",
            "الجلد",
            "القماش",
            "المطاط",
            "البلاستيك",
            "الورق والكرتون",
            "الزجاج (نقش سطحي)"
          ]
        },

        {
          title: "High-Precision Motion System",
          titleAr: "نظام حركة عالي الدقة",
          points: [
            "Stable guide rails",
            "Accurate positioning",
            "Smooth and clean cutting lines",
            "Consistent results on all materials"
          ],
          pointsAr: [
            "سكك توجيه مستقرة",
            "دقة عالية في التمركز",
            "خطوط قص نظيفة وسلسة",
            "نتائج ثابتة على جميع المواد"
          ]
        },

        {
          title: "Large Working Area Options",
          titleAr: "خيارات مساحات عمل مختلفة",
          points: [
            "40×30 cm",
            "60×40 cm",
            "90×60 cm",
            "100×160 cm",
            "130×90 cm",
            "130×180 cm",
            "Customizable sizes"
          ],
          pointsAr: [
            "40×30 سم",
            "60×40 سم",
            "90×60 سم",
            "100×160 سم",
            "130×90 سم",
            "130×180 سم",
            "مقاسات مخصصة حسب الطلب"
          ]
        },

        {
          title: "User-Friendly Control Software",
          titleAr: "برنامج تشغيل سهل الاستخدام",
          points: [
            "Compatible with RDWorks",
            "Supports LightBurn",
            "CorelDRAW plug-ins",
            "Vector cutting & raster engraving",
            "Multi-layer setup"
          ],
          pointsAr: [
            "متوافق مع RDWorks",
            "يدعم LightBurn",
            "إضافات CorelDRAW",
            "قص متجهي ونقش Raster",
            "يدعم الطبقات المتعددة"
          ]
        },

        {
          title: "Automatic Up/Down Table & Rotary Axis (Optional)",
          titleAr: "طاولة رفع تلقائي ومحور دوّار (اختياري)",
          points: [
            "Ideal for cups and cylindrical objects",
            "Perfect for 360° engraving",
            "Enhances workflow flexibility"
          ],
          pointsAr: [
            "مثالية للأكواب والأجسام الأسطوانية",
            "نقش 360° بسهولة",
            "مرونة أكبر في التشغيل"
          ]
        },

        {
          title: "Clean & Safe Operation",
          titleAr: "تشغيل نظيف وآمن",
          points: [
            "Built-in exhaust fan",
            "Air assist prevents burning",
            "Cleaner edges",
            "Enhanced safety"
          ],
          pointsAr: [
            "مروحة شفط مدمجة",
            "Air Assist لمنع الاحتراق",
            "حواف أنظف",
            "أمان أعلى أثناء التشغيل"
          ]
        }
      ],

      workingArea: [
        "40×30 cm",
        "60×40 cm",
        "90×60 cm",
        "130×90 cm",
        "130×180 cm",
        "Custom sizes available"
      ],
      workingAreaAr: [
        "40×30 سم",
        "60×40 سم",
        "90×60 سم",
        "130×90 سم",
        "130×180 سم",
        "مقاسات مخصصة"
      ],

      applications: [
        {
          category: "Signage & Advertising",
          categoryAr: "الإعلانات",
          items: ["Acrylic letters", "Lightbox panels", "Engraved logos", "Event decorations"],
          itemsAr: ["حروف أكريليك", "لوحات Lightbox", "شعارات منقوشة", "ديكورات مناسبات"]
        },
        {
          category: "Woodworking & Décor",
          categoryAr: "الخشب والديكور",
          items: ["MDF panels", "Wood art", "Decorative partitions", "Custom furniture parts"],
          itemsAr: ["ألواح MDF", "قطع فنية خشبية", "فواصل زخرفية", "أجزاء أثاث مخصصة"]
        },
        {
          category: "Packaging & Crafts",
          categoryAr: "التغليف والحرف",
          items: ["Paper cutting", "Cardboard prototypes", "Gift boxes", "Craft projects"],
          itemsAr: ["قص الورق", "نماذج كرتون", "علب هدايا", "أعمال حرفية"]
        },
        {
          category: "Leather Products",
          categoryAr: "منتجات الجلد",
          items: ["Wallets", "Belts", "Bags", "Shoes"],
          itemsAr: ["محافظ", "أحزمة", "حقائب", "أحذية"]
        },
        {
          category: "Textile & Garments",
          categoryAr: "القماش والملابس",
          items: ["Pattern cutting", "Engraving on fabric", "Fashion accessories"],
          itemsAr: ["قص النقوش", "نقش على القماش", "إكسسوارات الموضة"]
        },
        {
          category: "Custom Gifts & Personalization",
          categoryAr: "الهدايا والمنتجات المخصصة",
          items: ["Photo engraving", "Name tags", "Awards", "Trophies"],
          itemsAr: ["صور منقوشة", "ميداليات", "دروع", "كوؤس"]
        }
      ],

      advantages: [
        "Smooth polished edges",
        "No tool wear (non-contact cutting)",
        "Fine engraving details",
        "Low maintenance",
        "Suitable for hobby and industrial use"
      ],
      advantagesAr: [
        "حواف ناعمة بدون تشطيب إضافي",
        "بدون تآكل أدوات (قص غير تلامسي)",
        "تفاصيل نقش دقيقة",
        "صيانة منخفضة",
        "مناسب للهواة والمصانع"
      ]
    },

    TitleTag: "CO₂ Laser Cutting Machine | High-Precision Laser Engraving System",
    MetaDescription:
      "High-speed CO₂ laser cutting and engraving machine for wood, acrylic, leather, MDF, and non-metal materials with clean edges and precision results.",
    Keywords: "co2 laser machine, acrylic laser cutting, co2 engraving machine, mdf laser cutter",
    SEOContent: ""
  },

  {
    id: 12,
    name: "Sheet Metal Fiber Laser Cutting Machine",
    nameAr: "ماكينة الفايبر ليزر لقص الصفائح المعدنية",

    image: "/../products/fiber-laser-550x750.png",
    image_small: "/../products/fiber-laser-350x370.png",
    video: "/../products/fiber laser.mp4",
    slug: "sheet-metal-fiber-laser-cutting-machine",

    rate: 5,
    reviews: [
      {
        id: 1,
        userName: "عبدالله العتيبي",
        rating: 5,
        comment:
          "ماكينة ممتازة، دقة القص عالية جدًا وسرعة التنفيذ وفرت علينا وقت كبير في الإنتاج.",
        createdAt: "May 2026",
      },
      {
        id: 2,
        userName: "",
        rating: 5,
        comment:
          "Excellent cutting quality and very stable performance. Installation was smooth and the machine exceeded expectations.",
        createdAt: "Apr 2026",
      },
      {
        id: 3,
        userName: "فيصل القحطاني",
        rating: 5,
        comment:
          "استخدمناها في قص الستانلس والحديد والنتائج كانت احترافية، أنصح بها.",
        createdAt: "Mar 2026",
      },
      {
        id: 4,
        userName: "سلمان الدوسري",
        rating: 4,
        comment:
          "الأداء ممتاز وسهلة التشغيل، فقط احتجنا بعض الوقت للتعود على الإعدادات.",
        createdAt: "Feb 2026",
      },
      {
        id: 5,
        userName: "",
        rating: 5,
        comment:
          "Very fast machine with clean edges. Reduced material waste significantly.",
        createdAt: "Jan 2026",
      },
      {
        id: 6,
        userName: "محمد الشمري",
        rating: 5,
        comment:
          "خدمة ما بعد البيع ممتازة، والماكينة تعمل بكفاءة حتى مع التشغيل لساعات طويلة.",
        createdAt: "Dec 2025",
      },
      {
        id: 7,
        userName: "تركي المطيري",
        rating: 4,
        comment:
          "الجودة ممتازة والقص دقيق جدًا، وكانت مناسبة لاحتياجات المصنع لدينا.",
        createdAt: "Nov 2025",
      },
      {
        id: 8,
        userName: "",
        rating: 5,
        comment:
          "The machine is reliable and easy to maintain. Great value for the price.",
        createdAt: "Sep 2025",
      },
      {
        id: 9,
        userName: "خالد العنزي",
        rating: 5,
        comment:
          "أفضل ماكينة تعاملنا معها حتى الآن، السرعة والدقة وفرت علينا تكلفة التشغيل.",
        createdAt: "Aug 2025",
      },
      {
        id: 10,
        userName: "ناصر الحربي",
        rating: 5,
        comment:
          "تجربة ممتازة من الشراء حتى التشغيل، والنتائج في قص الصفائح كانت أكثر من رائعة.",
        createdAt: "Jun 2025",
      },
    ],
    title: "Sheet Metal Fiber Laser Cutting Machine",
    titleAr: "ماكينة الفايبر ليزر لقص الصفائح المعدنية",

    desc:
      "A high-speed, high-precision fiber laser cutting machine designed for industrial sheet metal fabrication with exceptional quality and performance.",
    descAr:
      "ماكينة فايبر ليزر عالية السرعة والدقة مخصصة لقص الصفائح المعدنية بجودة ممتازة وأداء ثابت يناسب المصانع وخطوط الإنتاج.",

    overview:
      "High-Speed & High-Precision Metal Cutting. The Sheet Metal Fiber Laser Cutting Machine is engineered for industrial manufacturers needing stable performance, clean edges, and ultra-fast production. Perfect for cutting steel, stainless steel, aluminum, brass, and copper with exceptional accuracy.",
    overviewAr:
      "قص فائق السرعة والدقة للصفائح المعدنية الصناعية. تم تصميم ماكينة الفايبر ليزر لقص المعادن بأعلى جودة لضمان أداء ثابت، حواف نظيفة، وإنتاج سريع للمصانع التي تعمل على الحديد، الستانلس، الألمنيوم، النحاس، والبرونز.",

    details: {
      keyFeatures: [
        {
          title: "High-Power Fiber Laser Source",
          titleAr: "ليزر فايبر عالي القدرة",
          points: [
            "Power options from 1 kW to 60 kW",
            "Fast and clean metal cutting",
            "Works with steel, stainless steel, aluminum, brass, copper",
            "Stable output for continuous industrial production"
          ],
          pointsAr: [
            "قدرات من 1 كيلووات حتى 60 كيلووات",
            "قص سريع ونظيف لكل أنواع المعادن",
            "مثالي للحديد، الستانلس، الألمنيوم، النحاس، والبرونز",
            "ثبات عالي للتشغيل الصناعي المستمر"
          ]
        },

        {
          title: "Industrial-Grade Machine Body",
          titleAr: "هيكل صناعي ثقيل",
          points: [
            "Fully welded steel structure",
            "Heat-treated for maximum rigidity",
            "Precision machined to eliminate vibration",
            "Long-term accuracy and durability"
          ],
          pointsAr: [
            "هيكل فولاذي ملحوم بالكامل",
            "معالج حرارياً لضمان أعلى ثبات",
            "تصنيع دقيق لمنع أي اهتزاز",
            "دقة وثبات طويل المدى"
          ]
        },

        {
          title: "Ultra-Fast Cutting Speed",
          titleAr: "سرعة قص عالية جداً",
          points: [
            "High-speed motion system",
            "Smooth and stable movement",
            "Perfect for large production batches",
            "Precision maintained at maximum speed"
          ],
          pointsAr: [
            "نظام حركة عالي السرعة",
            "حركة سلسة ومستقرة",
            "مثالية للإنتاج الكثيف",
            "دقة ثابتة حتى عند أعلى سرعة"
          ]
        },

        {
          title: "Auto-Focus Laser Head",
          titleAr: "عدسة أوتوفوكس ذكية",
          points: [
            "Automatic focus adjustment",
            "Clean and accurate cutting edges",
            "No manual calibration needed",
            "Designed specifically for metal cutting"
          ],
          pointsAr: [
            "تعديل تلقائي للبؤرة حسب السماكة",
            "حواف نظيفة ودقيقة",
            "بدون الحاجة لضبط يدوي",
            "مصممة خصيصاً لقص الصفائح المعدنية"
          ]
        },

        {
          title: "Low Maintenance & Long Lifespan",
          titleAr: "صيانة منخفضة وعمر طويل",
          points: [
            "Reliable fiber source",
            "Minimal servicing requirements",
            "High efficiency and reduced power consumption",
            "Built for 24/7 industrial use"
          ],
          pointsAr: [
            "مصدر ليزر موثوق",
            "صيانة قليلة جداً",
            "كفاءة عالية وأقل استهلاك للطاقة",
            "مصممة للعمل المستمر 24/7"
          ]
        }
      ],

      workingArea: [
        "1500×3000 mm",
        "1500×6000 mm",
        "2000×6000 mm",
        "2500×6000 mm",
        "3000×12000 mm",
        "Optional double table system"
      ],
      workingAreaAr: [
        "1500×3000 مم",
        "1500×6000 مم",
        "2000×6000 مم",
        "2500×6000 مم",
        "3000×12000 مم",
        "يتوفر أيضاً طاولة عمل مزدوجة"
      ],

      applications: [
        {
          category: "General Metal Fabrication",
          categoryAr: "تصنيع المعادن",
          items: ["Steel structures", "Custom parts", "Contract manufacturing"],
          itemsAr: ["هياكل معدنية", "قطع مخصصة", "تصنيع تعاقدي"]
        },
        {
          category: "HVAC & Ducting",
          categoryAr: "دكتات التكييف HVAC",
          items: ["Ventilation parts", "Duct components", "Air system panels"],
          itemsAr: ["قطع التهوية", "مكونات الدكت", "ألواح نظم الهواء"]
        },
        {
          category: "Industrial Enclosures",
          categoryAr: "الصناديق الصناعية",
          items: ["Machine covers", "Control boxes", "Metal housings"],
          itemsAr: ["أغطية ماكينات", "صناديق التحكم", "هياكل معدنية"]
        },
        {
          category: "Automotive & Transportation",
          categoryAr: "السيارات والنقل",
          items: ["Car parts", "Chassis components", "Metal prototypes"],
          itemsAr: ["أجزاء سيارات", "مكونات شاسيه", "نماذج معدنية"]
        },
        {
          category: "Kitchen Equipment",
          categoryAr: "معدات المطابخ",
          items: ["Stainless steel tables", "Cabinets", "Commercial appliances"],
          itemsAr: ["طاولات ستانلس", "خزائن", "معدات تجارية"]
        },
        {
          category: "Signage & Advertising",
          categoryAr: "الإعلانات",
          items: ["Metal letters", "Lightbox parts", "Decorative panels"],
          itemsAr: ["حروف معدنية", "مكونات لايت بوكس", "ألواح ديكور معدنية"]
        },
        {
          category: "Steel Furniture",
          categoryAr: "الأثاث المعدني",
          items: ["Tables", "Shelving", "Interior décor"],
          itemsAr: ["طاولات", "أرفف", "ديكور داخلي معدني"]
        },
        {
          category: "Agricultural Machinery",
          categoryAr: "الآلات الزراعية",
          items: ["Panels", "Spare parts", "Machine components"],
          itemsAr: ["ألواح", "قطع غيار", "مكونات آلات"]
        },
        {
          category: "Electrical Cabinets",
          categoryAr: "صناديق الكهرباء",
          items: ["Distribution boxes", "Control panels", "Enclosures"],
          itemsAr: ["علب توزيع", "لوحات تحكم", "هياكل معدنية"]
        }
      ],

      advantages: [
        "Cutting accuracy up to ±0.02 mm",
        "Clean edges with zero burrs",
        "Extremely fast cutting speed",
        "Industrial-grade components",
        "After-sales support & spare parts",
        "Optional: Auto-loader, Tube Cutting, Shuttle Table"
      ],
      advantagesAr: [
        "دقة قص تصل إلى ±0.02 مم",
        "حواف نظيفة بدون رايش",
        "سرعة قص عالية جداً",
        "مكونات صناعية عالية الجودة",
        "دعم فني وقطع غيار",
        "خيارات إضافية: Auto-loader – Tube Cutting – Shuttle Table"
      ]
    },

    TitleTag: "Sheet Metal Fiber Laser Cutting Machine | High-Speed Metal Cutting",
    MetaDescription:
      "Industrial fiber laser cutting machine for sheet metal fabrication. High-speed cutting, clean edges, and precision accuracy for steel, stainless steel, aluminum, brass, and copper.",
    Keywords: "fiber laser cutting machine, metal laser cutter, sheet metal fiber laser, industrial laser cutting",
    SEOContent: ""
  },

  {
    id: 13,
    name: "Tube Fiber Laser Cutting Machine",
    nameAr: "ماكينة الفايبر ليزر لقص الأنابيب",

    image: "/products/Tube Fiber Laser Cutting Machine.jfif",
    image_small: "/products/Tube Fiber Laser Cutting Machine.jfif",
    slug: "tube-fiber-laser-cutting-machine",

    title: "Tube Fiber Laser Cutting Machine",
    titleAr: "ماكينة الفايبر ليزر لقص الأنابيب",

    desc:
      "A high-precision fiber laser machine engineered for fast, clean, and accurate cutting of round, square, rectangular, oval, and custom metal tubes.",
    descAr:
      "ماكينة فايبر ليزر عالية الدقة مصممة لقص الأنابيب المعدنية المستديرة والمربعة والمستطيلة والبيضاوية والمقاطع المختلفة بسرعة ودقة وحواف نظيفة.",

    overview: `
Precision Cutting for Round, Square & Custom Tubes

Our Tube Fiber Laser Cutting Machine is engineered to deliver fast, clean, and highly accurate cuts across all types of metal pipes and profiles.
Designed for modern fabrication industries, it provides unmatched performance in cutting round, square, rectangular, oval, and custom-shaped tubes with exceptional consistency.
`,
    overviewAr:
      "قص دقيق للأنابيب الدائرية والمربعة والمستطيلة والبيضاوية والمقاطع الخاصة. تم تصميم ماكينة قص الأنابيب بالفايبر لتوفير أداء عالي السرعة والدقة والثبات لمختلف التطبيقات الصناعية، مع قدرة ممتازة على التعامل مع الأنابيب المعدنية بأشكالها وأنواعها المختلفة.",

    details: {
      keyFeatures: [
        {
          title: "High-Performance Fiber Laser Source",
          titleAr: "ليزر فايبر عالي الأداء",
          points: [
            "Available from 1 kW to 60 kW",
            "Fast, stable, and clean cutting quality",
            "Equipped with Raycus, IPG, or MAX laser sources",
            "Suitable for carbon steel, stainless steel, aluminum, brass, and more"
          ],
          pointsAr: [
            "قدرات تبدأ من 1 كيلووات حتى 60 كيلووات",
            "جودة قص سريعة ونظيفة وثابتة",
            "مزودة بمصادر ليزر: Raycus – IPG – MAX",
            "مناسبة للحديد، الستانلس، الألومنيوم، النحاس، والبرونز"
          ]
        },

        {
          title: "Ultra-Precise Tube Cutting",
          titleAr: "قص دقيق للغاية للأنابيب",
          points: [
            "Smooth edges without post-processing",
            "High accuracy for complex contours and bevel cuts",
            "Ideal for structural and decorative tube components"
          ],
          pointsAr: [
            "حواف ناعمة بدون الحاجة لتشطيب إضافي",
            "دقة عالية للقصات المنحنية والمعقدة وللبوفل",
            "مثالية للأنابيب الهيكلية والزخرفية"
          ]
        },

        {
          title: "Automatic Tube Loading System (Optional)",
          titleAr: "نظام تحميل أنابيب أوتوماتيكي (اختياري)",
          points: [
            "Automatic feeding and centering",
            "Reduces labor cost",
            "Supports continuous, unmanned operation",
            "Boosts overall production efficiency"
          ],
          pointsAr: [
            "تغذية أوتوماتيكية وتمركز تلقائي",
            "تقليل تكلفة العمالة",
            "تشغيل مستمر بدون تدخل بشري",
            "زيادة كفاءة الإنتاج"
          ]
        },

        {
          title: "High-Speed Rotary Chuck System",
          titleAr: "تشاك دوار عالي السرعة",
          points: [
            "Servo-driven rotary chucks for maximum stability",
            "Automatic adjustment for multiple tube diameters",
            "Supports tubes from 20 mm to 320 mm (customizable)"
          ],
          pointsAr: [
            "تشاك سيرفو للحصول على أعلى ثبات",
            "ضبط تلقائي لأقطار الأنابيب المتنوعة",
            "يدعم أقطار من 20 مم حتى 320 مم (قابل للتخصيص)"
          ]
        },

        {
          title: "Real-Time Monitoring & Smart Control",
          titleAr: "مراقبة ذكية وتحكم متقدم",
          points: [
            "Advanced CNC control system",
            "Automatic nesting and toolpath optimization",
            "Real-time cutting visualization",
            "Error detection with smart alarms"
          ],
          pointsAr: [
            "نظام تحكم CNC متطور",
            "Nesting تلقائي وتحسين لمسار القطع",
            "رؤية مباشرة لعملية القص",
            "إنذارات ذكية واكتشاف للأخطاء"
          ]
        }
      ],

      workingArea: [
        "Supports tube diameters: 20 mm – 320 mm (customizable)",
        "Supports round, square, rectangular, oval, and special profiles",
        "Optional automatic loading system for long tubes"
      ],
      workingAreaAr: [
        "يدعم أقطار الأنابيب: 20 مم – 320 مم (قابل للتخصيص)",
        "يدعم الأنابيب الدائرية والمربعة والمستطيلة والبيضاوية والمقاطع الخاصة",
        "نظام تحميل أوتوماتيكي اختياري للأنابيب الطويلة"
      ],

      applications: [
        {
          category: "Industrial Metal Fabrication",
          categoryAr: "تصنيع الهياكل المعدنية",
          items: ["Structural pipes", "Supporting beams", "Industrial assemblies"],
          itemsAr: ["أنابيب هيكلية", "عوارض دعم", "تجميعات صناعية"]
        },
        {
          category: "Furniture Manufacturing",
          categoryAr: "صناعة الأثاث المعدني",
          items: ["Metal chairs & tables", "Bed frames", "Office furniture", "Decorative tubular designs"],
          itemsAr: ["كراسي وطاولات معدنية", "هياكل أسرّة", "أثاث مكتبي", "تصميمات أنابيب زخرفية"]
        },
        {
          category: "Automotive & Transportation",
          categoryAr: "السيارات والنقل",
          items: ["Exhaust systems", "Chassis components", "Roll cages", "Lightweight aluminum tubes"],
          itemsAr: ["عوادم سيارات", "مكونات شاسيه", "حمايات رول بار", "أنابيب ألومنيوم خفيفة"]
        },
        {
          category: "Fitness & Gym Equipment",
          categoryAr: "معدات الجيم واللياقة",
          items: ["Gym machines", "Weightlifting racks", "Fitness accessories"],
          itemsAr: ["ماكينات جيم", "رفوف أوزان", "معدات لياقة"]
        },
        {
          category: "Architectural & Interior Design",
          categoryAr: "الأعمال المعمارية والديكور",
          items: ["Handrails", "Staircase frames", "Decorative metal structures", "Lighting installations"],
          itemsAr: ["درابزين", "هياكل سلالم", "هياكل معدنية ديكورية", "تركيبات إضاءة"]
        },
        {
          category: "Agriculture & Construction Machinery",
          categoryAr: "الآلات الزراعية والإنشائية",
          items: ["Hydraulic components", "Machine frames", "Protective tube guards"],
          itemsAr: ["مكونات هيدروليك", "هياكل معدات", "حمايات أنابيب"]
        },
        {
          category: "HVAC & Ventilation Systems",
          categoryAr: "أنظمة التهوية والتكييف",
          items: ["Ventilation tubing", "Duct connectors", "Industrial piping"],
          itemsAr: ["أنابيب تهوية", "وصلات دكت", "配管 صناعي"]
        },
        {
          category: "Signage & Advertising",
          categoryAr: "الإعلانات واليافطات",
          items: ["Lightbox frames", "Billboard structures", "Aluminum profile systems"],
          itemsAr: ["هياكل لايت بوكس", "هياكل لوحات إعلانية", "أنظمة بروفايل ألومنيوم"]
        },
        {
          category: "Medical Equipment Fabrication",
          categoryAr: "تصنيع المعدات الطبية",
          items: ["Hospital beds", "Wheelchairs", "Surgical frames", "Precision medical components"],
          itemsAr: ["أسرة مستشفيات", "كراسي متحركة", "هياكل جراحية", "قطع طبية دقيقة"]
        },
        {
          category: "Steel Doors & Frames",
          categoryAr: "الأبواب والهياكل المعدنية",
          items: ["Metal gates", "Fencing systems", "Custom tubular frames"],
          itemsAr: ["بوابات معدنية", "أسوار", "هياكل أنابيب مخصصة"]
        }
      ],

      advantages: [
        "Higher cutting speed than plasma or mechanical saws",
        "Zero burrs and minimal heat effect",
        "Reduced material waste",
        "Long machine lifespan with lower maintenance",
        "Perfect for mass production",
        "Easily integrated into automated production lines"
      ],
      advantagesAr: [
        "سرعة أعلى من البلازما والمناشير التقليدية",
        "بدون رايش وتأثير حراري منخفض",
        "هدر أقل في الخامة",
        "عمر تشغيل طويل وصيانة أقل",
        "مثالية للإنتاج الكمي",
        "يمكن دمجها بسهولة مع خطوط الإنتاج"
      ]
    },

    TitleTag: "Tube Fiber Laser Cutting Machine | High-Accuracy Tube Laser",
    MetaDescription:
      "High-speed fiber laser cutting machine for round, square, rectangular, and custom metal tubes. Ideal for industrial fabrication with high precision and stability.",
    Keywords:
      "tube laser cutting machine, pipe fiber laser, metal tube cutter, round tube laser, square tube laser",
    SEOContent: ""
  },

  {
    id: 14,
    name: "Tube & Sheet Fiber Laser Cutting Machine",
    nameAr: "ماكينة فايبر ليزر للصفائح والأنابيب",

    image: "/products/Tube & Sheet Fiber Laser Cutting Machine.jfif",
    image_small: "/products/Tube & Sheet Fiber Laser Cutting Machine.jfif",
    slug: "tube-sheet-fiber-laser-cutting-machine",

    title: "Tube & Sheet Fiber Laser Cutting Machine",
    titleAr: "ماكينة فايبر ليزر للصفائح والأنابيب",

    desc:
      "A dual-function fiber laser machine designed for high-precision cutting of both metal sheets and tubes, combining flexibility and productivity in one system.",
    descAr:
      "ماكينة فايبر ليزر مزدوجة الوظيفة لقص الصفائح المعدنية والأنابيب بدقة عالية، تجمع بين المرونة والإنتاجية في جهاز واحد.",

    overview: `
One Machine for Cutting Both Metal Sheets and Tubes With High Precision

The Tube & Sheet Fiber Laser Cutting Machine is a dual-function system designed for manufacturers who need maximum flexibility in their production line.
It combines flat sheet cutting and tube/pipe cutting into a single high-performance machine, reducing factory space requirements while boosting productivity.
`,
    overviewAr: `
جهاز واحد لقص الصفائح المعدنية والأنابيب بدقة عالية.

ماكينة الفايبر المزدوجة توفر حل مثالي للمصانع التي تحتاج تنوع في الإنتاج.
تجمع بين قص الصفائح وقص الأنابيب في نفس الجهاز، مما يوفر مساحة المصنع ويزيد الإنتاجية.
`,

    details: {
      keyFeatures: [
        {
          title: "Dual Cutting Functionality",
          titleAr: "وظيفة قص مزدوجة",
          points: [
            "Performs flat sheet metal cutting and round/square/rectangular tube cutting",
            "Eliminates need for separate machines",
            "Reduces operational costs",
            "Boosts factory productivity"
          ],
          pointsAr: [
            "قص الصفائح المعدنية",
            "قص الأنابيب (دائري – مربع – مستطيل)",
            "بدون الحاجة لشراء جهازين منفصلين",
            "تقليل التكلفة وزيادة الإنتاجية"
          ]
        },

        {
          title: "High-Power Fiber Laser Source",
          titleAr: "ليزر فايبر عالي القدرة",
          points: [
            "Power options from 1 kW to 60 kW",
            "Fast, stable, and clean cuts",
            "Suitable for all common metals",
            "Reliable performance for industrial production"
          ],
          pointsAr: [
            "قدرات تبدأ من 1kW حتى 60kW",
            "قص نظيف وسريع",
            "مناسب لمعظم المعادن",
            "أداء موثوق للإنتاج الصناعي"
          ]
        },

        {
          title: "Automatic Rotary Tube Cutting System",
          titleAr: "تشاك دوار أوتوماتيكي",
          points: [
            "Servo-driven rotary chuck",
            "Supports tubes from 20 mm to 320 mm (customizable)",
            "High accuracy at high speeds",
            "Smooth rotation for complex contours and beveled cuts"
          ],
          pointsAr: [
            "تشاك سيرفو عالي الدقة",
            "يدعم أنابيب من 20 مم حتى 320 مم (قابل للتخصيص)",
            "دقة ممتازة بسرعات عالية",
            "سلاسة في القص للمنحنيات والقصات المائلة"
          ]
        },

        {
          title: "Advanced Autofocus Laser Head",
          titleAr: "عدسة Autofocus متقدمة",
          points: [
            "Smart autofocus adjusts to material thickness",
            "Consistent cutting quality for both tubes and sheets",
            "Minimizes manual adjustment",
            "Ensures flawless edges"
          ],
          pointsAr: [
            "ضبط تلقائي حسب سماكة المادة",
            "جودة قص ثابتة للصفائح والأنابيب",
            "تقليل الحاجة للضبط اليدوي",
            "حواف نظيفة بدون عيوب"
          ]
        },

        {
          title: "Intelligent CNC Control System",
          titleAr: "نظام CNC ذكي",
          points: [
            "High-speed nesting",
            "Path optimization",
            "Real-time cutting preview",
            "Error detection & smart alarms",
            "One-click switching between tube and sheet modes"
          ],
          pointsAr: [
            "Nesting عالي السرعة",
            "تحسين مسار القص",
            "معاينة مباشرة للعمل",
            "إنذارات ذكية واكتشاف الأخطاء",
            "تبديل سريع بين وضع الصفائح والأنابيب"
          ]
        },

        {
          title: "Heavy-Duty Industrial Construction",
          titleAr: "هيكل صناعي ثقيل",
          points: [
            "Stress-relieved, heat-treated frame",
            "Minimal vibration during operation",
            "Long-term stability",
            "Durable for continuous industrial use"
          ],
          pointsAr: [
            "هيكل معالج حرارياً ومفرغ من الإجهاد",
            "اهتزاز منخفض أثناء التشغيل",
            "ثبات عالي على المدى الطويل",
            "مصمم للاستخدام الصناعي المستمر"
          ]
        }
      ],

      workingArea: [
        "1500×3000 mm",
        "1500×6000 mm",
        "2000×6000 mm",
        "2500×6000 mm",
        "3000×12000 mm"
      ],
      workingAreaAr: [
        "1500×3000 مم",
        "1500×6000 مم",
        "2000×6000 مم",
        "2500×6000 مم",
        "3000×12000 مم"
      ],

      applications: [
        {
          category: "Metal Fabrication Workshops",
          categoryAr: "الورش والمصانع المعدنية",
          items: ["Flat sheet cutting", "Tube and pipe processing"],
          itemsAr: ["قص الصفائح", "قص الأنابيب والمعادن"]
        },
        {
          category: "Furniture & Decoration Industry",
          categoryAr: "صناعة الأثاث والديكور",
          items: ["MDF & metal furniture components", "Decorative metal designs"],
          itemsAr: ["مكونات أثاث MDF ومعدن", "تصميمات معدنية زخرفية"]
        },
        {
          category: "Automotive Parts Manufacturing",
          categoryAr: "تصنيع أجزاء السيارات",
          items: ["Car frames", "Chassis components", "Custom tubular parts"],
          itemsAr: ["هياكل سيارات", "مكونات شاسيه", "قطع أنابيب مخصصة"]
        },
        {
          category: "Steel Structures & Construction",
          categoryAr: "الهياكل المعدنية والإنشاءات",
          items: ["Structural beams", "Support frameworks", "Industrial assemblies"],
          itemsAr: ["عوارض هيكلية", "هياكل دعم", "تجميعات صناعية"]
        },
        {
          category: "Agricultural & Industrial Machinery",
          categoryAr: "معدات زراعية وصناعية",
          items: ["Machine frames", "Hydraulic components", "Protective tube guards"],
          itemsAr: ["هياكل معدات", "قطع هيدروليك", "حمايات أنابيب"]
        },
        {
          category: "HVAC & Ventilation Systems",
          categoryAr: "أنظمة HVAC والتهوية",
          items: ["Ventilation tubes", "Duct connectors", "Industrial piping"],
          itemsAr: ["أنابيب تهوية", "وصلات دكت", "配管 صناعي"]
        },
        {
          category: "Advertising & Signage Industry",
          categoryAr: "الإعلانات واليافطات",
          items: ["Lightbox frames", "Billboard structures", "Aluminum profile systems"],
          itemsAr: ["هياكل لايت بوكس", "هياكل لوحات إعلانية", "أنظمة بروفايل ألومنيوم"]
        },
        {
          category: "Electrical Cabinets & Enclosures",
          categoryAr: "لوحات وصناديق كهرباء",
          items: ["Control panels", "Distribution boxes", "Protective housings"],
          itemsAr: ["لوحات تحكم", "صناديق توزيع", "هياكل حماية كهربائية"]
        }
      ],

      advantages: [
        "Cuts both sheets and tubes with a single machine",
        "Saves factory space and reduces equipment costs",
        "High-speed cutting with burr-free edges",
        "Lower power consumption than CO₂ systems",
        "Long service life with minimal maintenance",
        "Professional support, training, and spare parts"
      ],
      advantagesAr: [
        "جهاز واحد للصفائح والأنابيب",
        "توفير مساحة وتكاليف المعدات",
        "قص سريع ونظيف بدون رايش",
        "استهلاك طاقة أقل من أنظمة CO₂",
        "عمر تشغيل طويل وصيانة بسيطة",
        "تدريب ودعم وقطع غيار"
      ]
    },

    TitleTag: "Tube & Sheet Fiber Laser Cutting Machine | Dual-Function Laser Cutter",
    MetaDescription:
      "High-precision dual-function fiber laser machine for cutting metal sheets and tubes. Ideal for factories requiring flexibility, speed, and clean cutting.",
    Keywords:
      "fiber laser cutting machine, tube and sheet laser cutter, dual laser machine, metal sheet cutting, tube laser system",
    SEOContent: ""
  },

  {
    id: 15,
    name: "Handheld Fiber Laser Welding Machine",
    nameAr: "ماكينة اللحام بالليزر المحمولة – فايبر",

    image: "/../products/welding-550x750.png",
    image_small: "/../products/welding-350x370.png",
    video: "/../products/Handheld Fiber Laser Welding Machine video.mp4",
    slug: "handheld-fiber-laser-welding-machine",

    title: "Handheld Fiber Laser Welding Machine",
    titleAr: "ماكينة اللحام بالليزر المحمولة – فايبر",

    desc:
      "A next-generation handheld fiber laser welding machine offering fast, precise, and clean welding for a wide range of metals, replacing traditional TIG/MIG welding.",
    descAr:
      "جيل جديد من ماكينات اللحام الليزري المحمولة يوفر لحامًا سريعًا، نظيفًا، ودقيقًا لمختلف المعادن، وهو بديل مثالي للحام التقليدي TIG/MIG.",

    overview: `
Fast, Clean & High-Precision Welding for All Metal Fabrication Needs

The Handheld Fiber Laser Welding Machine is designed for manufacturers who require high welding speed, exceptional accuracy, and clean weld seams without post-processing.
It delivers superior welding performance on stainless steel, carbon steel, aluminum, brass, and other metals, making it ideal for industrial production and custom metalwork.
`,
    overviewAr: `
لحام سريع، نظيف، ودقيق لكافة احتياجات تشكيل المعادن.

ماكينة اللحام المحمولة بالفايبر تمثل الجيل الجديد للمصنعين الذين يحتاجون إلى سرعة عالية، دقة ممتازة، وجودة لحام فائقة بدون الحاجة لأي تشطيب لاحق.
توفر أداءً قويًا على الفولاذ المقاوم للصدأ، الفولاذ الكربوني، الألمنيوم، النحاس، وغيرها — مما يجعلها بديلاً مثالياً للحام TIG/MIG التقليدي.
`,

    details: {
      keyFeatures: [
        {
          title: "High Welding Speed",
          titleAr: "سرعة لحام عالية",
          points: [
            "Up to 4× faster than TIG/MIG welding",
            "Boosts production efficiency",
            "Reduces labor costs"
          ],
          pointsAr: [
            "أسرع حتى 4 مرات من لحام TIG/MIG",
            "زيادة كبيرة في الإنتاجية",
            "تقليل تكاليف العمالة"
          ]
        },

        {
          title: "Deep Penetration & Strong Weld Quality",
          titleAr: "اختراق عميق وجودة لحام قوية",
          points: [
            "Smooth and uniform weld seams",
            "Minimal heat distortion",
            "Stronger mechanical bonding",
            "Supports metal thickness 0.5–14 mm"
          ],
          pointsAr: [
            "لحامات ناعمة ومتجانسة",
            "تشوه حراري منخفض",
            "ترابط ميكانيكي قوي",
            "يدعم لحام سماكات من 0.5 حتى 14 مم"
          ]
        },

        {
          title: "Low Heat Input (Minimal HAZ)",
          titleAr: "تشوه حراري منخفض (منطقة تأثير حراري صغيرة)",
          points: [
            "Prevents metal warping",
            "Ideal for thin sheet welding",
            "Reduces or eliminates polishing work"
          ],
          pointsAr: [
            "يمنع التواء المعادن",
            "مثالي للألواح الرقيقة",
            "تقليل أو إلغاء الحاجة للتشطيب"
          ]
        },

        {
          title: "Multi-Function Welding Head",
          titleAr: "رأس لحام متعددة الوظائف",
          points: [
            "Continuous welding",
            "Spot welding",
            "Stitch welding",
            "Overlap welding",
            "Fillet & corner welding"
          ],
          pointsAr: [
            "لحام مستمر",
            "لحام نقطي",
            "لحام خياطة",
            "لحام تراكمي",
            "لحام زوايا وحواف"
          ]
        },

        {
          title: "Smart Control System",
          titleAr: "نظام تحكم ذكي",
          points: [
            "Adjustable laser power",
            "Pre-set welding modes",
            "Real-time monitoring",
            "Integrated safety interlocks"
          ],
          pointsAr: [
            "تحكم كامل في قدرة الليزر",
            "وضعيات لحام جاهزة",
            "مراقبة مباشرة أثناء التشغيل",
            "أنظمة أمان متقدمة"
          ]
        },

        {
          title: "Safe & Easy to Use",
          titleAr: "سهلة وآمنة التشغيل",
          points: [
            "Lightweight ergonomic handheld gun",
            "Built-in safety sensors",
            "Minimal learning curve",
            "Suitable for new operators"
          ],
          pointsAr: [
            "مسدس لحام خفيف ومريح",
            "حساسات أمان مدمجة",
            "سهولة التعلم والتشغيل",
            "مناسبة للمشغلين الجدد"
          ]
        }
      ],

      workingArea: [
        "Suitable for stainless steel, carbon steel, aluminum, copper, brass and more",
        "Supports welding thickness 0.5 mm – 14 mm"
      ],
      workingAreaAr: [
        "مناسبة للفولاذ المقاوم، الفولاذ الكربوني، الألمنيوم، النحاس، والنحاس الأصفر",
        "تدعم لحام سماكات من 0.5 مم حتى 14 مم"
      ],

      applications: [
        {
          category: "Stainless Steel Kitchen Equipment",
          categoryAr: "معدات المطابخ الفولاذية",
          items: ["Countertops", "Cooking units", "Industrial kitchen equipment"],
          itemsAr: ["أسطح مطابخ", "أجهزة طهي", "معدات مطابخ صناعية"]
        },
        {
          category: "Doors, Windows & Gates",
          categoryAr: "الأبواب، الشبابيك، والبوابات",
          items: ["Metal doors", "Frames", "Gate fabrication"],
          itemsAr: ["أبواب معدنية", "إطارات نوافذ", "بوابات معدنية"]
        },
        {
          category: "HVAC & Ventilation Systems",
          categoryAr: "أنظمة التكييف والتهوية",
          items: ["Ducts", "Ventilation parts", "Industrial tubes"],
          itemsAr: ["دكتات تهوية", "مكونات تهوية", "أنابيب صناعية"]
        },
        {
          category: "Automotive Fabrication",
          categoryAr: "صناعة السيارات",
          items: ["Body repair", "Panels", "Custom parts"],
          itemsAr: ["هياكل سيارات", "ألواح جسم السيارة", "قطع معدنية مخصصة"]
        },
        {
          category: "Metal Furniture",
          categoryAr: "الأثاث المعدني",
          items: ["Tables & chairs", "Decorative pieces", "Frames"],
          itemsAr: ["طاولات وكراسي", "قطع ديكور معدنية", "هياكل وإطارات"]
        },
        {
          category: "Electrical Cabinets",
          categoryAr: "الخزائن الكهربائية",
          items: ["Control panels", "Boxes", "Protective housings"],
          itemsAr: ["لوحات تحكم", "صناديق كهرباء", "هياكل حماية"]
        },
        {
          category: "Advertising & Signage",
          categoryAr: "الإعلانات واليافطات",
          items: ["Metal letters", "Frames", "Sign structures"],
          itemsAr: ["حروف معدنية", "هياكل لوحات", "إطارات يافطات"]
        },
        {
          category: "Maintenance Workshops",
          categoryAr: "ورش الصيانة",
          items: ["Industrial repairs", "On-site welding", "Custom fabrication"],
          itemsAr: ["صيانة صناعية", "لحام ميداني", "تشكيل معدني مخصص"]
        }
      ],

      advantages: [
        "Clean and strong welding quality",
        "No polishing required after welding",
        "Lower running cost than TIG/MIG",
        "Beginner-friendly operation",
        "Consistent industrial performance",
        "Suitable for a wide range of metals"
      ],
      advantagesAr: [
        "لحام نظيف وقوي بدون تشطيب",
        "لا يحتاج إلى تلميع بعد اللحام",
        "تكلفة تشغيل أقل من TIG/MIG",
        "سهل الاستخدام للمبتدئين",
        "أداء صناعي ثابت",
        "مناسب لأنواع معادن متعددة"
      ]
    },

    TitleTag: "Handheld Fiber Laser Welding Machine | Portable Laser Welder",
    MetaDescription:
      "High-speed handheld fiber laser welding machine for stainless steel, aluminum, carbon steel & metal fabrication with clean weld seams and minimal distortion.",
    Keywords:
      "fiber laser welding machine, handheld laser welder, portable laser welding, stainless steel laser welding, metal welding equipment",
    SEOContent: ""
  },

  {
    id: 16,
    name: "3 Axis CNC Fiber Laser Welding Machine",
    nameAr: "ماكينة اللحام بالليزر CNC ثلاثية المحاور – فايبر",

    image: "/products/3 Axis CNC Fiber Laser Welding Machine.jfif",
    image_small: "/products/3 Axis CNC Fiber Laser Welding Machine.jfif",
    slug: "3-axis-cnc-fiber-laser-welding-machine",

    title: "3 Axis CNC Fiber Laser Welding Machine",
    titleAr: "ماكينة اللحام بالليزر CNC ثلاثية المحاور – فايبر",

    desc:
      "A fully automated 3-axis CNC fiber laser welding machine offering ultra-precise welding for small components, assemblies, and industrial production.",
    descAr:
      "ماكينة لحام ليزر CNC ثلاثية المحاور توفر لحامًا دقيقًا للغاية بفضل التحكم الكامل في المحاور X–Y–Z، ومثالية للحام القطع الصغيرة والمتوسطة والإنتاج الصناعي الضخم.",

    overview: `
High-Precision Automated Welding for Industrial Manufacturing

This 3-axis CNC fiber laser welding system is built for manufacturers who require fully automated, repeatable, and ultra-precise welding.
With X–Y–Z motion control and a stable fiber laser source, it ensures flawless welding for small parts, medium assemblies, and mass-production environments.
`,
    overviewAr: `
لحام آلي عالي الدقة للإنتاج الصناعي.

تأتي ماكينة اللحام بالليزر CNC ثلاثية المحاور لتلبية احتياجات المصانع التي تتطلب لحامًا دقيقًا، متكررًا، وذو جودة ثابتة في كل دورة.
بفضل التحكم في المحاور X–Y–Z ومصدر الليزر الفايبر القوي، تقدم لحامات فائقة النقاء للقطع الصغيرة والمتوسطة وفي خطوط الإنتاج الضخمة.
`,

    details: {
      keyFeatures: [
        {
          title: "3-Axis CNC Control System",
          titleAr: "نظام تحكم CNC ثلاثي المحاور",
          points: [
            "Fully automated movement across X, Y, Z axes",
            "Perfect repeatability for mass production",
            "Highly accurate welding paths",
            "Ensures consistent weld quality every cycle",
            "Ideal for complex shapes and micro-welding"
          ],
          pointsAr: [
            "تحكم آلي كامل في محاور X–Y–Z",
            "تكرار عالي الدقة يناسب الإنتاج الضخم",
            "مسارات لحام دقيقة للغاية",
            "جودة لحام ثابتة في كل دورة",
            "مثالية للأشكال المعقدة واللحام الميكروي"
          ]
        },

        {
          title: "High-Quality Fiber Laser Source",
          titleAr: "مصدر ليزر فايبر عالي الجودة",
          points: [
            "Available powers: 500W–3000W",
            "Deep, clean, and stable welds",
            "Suitable for many metal types",
            "Reliable for continuous industrial work"
          ],
          pointsAr: [
            "قدرات متعددة: من 500W حتى 3000W",
            "لحام عميق ونظيف وثابت",
            "مناسب لمجموعة واسعة من المعادن",
            "موثوق للعمل الصناعي المستمر"
          ]
        },

        {
          title: "Micron-Level Welding Accuracy",
          titleAr: "دقة لحام بمستوى الميكرون",
          points: [
            "Ultra-fine positioning accuracy",
            "Perfect for small parts & thin materials",
            "Consistent precision every cycle"
          ],
          pointsAr: [
            "دقة تحديد عالية جدًا",
            "مثالية للقطع الصغيرة والصفائح الرقيقة",
            "ثبات تام في جودة اللحام"
          ]
        },

        {
          title: "Smart Programming & Automation",
          titleAr: "برمجة ذكية وتشغيل آلي",
          points: [
            "G-code programming",
            "Supports CAD/CAM",
            "Welding path simulation",
            "Automatic parameter setting",
            "Multi-step welding support"
          ],
          pointsAr: [
            "برمجة باستخدام G-code",
            "يدعم CAD/CAM",
            "محاكاة لمسار اللحام",
            "إعداد تلقائي للمعايير",
            "يدعم عمليات لحام متعددة الخطوات"
          ]
        },

        {
          title: "Stable Industrial Machine Body",
          titleAr: "هيكل صناعي ثابت",
          points: [
            "Rigid steel frame reduces vibration",
            "Improves accuracy and weld quality",
            "Designed for long-term industrial use"
          ],
          pointsAr: [
            "هيكل فولاذي قوي يقلل الاهتزاز",
            "يعزز الدقة وجودة اللحام",
            "مصمم للعمل الصناعي الطويل"
          ]
        },

        {
          title: "Automatic Cooling System",
          titleAr: "نظام تبريد أوتوماتيكي",
          points: [
            "Industrial chiller integration",
            "Stable laser temperature",
            "Prevents thermal distortion"
          ],
          pointsAr: [
            "تشغيل متكامل مع شيلر صناعي",
            "يحافظ على درجة حرارة الليزر",
            "يمنع التشوه الحراري"
          ]
        }
      ],

      workingArea: [
        "High-precision small to medium components",
        "Electronics-grade welding",
        "Industrial production lines"
      ],
      workingAreaAr: [
        "لحام القطع الصغيرة والمتوسطة بدقة عالية",
        "لحام مكونات إلكترونية ومعادن رقيقة",
        "مناسب لخطوط الإنتاج الصناعي"
      ],

      applications: [
        {
          category: "Medical Devices Manufacturing",
          categoryAr: "تصنيع الأجهزة الطبية",
          items: ["Surgical tools", "Medical components"],
          itemsAr: ["أدوات جراحية", "مكونات طبية دقيقة"]
        },
        {
          category: "Automotive Sensors & Parts",
          categoryAr: "حساسات وقطع السيارات",
          items: ["Automotive sensors", "Precision small parts"],
          itemsAr: ["حساسات سيارات", "قطع دقيقة صغيرة"]
        },
        {
          category: "Metal Enclosures",
          categoryAr: "الخزائن والهياكل المعدنية",
          items: ["Electrical enclosures", "Metal boxes"],
          itemsAr: ["خزائن كهرباء", "هياكل وصناديق معدنية"]
        },
        {
          category: "Hardware Components",
          categoryAr: "مكونات الهاردوير",
          items: ["Fasteners", "Mini hardware"],
          itemsAr: ["مسامير وأجزاء تثبيت", "قطع هاردوير صغيرة"]
        },
        {
          category: "Aerospace Components",
          categoryAr: "مكونات الطيران",
          items: ["Precision aerospace parts"],
          itemsAr: ["قطع طيران دقيقة وخفيفة"]
        },
        {
          category: "Instrumentation Tools",
          categoryAr: "أدوات القياس الدقيقة",
          items: ["Measuring tools", "Precision tools"],
          itemsAr: ["أدوات قياس", "أدوات دقيقة"]
        },
        {
          category: "Fine Metal Fabrication",
          categoryAr: "التصنيع المعدني الدقيق",
          items: ["Custom parts", "Industrial prototypes"],
          itemsAr: ["قطع مخصصة", "نماذج صناعية"]
        }
      ],

      advantages: [
        "Ultra-high precision automated welding",
        "Eliminates human error",
        "Ideal for mass production",
        "Minimal heat distortion",
        "Strong weld bonding",
        "Lower operating cost vs TIG/MIG",
        "Perfect for small/complex parts"
      ],
      advantagesAr: [
        "لحام آلي عالي الدقة",
        "إلغاء الأخطاء البشرية تمامًا",
        "مثالية للإنتاج الضخم",
        "تشوه حراري شبه معدوم",
        "تماسك لحام قوي",
        "تكلفة تشغيل أقل من TIG/MIG",
        "ممتازة للقطع الصغيرة والمعقدة"
      ]
    },

    TitleTag: "3 Axis CNC Fiber Laser Welding Machine | Industrial Precision Welding",
    MetaDescription:
      "Automated CNC 3-axis fiber laser welding machine for ultra-precise industrial welding. Ideal for electronics, automotive parts, medical devices, and precision manufacturing.",
    Keywords:
      "3 axis laser welding, cnc fiber laser welder, precision laser welding, automated laser welding, industrial welding machine",
    SEOContent: ""
  },


  {
    id: 17,
    name: "Fiber Laser Spot Welding Machine",
    nameAr: "ماكينة اللحام النقطي بالليزر – فايبر",

    image: "/products/Fiber Laser Spot Welding Machine.jfif",
    image_small: "/products/Fiber Laser Spot Welding Machine.jfif",
    slug: "fiber-laser-spot-welding-machine",

    title: "Fiber Laser Spot Welding Machine",
    titleAr: "ماكينة اللحام النقطي بالليزر – فايبر",

    desc:
      "A high-precision fiber laser spot welding machine designed for delicate components, thin metals, and premium decorative products with minimal heat distortion.",
    descAr:
      "ماكينة لحام نقطي بالليزر فايبر توفر لحامًا دقيقًا للغاية مع أقل معدل حرارة وتشوه، مناسبة للمعادن الرقيقة والمنتجات الهندسية الدقيقة والاعمال الزخرفية.",

    overview: `
High-Precision Spot Welding for Delicate Components

The Fiber Laser Spot Welding Machine is engineered for applications that require high-precision, low-heat, and high-strength spot welding.
With exceptionally clean weld spots and adjustable micro-level parameters, it is perfect for thin metals, channel letters, precision tools, and high-end engineered products.
`,
    overviewAr: `
نظرة عامة

ماكينة لحام مؤتمتة بالكامل بدقة عالية، مخصصة للإنتاج الصناعي المتكرر.
تعتمد على نظام حركة دقيق مع مصدر ليزر ثابت لضمان نقاط لحام متناسقة ونظيفة في كل دورة.
مصممة خصيصًا للمعادن الرقيقة والقطع الصغيرة والمنتجات الهندسية عالية الجودة.
`,

    details: {
      keyFeatures: [
        {
          title: "High-Precision Spot Control",
          titleAr: "تحكم عالي الدقة في نقطة اللحام",
          points: [
            "Adjustable spot diameter from 0.1 mm to 2.0 mm",
            "Perfect for miniature components and thin metals",
            "Ensures precise micro-welds"
          ],
          pointsAr: [
            "تعديل قطر نقطة اللحام بين 0.1 مم حتى 2.0 مم",
            "مثالية للأجزاء الصغيرة والمعادن الرقيقة",
            "توفر لحامات ميكرو دقيقة"
          ]
        },

        {
          title: "Minimal Heat-Affected Zone",
          titleAr: "منطقة تأثر حراري منخفضة للغاية",
          points: [
            "Ultra-low heat input",
            "Prevents warping or discoloration",
            "Perfect for stainless steel decorative letters"
          ],
          pointsAr: [
            "حرارة منخفضة جدًا",
            "منع الالتواء أو تغير اللون",
            "مثالية لحروف الستانلس ستيل ثلاثية الأبعاد"
          ]
        },

        {
          title: "Fast & Clean Pulsed Welding",
          titleAr: "لحام نبضي سريع ونظيف",
          points: [
            "Instant energy delivery",
            "Strong and clean weld spots",
            "Almost zero post-processing"
          ],
          pointsAr: [
            "طاقة لحام فورية",
            "نقاط لحام قوية ونظيفة",
            "لا تحتاج معالجة لاحقة تقريبًا"
          ]
        },

        {
          title: "Advanced Intelligent Control System",
          titleAr: "نظام تحكم ذكي ومتطور",
          points: [
            "Touchscreen interface",
            "Preset welding modes",
            "Pulse / frequency / energy adjustment",
            "Real-time monitoring",
            "Automatic fault detection"
          ],
          pointsAr: [
            "واجهة شاشة لمس",
            "وضعيات لحام جاهزة",
            "تحكم في النبض والتردد والطاقة",
            "مراقبة لحظية",
            "كشف أعطال تلقائي"
          ]
        },

        {
          title: "Long-Life Fiber Laser Source",
          titleAr: "مصدر ليزر فايبر طويل العمر",
          points: [
            "Over 100,000 hours lifespan",
            "Stable laser output",
            "No consumables required",
            "Low maintenance"
          ],
          pointsAr: [
            "عمر افتراضي يتجاوز 100,000 ساعة",
            "ثبات عالي في خرج الليزر",
            "لا يحتاج مستهلكات",
            "صيانة منخفضة"
          ]
        }
      ],

      // workingArea: [
      //   "Thin sheet metals",
      //   "Small delicate components",
      //   "3D stainless-steel and aluminum letters",
      //   "Electronics micro parts"
      // ],
      workingAreaAr: [
        "معادن رقيقة",
        "قطع صغيرة ودقيقة",
        "حروف 3D ستانلس ستيل وألومنيوم",
        "مكونات إلكترونية ميكرو"
      ],

      applications: [
        {
          category: "Medical Devices",
          categoryAr: "الأجهزة الطبية",
          items: ["Surgical tools", "Precision components"],
          itemsAr: ["أدوات جراحية", "مكونات دقيقة"]
        },
        {
          category: "Automotive Sensors",
          categoryAr: "حساسات السيارات",
          items: ["Automotive sensors", "Small precision parts"],
          itemsAr: ["حساسات سيارات", "قطع دقيقة صغيرة"]
        },
        {
          category: "Fine Metal Structures",
          categoryAr: "الهياكل المعدنية الدقيقة",
          items: ["Thin metal welds", "Engineered parts"],
          itemsAr: ["لحام معادن رفيعة", "منتجات هندسية دقيقة"]
        },
        {
          category: "Aerospace Components",
          categoryAr: "مكونات الطائرات",
          items: ["Precision aerospace parts"],
          itemsAr: ["قطع طيران دقيقة"]
        },
        {
          category: "Measurement Tools",
          categoryAr: "أدوات القياس",
          items: ["Precision measuring tools"],
          itemsAr: ["أدوات قياس دقيقة"]
        },
        {
          category: "Fine Metal Fabrication",
          categoryAr: "الأجزاء المعدنية الدقيقة",
          items: ["Custom micro parts", "Small metal assemblies"],
          itemsAr: ["أجزاء معدنية دقيقة", "تجميعات صغيرة"]
        }
      ],

      advantages: [
        "Extremely accurate spot positioning",
        "Very low heat distortion",
        "High-strength micro welds",
        "Long laser source lifespan",
        "No consumables & low maintenance",
        "Ideal for precision manufacturing"
      ],
      advantagesAr: [
        "لحام مؤتمت بالكامل",
        "إلغاء الأخطاء البشرية",
        "مثالي للإنتاج الكبير",
        "حرارة وتشوه منخفض جدًا",
        "جودة لحام ممتازة",
        "تكلفة تشغيل منخفضة"
      ]
    },

    TitleTag: "Fiber Laser Spot Welding Machine | Precision Micro Welding",
    MetaDescription:
      "High-precision fiber laser spot welding machine for thin metals, 3D letters, micro components, and precision industrial manufacturing.",
    Keywords:
      "fiber laser spot welding, micro welding machine, 3D letter welding, precision welding system",

    SEOContent: ""
  },

  {
    id: 18,
    name: "CO₂ Laser Marking Machine",
    nameAr: "ماكينة تعليم الليزر CO₂",

    image: "/../products/marker550x750.png",
    image_small: "/../products/marker-350x370.png",
    slug: "co2-laser-marking-machine",

    title: "CO₂ Laser Marking Machine",
    titleAr: "ماكينة تعليم الليزر CO₂",

    desc:
      "A high-speed CO₂ laser marking machine for precise, permanent marking on non-metal materials, ideal for industrial production, packaging, branding, and decorative applications.",
    descAr:
      "حل تعليم ليزر عالي السرعة ودقيق على المواد غير المعدنية، مثالي للإنتاج الصناعي والتغليف والعلامات التجارية والتطبيقات الزخرفية.",

    overview: `
High-Speed Marking for Non-Metal Materials with Superior Clarity

The CO₂ Laser Marking Machine is engineered for fast, precise, and permanent marking on a wide range of non-metal materials.
Advanced RF or glass CO₂ laser sources deliver excellent marking quality for industrial production, packaging, branding, and decorative applications.
`,
    overviewAr: `
نظرة عامة

حل لحام دقيق جداً ومنخفض الحرارة، مثالي للأجزاء الصغيرة والمواد الحساسة.
ممتاز لحروف اللوحات الإعلانية ثلاثية الأبعاد من الستانلس والألمنيوم، والأعمال الدقيقة.
`,

    details: {
      keyFeatures: [
        {
          title: "Precise Spot & Line Control",
          titleAr: "تحكم دقيق في النقاط والخطوط",
          points: [
            "Ultra-fast marking on wood, leather, acrylic, paper, cardboard, plastics, rubber, fabric, and glass",
            "Clean and precise results across various materials"
          ],
          pointsAr: [
            "تحكم سريع ودقيق على الخشب، الجلد، الأكريليك، الورق، الكرتون، البلاستيك، المطاط، القماش والزجاج",
            "نتائج نظيفة ودقيقة على جميع المواد"
          ]
        },
        {
          title: "Permanent, High-Contrast Marks",
          titleAr: "علامات دائمة وواضحة",
          points: [
            "Sharp and detailed marks",
            "Supports text, logos, serial numbers, QR codes, barcodes, and patterns"
          ],
          pointsAr: [
            "علامات حادة وواضحة",
            "يدعم النصوص، الشعارات، الأرقام التسلسلية، QR، الباركود والأنماط"
          ]
        },
        {
          title: "Long-Life Laser Source",
          titleAr: "مصدر ليزر طويل العمر",
          points: [
            "Optional RF metal tube for high precision",
            "Stable and long-lasting performance",
            "Low maintenance"
          ],
          pointsAr: [
            "مصدر ليزر معدني RF اختياري لدقة عالية",
            "أداء مستقر وطويل الأمد",
            "صيانة منخفضة"
          ]
        },
        {
          title: "User-Friendly Software",
          titleAr: "برنامج سهل الاستخدام",
          points: [
            "Compatible with EZCAD, CorelDRAW plug-ins, AutoCAD vector imports",
            "Supports multi-layer marking, variable text, batch serialization, and full graphic control"
          ],
          pointsAr: [
            "متوافق مع EZCAD، إضافات CorelDRAW واستيراد فيكتور AutoCAD",
            "يدعم تعليم متعدد الطبقات، نصوص متغيرة، ترقيم دفعية، والتحكم الكامل بالرسومات"
          ]
        },
        {
          title: "Flexible Integration Options",
          titleAr: "خيارات تكامل مرنة",
          points: [
            "Standalone workstation or fully integrated inline marking",
            "Large marking area options with F-Theta lenses: 100×100 mm up to 800×800 mm"
          ],
          pointsAr: [
            "يمكن استخدامه كوحدة مستقلة أو مدمج بالكامل في خطوط الإنتاج",
            "مساحات تعليم كبيرة مع عدسات F-Theta من 100×100 مم حتى 800×800 مم"
          ]
        }
      ],

      workingArea: [
        "up to 800×800 mm"
      ],
      workingAreaAr: [

        "حتى 800×800 مم  "
      ],

      applications: [
        {
          category: "Signage & 3D Letters",
          categoryAr: "حروف ولافتات 3D",
          items: [
            "Welding stainless steel and aluminum",
            "Welding corners, curves, and edges",
            "Attaching internal supports"
          ],
          itemsAr: [
            "لحام الستانلس والألمنيوم",
            "لحام الحواف والمنحنيات والزوايا",
            "تثبيت الدعامات الداخلية"
          ]
        },
        {
          category: "Electronics & Micro-Components",
          categoryAr: "الإلكترونيات والمكونات الدقيقة",
          items: ["Sensors", "Connectors", "Micro contact points"],
          itemsAr: ["حساسات", "موصلات", "نقاط اتصال صغيرة"]
        },
        {
          category: "Battery Manufacturing",
          categoryAr: "تصنيع البطاريات",
          items: ["Nickel welding", "Small cell assemblies"],
          itemsAr: ["لحام النيكل", "وحدات خلايا صغيرة"]
        },
        {
          category: "Jewelry & Fine Metalwork",
          categoryAr: "المجوهرات",
          items: ["Gold, silver, platinum welding", "Repairing delicate parts"],
          itemsAr: ["لحام الذهب والفضة والبلاتين", "إصلاح القطع الدقيقة"]
        },
        {
          category: "Medical Tools",
          categoryAr: "الأدوات الطبية",
          items: ["Surgical tools", "Precision small components"],
          itemsAr: ["أدوات جراحية", "مكونات صغيرة دقيقة"]
        },
        {
          category: "Hardware & Small Parts",
          categoryAr: "الهاردوير والمكونات الصغيرة",
          items: ["Hinges", "Locks", "Precision mechanisms"],
          itemsAr: ["مفصلات", "أقفال", "آليات دقيقة"]
        },
        {
          category: "Thin Metal Sheets",
          categoryAr: "الصفائح المعدنية الرفيعة",
          items: ["Metal casings", "Light brackets", "Small parts"],
          itemsAr: ["أغلفة معدنية", "براكتات خفيفة", "أجزاء صغيرة"]
        }
      ],

      advantages: [
        "Extremely precise marking",
        "Minimal heat distortion",
        "Strong and durable marks",
        "Long-lasting laser source",
        "Low maintenance",
        "Suitable for industrial production"
      ],
      advantagesAr: [
        "دقة عالية جدًا",
        "حرارة منخفضة",
        "قوة علامات ممتازة",
        "عمر طويل",
        "صيانة منخفضة",
        "مثالي للإنتاج الصناعي"
      ]
    },

    TitleTag: "CO₂ Laser Marking Machine | Precision Marking for Non-Metal Materials",
    MetaDescription:
      "High-speed CO₂ laser marking machine for precise, permanent marking on wood, leather, acrylic, paper, plastics, and other non-metal materials.",
    Keywords: "CO2 laser marking, logo marking machine, wood engraving laser",
    SEOContent: ""
  },

  {
    id: 19,
    name: "Fiber Laser Marking Machine",
    nameAr: "ماكينة الحفر بالليزر فايبر",

    image: "/../products/marker550x750.png",
    image_small: "/../products/marker-350x370.png",
    video: "/../products/Fiber Laser Marking Machine video.mp4",
    slug: "fiber-laser-marking-machine",

    title: "Fiber Laser Marking Machine",
    titleAr: "ماكينة الحفر بالليزر فايبر",

    desc:
      "Ultra-fast, high-precision fiber laser marking machine for metals and industrial materials, ideal for serial numbers, logos, barcodes, QR codes, and deep engraving.",
    descAr:
      "حل حفر ليزر فايبر عالي السرعة ودقيق على المعادن والمواد الصناعية، مثالي للترقيم التسلسلي، الشعارات، الباركود، QR والحفر العميق.",

    overview: `
Ultra-Fast, High-Precision Marking for Metals & Industrial Materials

The Fiber Laser Marking Machine is engineered for extremely fast, permanent, and high-precision marking on all types of metals and many industrial materials.
Using advanced fiber laser sources (20W–100W, JPT, Raycus, MAX), it delivers exceptional marking quality for factories, workshops, and branding applications.
`,
    overviewAr: `
نظرة عامة

حل حفر ليزر فايبر سريع ودقيق للغاية، مناسب لجميع أنواع المعادن والمواد الصناعية.
يستخدم مصادر ليزر فايبر متقدمة (20–100 واط، JPT، Raycus، MAX) لتقديم جودة حفر ممتازة للمصانع وورش العمل والعلامات التجارية.
`,

    details: {
      keyFeatures: [
        {
          title: "High-Speed Metal Marking",
          titleAr: "حفر عالي السرعة على المعادن",
          points: [
            "Optimized for stainless steel, carbon steel, aluminum, brass, copper, titanium, gold, silver, anodized aluminum, and hard plastics (ABS, PVC, PC)",
            "Clean, precise, and durable marks"
          ],
          pointsAr: [
            "مصممة للستانلس ستيل، الكربون ستيل، الألومنيوم، النحاس الأصفر، النحاس، التيتانيوم، الذهب، الفضة، الألومنيوم المؤكسد، والبلاستيك الصلب (ABS, PVC, PC)",
            "نتائج نظيفة، دقيقة ودائمة"
          ]
        },
        {
          title: "Permanent, High-Contrast Results",
          titleAr: "نتائج دائمة ووضوح عالي",
          points: [
            "Ultra-sharp marks resistant to wear, heat, chemicals, and corrosion",
            "Ideal for industrial-grade identification and branding"
          ],
          pointsAr: [
            "علامات حادة للغاية مقاومة للتآكل والحرارة والمواد الكيميائية والتآكل",
            "مثالية للتمييز الصناعي والعلامات التجارية"
          ]
        },
        {
          title: "MOPA Laser Option (JPT M7/M8)",
          titleAr: "خيار ليزر MOPA (JPT M7/M8)",
          points: [
            "Color marking on stainless steel",
            "Fine marking on plastics",
            "Adjustable pulse width for smoother results",
            "Ultra-precise edge control"
          ],
          pointsAr: [
            "علامات ملونة على الستانلس ستيل",
            "حفر دقيق على البلاستيك",
            "ضبط عرض النبضة لنتائج أكثر نعومة",
            "تحكم فائق الدقة في الحواف"
          ]
        },
        {
          title: "Deep Metal Engraving (Optional)",
          titleAr: "حفر المعادن العميق (اختياري)",
          points: [
            "Tool marking, molds, gunsmithing",
            "Heavy industrial parts"
          ],
          pointsAr: [
            "حفر الأدوات والقوالب وصناعة الأسلحة",
            "قطع صناعية ثقيلة"
          ]
        },
        {
          title: "User-Friendly Software",
          titleAr: "برنامج سهل الاستخدام",
          points: [
            "Powered by EZCAD or LightBurn Laser",
            "Supports vector/raster marking, QR/barcode/UID marking, auto-serialization, variable data, multi-layer processing, high-resolution image engraving"
          ],
          pointsAr: [
            "يعمل ببرنامج EZCAD أو LightBurn Laser",
            "يدعم الحفر بالفيكتور/الراستر، QR/باركود/UID، الترقيم التلقائي، البيانات المتغيرة، المعالجة متعددة الطبقات، والحفر عالي الدقة للصور"
          ]
        },
        {
          title: "Large Marking Field Options",
          titleAr: "خيارات مساحات حفر كبيرة",
          points: [
            "70×70 mm, 110×110 mm, 150×150 mm, 175×175 mm, 200×200 mm, 300×300 mm"
          ],
          pointsAr: [
            "70×70 مم، 110×110 مم، 150×150 مم، 175×175 مم، 200×200 مم، 300×300 مم"
          ]
        },
        {
          title: "Low Maintenance & Long Lifespan",
          titleAr: "صيانة منخفضة وعمر طويل",
          points: [
            "Fiber source lifespan: 100,000+ hours",
            "No optical adjustments needed"
          ],
          pointsAr: [
            "عمر مصدر الليزر: أكثر من 100,000 ساعة",
            "لا تحتاج إلى تعديلات بصرية"
          ]
        },
        {
          title: "Multiple Machine Configurations",
          titleAr: "تكوينات متعددة للماكينة",
          points: [
            "Desktop model",
            "Split-type model",
            "Enclosed cabinet (Class 1 laser safety)",
            "Flight (online marking for production lines)"
          ],
          pointsAr: [
            "نموذج مكتبي",
            "نموذج مقسم",
            "خزانة مغلقة (أمان ليزر الفئة 1)",
            "حفر مباشر للخطوط الإنتاجية"
          ]
        }
      ],

      workingArea: [
        "100×100 mm to 550×550 mm",
      ],
      workingAreaAr: [
        "100×100 مم الي 550×550 مم",
      ],

      applications: [
        {
          category: "Industrial Part Identification",
          categoryAr: "تمييز القطع الصناعية",
          items: ["Serial numbers", "Batch codes", "Product IDs", "UDI medical marking"],
          itemsAr: ["الأرقام التسلسلية", "رموز الدفعات", "معرفات المنتجات", "تمييز طبي UDI"]
        },
        {
          category: "Automotive & Machinery Components",
          categoryAr: "مكونات السيارات والآلات",
          items: ["Engine parts", "Gears", "Bearings", "Tools and mechanical hardware"],
          itemsAr: ["قطع المحرك", "تروس", "محامل", "أدوات ومعدات ميكانيكية"]
        },
        {
          category: "Jewelry & Luxury Items",
          categoryAr: "المجوهرات والمنتجات الفاخرة",
          items: ["Metal engraving", "Custom branding", "Deep engraving for long-lasting marks"],
          itemsAr: ["حفر المعادن", "علامات مخصصة", "حفر عميق لعلامات دائمة"]
        },
        {
          category: "Electronics & Electrical Components",
          categoryAr: "الإلكترونيات والمكونات الكهربائية",
          items: ["Chips", "Circuit boards", "Metal housings", "Connectors"],
          itemsAr: ["رقائق", "لوحات دوائر", "أغلفة معدنية", "موصلات"]
        },
        {
          category: "Tools & Hardware",
          categoryAr: "الأدوات والمعدات",
          items: ["Wrenches", "Knives", "Cutting tools", "Metal plates"],
          itemsAr: ["مفاتيح الربط", "سكاكين", "أدوات قطع", "صفائح معدنية"]
        },
        {
          category: "Gifts & Branding",
          categoryAr: "الهدايا والعلامات التجارية",
          items: ["Customized pens", "Metal accessories", "Promotional items"],
          itemsAr: ["أقلام مخصصة", "إكسسوارات معدنية", "منتجات ترويجية"]
        },
        {
          category: "Color Marking (MOPA Models)",
          categoryAr: "الحفر الملون (نماذج MOPA)",
          items: ["Stainless steel full-color engraving", "Anodized aluminum color effects"],
          itemsAr: ["حفر ملون كامل على الستانلس ستيل", "تأثيرات اللون على الألومنيوم المؤكسد"]
        }
      ],

      advantages: [
        "Extremely fast marking speed (up to 7,000 mm/s)",
        "High contrast & permanent results",
        "Zero maintenance required",
        "Very low power consumption",
        "Ultra-long lifespan",
        "Supports complex, detailed designs"
      ],
      advantagesAr: [
        "سرعة حفر عالية جدًا (حتى 7000 مم/ثانية)",
        "نتائج واضحة ودائمة",
        "لا تحتاج صيانة",
        "استهلاك منخفض جدًا للطاقة",
        "عمر طويل للغاية",
        "يدعم التصاميم المعقدة والدقيقة"
      ]
    },

    TitleTag: "Fiber Laser Marking Machine | High-Speed Precision Metal Marking",
    MetaDescription:
      "Ultra-fast fiber laser marking machine for precise, permanent marking on metals and industrial materials. Supports serial numbers, logos, barcodes, QR codes, and deep engraving.",
    Keywords: "fiber laser marker, metal engraving laser, deep marking system",
    SEOContent: ""
  },

  {
    id: 20,
    name: "UV Laser Marking Machine",
    nameAr: "ماكينة الحفر بالليزر UV",
    image: "/../products/marker portrable-550x750.png",
    image_small: "/../products/marker-portable-350x370.png",
    slug: "uv-laser-marking-machine",
    title: "UV Laser Marking Machine",
    titleAr: "ماكينة الحفر بالليزر UV",
    desc:
      "Ultra-fine, cold UV laser marking machine for plastics, glass, electronics, and heat-sensitive materials, ensuring precise, high-contrast, and damage-free marks.",
    descAr:
      "حل حفر ليزر UV دقيق جدًا وبارد للبلاستيك والزجاج والإلكترونيات والمواد الحساسة للحرارة، يضمن علامات دقيقة وواضحة ودون تلف.",
    overview: `
Ultra-Fine, Cold Marking for Plastics, Glass, Electronics & Sensitive Materials

The UV Laser Marking Machine is engineered for extremely fine, high-contrast marking with minimal heat impact.
Using a short 355nm wavelength, UV lasers deliver “cold marking,” ideal for plastics, glass, silicon, medical devices, and micro-electronics where traditional lasers may cause burning or deformation.
`,
    overviewAr: `
نظرة عامة

حل حفر ليزر UV دقيق جدًا وبارد، مناسب للحفر على البلاستيك والزجاج والأجهزة الطبية والمكونات الدقيقة الحساسة للحرارة.
يستخدم طول موجي قصير 355 نانومتر ليزر UV لتحقيق حفر بارد دون تشويه أو حروق.
`,
    details: {
      keyFeatures: [
        {
          title: "Cold Marking Technology (No Burning)",
          titleAr: "تقنية الحفر البارد (بدون حرق)",
          points: [
            "355nm wavelength produces almost zero heat",
            "Perfect for marking plastics (ABS, PVC, PP, PE, PC), glass, silicone, ceramic, sapphire, PCB boards, coated materials, cosmetics packaging, and medical plastics"
          ],
          pointsAr: [
            "طول موجة 355 نانومتر ينتج حرارة شبه معدومة",
            "مثالية للحفر على البلاستيك (ABS, PVC, PP, PE, PC)، الزجاج، السليكون، السيراميك، الياقوت، لوحات PCB، المواد المطلية، تغليف مستحضرات التجميل، والبلاستيك الطبي"
          ]
        },
        {
          title: "Ultra-Fine, High-Resolution Marking",
          titleAr: "حفر فائق الدقة وعالي الجودة",
          points: [
            "Micro-level detail for micro-text, logos, barcodes, QR codes, high-density vector graphics, calibration scales"
          ],
          pointsAr: [
            "تفاصيل دقيقة جدًا للنصوص الصغيرة، الشعارات، الباركود، QR، الرسوميات عالية الكثافة، ومقاييس المعايرة"
          ]
        },
        {
          title: "No Damage to Product Surface",
          titleAr: "بدون تلف لسطح المنتج",
          points: [
            "Smooth, clean marks without melting, charring, or cracking",
            "Ideal for transparent & translucent materials, medical-grade plastics, electronics, and chip components"
          ],
          pointsAr: [
            "علامات ناعمة ونظيفة دون ذوبان أو حرق أو تشقق",
            "مثالية للمواد الشفافة والنصف شفافة، البلاستيك الطبي، الإلكترونيات ومكونات الشرائح"
          ]
        },
        {
          title: "Large Marking Field Options",
          titleAr: "خيارات مساحة الحفر الكبيرة",
          points: [
            "Available lenses: 70×70 mm, 110×110 mm, 150×150 mm, 175×175 mm, 200×200 mm, 300×300 mm"
          ],
          pointsAr: [
            "عدسات متوفرة: 70×70 مم، 110×110 مم، 150×150 مم، 175×175 مم، 200×200 مم، 300×300 مم"
          ]
        },
        {
          title: "Advanced Software Control",
          titleAr: "برنامج تحكم متقدم",
          points: [
            "Compatible with EZCAD",
            "Batch serial marking, variable data, high-resolution image marking, multi-layer engraving, auto-positioning & red-light preview"
          ],
          pointsAr: [
            "متوافق مع برنامج EZCAD",
            "يدعم الترقيم التسلسلي، البيانات المتغيرة، الحفر عالي الدقة للصور، الحفر متعدد الطبقات، التموضع التلقائي، ومعاينة الضوء الأحمر"
          ]
        }
      ],
      // workingArea: [
      //   "Electronics & Semiconductors: IC chips, micro-components, connectors, phone parts, camera modules, PCB marking",
      //   "Medical & Laboratory Devices: syringes, catheters, medical tubes, surgical plastics, pharmaceutical packaging",
      //   "Cosmetics & Packaging: plastic bottles, transparent caps, date coding & batch marking, anti-counterfeit marking",
      //   "Glass & Crystal Marking: cups, bottles, perfume glass, barcode marking, decorative engraving"
      // ],
      // workingAreaAr: [
      //   "الإلكترونيات والرقائق: شرائح IC، المكونات الدقيقة، الموصلات، أجزاء الهواتف، وحدات الكاميرا، علامات PCB",
      //   "الأجهزة الطبية والمخبرية: محاقن، قساطر، أنابيب طبية، بلاستيك جراحي، تغليف دوائي",
      //   "المستحضرات والتغليف: زجاجات بلاستيكية، أغطية شفافة، ترميز تواريخ، ترميز دفعات، علامات مكافحة التزوير",
      //   "الزجاج والكريستال: أكواب، زجاجات، زجاج العطور، باركود، نقش زخرفي"
      // ],
      applications: [
        {
          category: "Electronics & Semiconductors",
          categoryAr: "الإلكترونيات والرقائق",
          items: ["IC chips", "Micro-components", "Connectors", "Phone parts", "Camera modules", "PCB marking"],
          itemsAr: ["شرائح IC", "مكونات دقيقة", "موصلات", "أجزاء الهواتف", "وحدات الكاميرا", "علامات PCB"]
        },
        {
          category: "Medical & Laboratory Devices",
          categoryAr: "الأجهزة الطبية والمخبرية",
          items: ["Syringes", "Catheters", "Medical tubes", "Surgical plastics", "Pharmaceutical packaging"],
          itemsAr: ["محاقن", "قساطر", "أنابيب طبية", "بلاستيك جراحي", "تغليف دوائي"]
        },
        {
          category: "Cosmetics & Packaging",
          categoryAr: "المستحضرات والتغليف",
          items: ["Plastic bottles", "Transparent caps", "Date coding & batch marking", "Anti-counterfeit marking"],
          itemsAr: ["زجاجات بلاستيكية", "أغطية شفافة", "ترميز تواريخ ودفعات", "علامات مكافحة التزوير"]
        },
        {
          category: "Glass & Crystal Marking",
          categoryAr: "الزجاج والكريستال",
          items: ["Cups", "Bottles", "Perfume glass", "Barcode marking", "Decorative engraving"],
          itemsAr: ["أكواب", "زجاجات", "زجاج العطور", "باركود", "نقش زخرفي"]
        }
      ],
      advantages: [
        "Extremely fine marking resolution",
        "No thermal damage (Cold Light Technology)",
        "Ideal for sensitive materials",
        "Clean, smooth marking edges",
        "Zero consumables",
        "Minimal maintenance",
        "Long lifespan and low operating cost"
      ],
      advantagesAr: [
        "دقة حفر فائقة",
        "بدون تلف حراري (تقنية الضوء البارد)",
        "مثالي للمواد الحساسة",
        "حواف حفر نظيفة وناعمة",
        "لا مواد مستهلكة",
        "صيانة منخفضة",
        "عمر طويل وتكلفة تشغيل منخفضة"
      ]
    },
    TitleTag: "UV Laser Marking Machine | Ultra-Fine Cold Marking",
    MetaDescription:
      "Ultra-fine UV laser marking machine for plastics, glass, electronics, and heat-sensitive materials. High-precision, damage-free, and high-contrast marking.",
    Keywords: "UV laser marking, cold laser marker, plastic marking machine",
    SEOContent: ""
  },

  {
    id: 21,
    name: "CNC Plasma Cutting Machine",
    nameAr: "ماكينة القطع بالبلازما CNC",
    image: "/products/CNC Plasma Cutting Machine.jfif",
    image_small: "/products/CNC Plasma Cutting Machine.jfif",
    slug: "cnc-plasma-cutting-machine",
    title: "CNC Plasma Cutting Machine",
    titleAr: "ماكينة القطع بالبلازما CNC",
    desc: "High-speed CNC plasma cutting machine for steel, stainless steel, and industrial fabrication, providing precision, strong penetration, and high productivity.",
    descAr: "ماكينة قطع بالبلازما CNC عالية السرعة للحديد، الستانلس ستيل، والأعمال الصناعية، توفر دقة، قدرة اختراق قوية، وإنتاجية عالية.",

    overview: `
High-Speed Metal Cutting for Steel, Stainless Steel & Industrial Fabrication

The CNC Plasma Cutting Machine is designed for heavy-duty, high-productivity metal cutting, capable of cutting both thin sheets and thick plates with excellent precision.
Equipped with advanced CNC control, high-quality plasma sources (Hypertherm, Huayuan), and a rigid mechanical structure, it ensures accuracy, stability, and long-term durability.
`,
    overviewAr: `
نظرة عامة

قطع معدني عالي السرعة للحديد، الستانلس ستيل، والأعمال الصناعية.
ماكينة القطع بالبلازما CNC مصممة للقطع الشاق عالي الإنتاجية، بقدرة اختراق قوية ودقة ممتازة سواء للصفائح الرقيقة أو السميكة. مناسبة لورش التصنيع، مصانع الهياكل المعدنية، مصانع مجاري الهواء (HVAC)، قطع غيار السيارات، والأعمال المعدنية المُخصصة.
مزودة بأنظمة CNC متقدمة ومصادر بلازما عالية الجودة (Hypertherm – Huayuan) وهيكل ميكانيكي قوي لضمان دقة واستقرار وعمر تشغيل طويل.
`,

    details: {
      keyFeatures: [
        {
          title: "High-Speed Metal Cutting",
          titleAr: "قطع معدني عالي السرعة",
          points: [
            "Cuts carbon steel, stainless steel, galvanized steel, aluminum, brass, copper",
            "Suitable for both thin sheets and thick metal plates"
          ],
          pointsAr: [
            "قادرة على قطع مجموعة واسعة من المعادن: الحديد، الستانلس ستيل، الصاج المجلفن، الألمنيوم، النحاس الأصفر، النحاس الأحمر",
            "مناسبة للصفائح الرقيقة والشرائح السميكة"
          ]
        },
        {
          title: "Powerful Plasma Sources (Optional)",
          titleAr: "مصادر بلازما قوية (اختياري)",
          points: [
            "Hypertherm Powermax Series (top-tier finish)",
            "Huayuan (economical & stable performance)",
            "Power options: 63A, 100A, 160A, 200A, 300A, 400A"
          ],
          pointsAr: [
            "خيارات مولدات البلازما: Hypertherm Powermax (أفضل جودة قطع)، Huayuan (اقتصادي وثابت)",
            "قدرات: 63A / 100A / 160A / 200A / 300A / 400A"
          ]
        },
        {
          title: "High Cutting Precision",
          titleAr: "دقة قطع عالية",
          points: [
            "Smooth, accurate cutting edges",
            "Minimal dross",
            "High repeatability",
            "Excellent performance for detailed patterns & shapes"
          ],
          pointsAr: [
            "حواف ناعمة ودقيقة",
            "حد أدنى من الخبث (Dross)",
            "تكرار ممتاز",
            "مثالية للأشكال التفصيلية والتصميمات المعقدة"
          ]
        },
        {
          title: "Rigid Machine Structure",
          titleAr: "هيكل ميكانيكي قوي",
          points: [
            "Heavy-duty steel frame ensures high stability, low vibration, and long lifespan"
          ],
          pointsAr: [
            "إطار فولاذي ثقيل لضمان ثبات عالي، اهتزاز منخفض، وعمر طويل للماكينة"
          ]
        },
        {
          title: "Advanced CNC Controller",
          titleAr: "وحدة تحكم CNC متقدمة",
          points: [
            "User-friendly interface",
            "DXF / PLT / AI file import",
            "Nesting software",
            "Auto-height control (THC)",
            "Accurate torch path management"
          ],
          pointsAr: [
            "واجهة استخدام سهلة وتدعم: استيراد ملفات DXF / PLT / AI، برنامج Nesting، خاصية التحكم التلقائي في الارتفاع (THC)، إدارة دقيقة لمسار الشعلة"
          ]
        },
        {
          title: "Automatic Torch Height Control (THC)",
          titleAr: "نظام التحكم التلقائي بارتفاع الشعلة (THC)",
          points: [
            "Maintains optimal cutting distance",
            "Better edge quality",
            "Longer torch life",
            "Stable cutting performance"
          ],
          pointsAr: [
            "يحافظ على الارتفاع المثالي، مما يعني جودة حافة أفضل، عمر أطول للشعلة، قطع مستقر وثابت"
          ]
        }
      ],

      workingArea: [
        "1300×2500 mm",
        "1500×3000 mm",
        "2000×4000 mm",
        "2500×6000 mm",
        "3000×12000 mm",
        "Tailor-made sizes for industrial production"
      ],
      workingAreaAr: [
        "1300×2500 مم",
        "1500×3000 مم",
        "2000×4000 مم",
        "2500×6000 مم",
        "3000×12000 مم",
        "وأحجام خاصة لخطوط الإنتاج"
      ],

      applications: [
        {
          category: "Metal Fabrication Workshops",
          categoryAr: "ورش تصنيع المعادن",
          items: [
            "Custom metal parts",
            "Machine components",
            "Heavy-duty structures"
          ],
          itemsAr: [
            "قطع غيار معدنية مخصصة",
            "مكونات الماكينة",
            "هياكل ثقيلة"
          ]
        },
        {
          category: "Steel Structure Production",
          categoryAr: "مصانع الهياكل المعدنية",
          items: ["Beams", "Frames", "Connection plates"],
          itemsAr: ["الكمرات", "الإطارات", "لوحات التوصيل"]
        },
        {
          category: "HVAC Duct Manufacturing",
          categoryAr: "صناعة مجاري الهواء HVAC",
          items: ["Duct panels", "Flanges", "Fittings"],
          itemsAr: ["ألواح مجاري الهواء", "الحواف", "التوصيلات"]
        },
        {
          category: "Automotive & Machinery Parts",
          categoryAr: "قطع الغيار الميكانيكية والسيارات",
          items: ["Brackets", "Mounting plates", "Structural components"],
          itemsAr: ["حوامل", "لوحات التركيب", "مكونات هيكلية"]
        },
        {
          category: "Industrial Decorations & Signage",
          categoryAr: "الديكورات المعدنية واللافتات",
          items: ["Metal art", "Decorative panels", "Custom designs"],
          itemsAr: ["أعمال فنية معدنية", "ألواح زخرفية", "تصاميم مخصصة"]
        },
        {
          category: "Shipbuilding & Heavy Industries",
          categoryAr: "بناء السفن والصناعات الثقيلة",
          items: ["Thick metal cutting", "Reinforcement plates", "Structural components"],
          itemsAr: ["قطع المعادن السميكة", "لوحات التعزيز", "مكونات هيكلية"]
        }
      ],

      advantages: [
        "Fast cutting speed & high productivity",
        "Affordable metal cutting solution",
        "Powerful penetration for thick metals",
        "Compatible with nesting & CAD/CAM software",
        "Easy operation & maintenance",
        "Strong mechanical durability"
      ],
      advantagesAr: [
        "سرعة قطع عالية وإنتاجية قوية",
        "حل اقتصادي للقطع المعدني",
        "قدرة اختراق ممتازة للمعادن السميكة",
        "متوافق مع برامج CAD/CAM",
        "تشغيل وصيانة سهلة",
        "بنية ميكانيكية قوية"
      ]
    },

    TitleTag: "CNC Plasma Cutting Machine | High-Speed Metal Cutting",
    MetaDescription: "CNC plasma cutting machine for steel, stainless steel, and industrial fabrication. High-speed, precise, and durable with advanced CNC control.",
    Keywords: "CNC plasma cutting, metal cutting machine, plasma cutter",
    SEOContent: ""
  },

  {
    id: 22,
    name: "DA53T 4+1Axis CNC Press Brake Machine",
    nameAr: "ماكينة ثني الصاج CNC",
    image: "/products/DA53T 4+1Axis CNC Press Brake Machine.jfif",
    image_small: "/products/DA53T 4+1Axis CNC Press Brake Machine.jfif",
    slug: "da53t-4-plus-1-axis-cnc-press-brake-laser-machine",
    title: "DA53T 4+1Axis CNC Press Brake Machine",
    titleAr: "ماكينة ثني الصاج CNC",
    desc: "High-precision CNC press brake for sheet metal bending with advanced controllers, hydraulic/hybrid systems, and robust frame structure.",
    descAr: "ماكينة الثني CNC عالية الدقة لصفائح المعادن مجهزة بوحدات تحكم متقدمة وأنظمة هيدروليك/هجينة وهيكل صلب.",

    overview: `
High-Precision Bending for Sheet Metal Fabrication

The CNC Press Brake Machine is engineered for precise, consistent, and high-efficiency bending of sheet metal.
With advanced CNC controllers, high-quality hydraulic or hybrid systems, and a rigid frame structure, it delivers exceptional accuracy for industrial fabrication, HVAC, enclosures, metal furniture, and large-scale production.
`,
    overviewAr: `
نظرة عامة

ثني عالي الدقة لصفائح المعادن.
ماكينة الثني CNC مصممة لتقديم دقة عالية، ثبات، وكفاءة إنتاجية ممتازة في ثني المعادن. مجهزة بوحدات تحكم CNC متقدمة، أنظمة هيدروليك أو سيرفو هجينة، وهيكل صلب لضمان نتائج دقيقة في تصنيع الصاج، HVAC، الكباين، الأثاث المعدني، وخطوط الإنتاج الصناعية.
`,

    details: {
      keyFeatures: [
        {
          title: "High-Precision Bending Performance",
          titleAr: "دقة ثني عالية",
          points: [
            "CNC-controlled back gauge and bending angles for accurate repeatability",
            "Smooth bending lines",
            "Perfect results for complex shapes"
          ],
          pointsAr: [
            "مزودة بباك جيج (Back Gauge) وزاوية ثني متحكم بها CNC لتحقيق دقة تكرار ممتازة",
            "خطوط ثني ناعمة",
            "نتائج مثالية للأشكال المعقدة"
          ]
        },
        {
          title: "Advanced CNC Controller",
          titleAr: "وحدة تحكم CNC متطورة",
          points: [
            "Delem DA-52S / DA-58T / DA-66T / DA-69T",
            "ESA S630 / S640 / S650",
            "2D/3D bending simulation",
            "Automatic crowning calculation",
            "Multi-step programming",
            "Automatic bending sequence planning"
          ],
          pointsAr: [
            "خيارات: Delem DA-52S / DA-58T / DA-66T / DA-69T، ESA S630 / S640 / S650",
            "محاكاة ثني 2D / 3D",
            "حساب أوتوماتيك للتعويض (Crowning)",
            "برمجة متعددة الخطوات",
            "تخطيط أوتوماتيكي لترتيب الانحناءات"
          ]
        },
        {
          title: "Robust Machine Structure",
          titleAr: "هيكل قوي",
          points: [
            "High-strength welded steel frame, stress-relieved for long-term stability",
            "Ensures precision under heavy-duty continuous work"
          ],
          pointsAr: [
            "إطار فولاذي ملحوم عالي الصلابة، معالج لإزالة الإجهاد الحراري",
            "يضمن الدقة مع العمل الشاق طويل المدى"
          ]
        },
        {
          title: "Hydraulic or Hybrid Servo System",
          titleAr: "نظام هيدروليكي أو هجين Servo",
          points: [
            "Hydraulic press brake",
            "Hybrid servo-controlled system for higher accuracy and energy savings",
            "Reduced oil consumption, lower noise, faster response time"
          ],
          pointsAr: [
            "ثناية هيدروليك أو سيرفو هجين",
            "ثناية سيرفو هجين لأعلى دقة وتوفير الطاقة",
            "استهلاك زيت أقل، ضوضاء أقل، استجابة أسرع"
          ]
        },
        {
          title: "Automatic Crowning System",
          titleAr: "نظام تعويض تلقائي (Crowning)",
          points: ["Ensures consistent bending angle across the entire sheet length"],
          pointsAr: ["يحافظ على زاوية ثني ثابتة على كامل طول الصاج"]
        },
        {
          title: "Back Gauge with Multiple Axes",
          titleAr: "الباك جيج متعدد المحاور",
          points: ["Options: X, R, Z1, Z2 axes for complex and multi-step bending jobs"],
          pointsAr: ["خيارات: X – R – Z1 – Z2 مناسب لأعمال الثني المعقدة"]
        },
        {
          title: "Safety & Protection Systems",
          titleAr: "أنظمة حماية كاملة",
          points: [
            "Safety light curtains",
            "Emergency stop",
            "Safety foot pedal",
            "Side and rear guards"
          ],
          pointsAr: [
            "ستائر ضوئية",
            "إيقاف طوارئ",
            "دواسة قدم آمنة",
            "حمايات جانبية وخلفية"
          ]
        }
      ],

      workingArea: [
        "1.2 meters (1200 mm)",
        "1.6 meters (1600 mm)",
        "2.0 meters (2000 mm)",
        "2.5 meters (2500 mm)",
        "3.2 meters (3200 mm)",
        "4.0 meters (4000 mm)",
        "5.0 meters (5000 mm)",
        "6.0 meters (6000 mm)",
        "8.0 meters (8000 mm)",
        "10 meters (10,000 mm)",
        "Custom lengths (7m, 9m, 12m) available upon request"
      ],
      workingAreaAr: [
        "1200 مم",
        "1600 مم",
        "2000 مم",
        "2500 مم",
        "3200 مم (الأكثر شيوعًا)",
        "4000 مم",
        "5000 مم",
        "6000 مم",
        "8000 مم",
        "10,000 مم",
        "إمكانية تصنيع أطوال خاصة (7م، 9م، 12م)"
      ],

      applications: [
        {
          category: "Sheet Metal Fabrication",
          categoryAr: "تصنيع الصاج",
          items: ["Enclosures", "Panels", "Cabinets", "Electrical boxes"],
          itemsAr: ["كباين", "ألواح", "خزائن", "صناديق كهربائية"]
        },
        {
          category: "HVAC & Ducting Industry",
          categoryAr: "HVAC والدكتات",
          items: ["Duct components", "Brackets", "Angle bending"],
          itemsAr: ["مكونات مجاري الهواء", "حوامل", "ثني زوايا"]
        },
        {
          category: "Metal Furniture & Decoration",
          categoryAr: "الأثاث المعدني",
          items: ["Frames", "Tables", "Customized metal parts"],
          itemsAr: ["إطارات", "طاولات", "قطع معدنية مخصصة"]
        },
        {
          category: "Automotive & Machinery",
          categoryAr: "السيارات والميكانيكا",
          items: ["Brackets", "Mounting parts", "Structural components"],
          itemsAr: ["حوامل", "قطع تركيبية", "مكونات هيكلية"]
        },
        {
          category: "Industrial Manufacturing",
          categoryAr: "تصنيع المعدات الصناعية",
          items: ["Machine parts", "Frames", "Large custom metal projects"],
          itemsAr: ["قطع ماكينات", "إطارات", "مشاريع معدنية كبيرة مخصصة"]
        }
      ],

      advantages: [
        "High accuracy & repeatability",
        "Fast bending cycles",
        "Low energy consumption (Hybrid models)",
        "Suitable for complex shapes",
        "Easy to operate",
        "High productivity for mass production"
      ],
      advantagesAr: [
        "دقة وثبات عالي",
        "دورات ثني سريعة",
        "استهلاك منخفض للطاقة (في الموديلات الهجينة)",
        "مناسب للأشكال المعقدة",
        "سهل التشغيل",
        "إنتاجية عالية للتشغيل الكمي"
      ]
    },

    TitleTag: "DA53T 4+1Axis CNC Press Brake Machine | High-Precision Sheet Metal Bending",
    MetaDescription: "High-precision CNC press brake for sheet metal bending with advanced controllers, hydraulic/hybrid systems, and robust frame structure.",
    Keywords: "CNC press brake, CNC bending machine, hydraulic CNC brake press",
    SEOContent: ""
  },

  {
    id: 23,
    name: "WC67K E310 200T6000mm Heavy Duty Sheet Metal CNC Press",
    nameAr: "ماكينة الثني NC",
    image: "/products/WC67K E310 200T6000mm Heavy Duty Sheet Metal CNC Press.jfif",
    image_small: "/products/WC67K E310 200T6000mm Heavy Duty Sheet Metal CNC Press.jfif",
    slug: "wc67k-e310-200t6000mm-heavy-duty-sheet-metal-cnc-press-laser",
    title: "WC67K E310 200T6000mm Heavy Duty Sheet Metal CNC Press Brake",
    titleAr: "ماكينة الثني NC",
    desc: "Reliable and cost-effective NC press brake for sheet-metal bending with hydraulic system and solid frame structure.",
    descAr: "ماكينة ثني NC عملية واقتصادية لصفائح المعادن مزودة بنظام هيدروليكي وهيكل صلب.",

    overview: `
Reliable and Cost-Effective Metal Bending for Workshops & Industrial Production

The NC Press Brake Machine is a practical and economical solution for sheet-metal bending, designed for workshops and factories that need accurate bending performance without the complexity of fully computerized CNC systems.
With a simple NC controller, hydraulic power, and a solid frame structure, it offers consistent results and easy operation—perfect for small to medium-scale production.
`,
    overviewAr: `
نظرة عامة

ماكينة الثني NC هي خيار عملي واقتصادي لثني صفائح المعادن، ومناسبة للورش والمصانع التي تحتاج دقة ثني ممتازة بدون تعقيد أنظمة CNC المتقدمة.
تعتمد على وحدة تحكم NC بسيطة، نظام هيدروليكي ثابت، وهيكل قوي يضمن نتائج دقيقة وسهولة تشغيل—حل مثالي للإنتاج الخفيف والمتوسط.
`,

    details: {
      keyFeatures: [
        {
          title: "Accurate Bending with NC Control",
          titleAr: "دقة ثني عالية باستخدام تحكم NC",
          points: [
            "Back gauge position control",
            "Bending angle via ram stroke",
            "Multi-step bending programs for repeatable quality"
          ],
          pointsAr: [
            "النظام يتحكم في موضع الباك جيج",
            "زاوية الثني عن طريق مشوار الكباس",
            "برامج ثني متعددة الخطوات للحصول على جودة متكررة"
          ]
        },
        {
          title: "User-Friendly NC Controller",
          titleAr: "وحدة تحكم سهلة الاستخدام",
          points: [
            "Simple operation, minimal training required",
            "Common controllers: ESTUN E21, ESTUN E200P, MD11 / MD20",
            "Programmable steps, automatic back gauge movement, digital stroke adjustment, memory storage for multiple jobs"
          ],
          pointsAr: [
            "تشغيل بسيط وما يحتاج خبرة كبيرة",
            "وحدات التحكم المتوفرة: ESTUN E21, ESTUN E200P, MD11 / MD20",
            "برمجة خطوات، حركة أوتوماتيكية للباك جيج، ضبط رقمي لمشوار الكباس، حفظ وظائف متعددة"
          ]
        },
        {
          title: "Hydraulic Bending System",
          titleAr: "نظام ثني هيدروليكي قوي",
          points: [
            "Smooth bending motion",
            "Strong pressing force",
            "High durability, low maintenance cost",
            "Suitable for carbon steel, stainless steel, aluminum, and galvanized sheets"
          ],
          pointsAr: [
            "حركة ثني ناعمة",
            "قوة ضغط عالية",
            "متانة ممتازة، تكلفة صيانة منخفضة",
            "مناسب للصاج بأنواعه"
          ]
        },
        {
          title: "Heavy-Duty Machine Frame",
          titleAr: "هيكل فولاذي ثقيل",
          points: [
            "Welded steel construction, stress-relieved body",
            "Excellent stability during long working hours"
          ],
          pointsAr: [
            "جسم فولاذي ملحوم ومعالج حرارياً",
            "ثبات عالي أثناء التشغيل الطويل"
          ]
        },
        {
          title: "Back Gauge for Consistent Results",
          titleAr: "الباك جيج",
          points: [
            "Motorized X-axis",
            "Manual R-axis adjustment",
            "Suitable for most standard bending applications"
          ],
          pointsAr: [
            "محور X كهربائي",
            "محور R يدوي",
            "مناسب لمعظم أعمال الثني القياسية"
          ]
        },
        {
          title: "Safety Systems",
          titleAr: "أنظمة الأمان",
          points: [
            "Emergency stop",
            "Foot pedal control",
            "Side & rear protective guards",
            "Optional light curtain"
          ],
          pointsAr: [
            "إيقاف طوارئ",
            "دواسة قدم",
            "حمايات جانبية وخلفية",
            "ستارة ضوئية (اختياري)"
          ]
        }
      ],

      workingArea: [
        "1.2 meters (1200 mm)",
        "1.6 meters (1600 mm)",
        "2.0 meters (2000 mm)",
        "2.5 meters (2500 mm)",
        "3.2 meters (3200 mm)",
        "4.0 meters (4000 mm)",
        "5.0 meters (5000 mm)",
        "6.0 meters (6000 mm)",
        "8.0 meters (8000 mm)",
        "10 meters (10,000 mm)",
        "Custom lengths (7m, 9m, 12m) available upon request"
      ],
      workingAreaAr: [
        "1200 – 1600 – 2000 – 2500 – 3200 مم (الأكثر طلبًا)",
        "4000 – 5000 – 6000 – 8000 – 10,000 مم",
        "إمكانية تصنيع أطوال خاصة (7م – 9م – 12م)"
      ],

      tonCapacity: [
        "40 Ton – 63 Ton (Light bending)",
        "80 Ton – 100 Ton (Standard sheet metal work)",
        "125 Ton – 160 Ton",
        "200 Ton – 250 Ton",
        "300 Ton – 400 Ton",
        "500 Ton – 1000 Ton (Heavy-duty bending)"
      ],
      tonCapacityAr: [
        "40–63 طن → أعمال خفيفة",
        "80–100 طن → الاستخدام العام",
        "125–160 طن",
        "200–250 طن",
        "300–400 طن",
        "500–1000 طن → الاستخدام الصناعي الثقيل"
      ],

      applications: [
        {
          category: "Sheet Metal Workshops",
          categoryAr: "ورش تشكيل المعادن",
          items: ["Small cabinets", "Enclosures", "Bending panels and boxes"],
          itemsAr: ["كبائن صغيرة", "صناديق", "ألواح"]
        },
        {
          category: "HVAC & Light Industrial Fabrication",
          categoryAr: "تصنيع الدكتات والـ HVAC",
          items: ["Duct components", "Flanges", "Support brackets"],
          itemsAr: ["مكونات الدكت", "فلنجات", "حوامل دعم"]
        },
        {
          category: "Metal Furniture Production",
          categoryAr: "الأثاث المعدني",
          items: ["Frames", "Shelves", "Decorative parts"],
          itemsAr: ["إطارات", "رفوف", "قطع زخرفية"]
        },
        {
          category: "Automotive & Machinery Parts",
          categoryAr: "قطع السيارات والميكانيكا",
          items: ["Mounting plates", "Angles and brackets", "Formed components"],
          itemsAr: ["صفائح تركيب", "زوايا وحوامل", "مكونات مصبوبة"]
        },
        {
          category: "General Fabrication & Maintenance",
          categoryAr: "أعمال الصيانة والتصنيع العام",
          items: ["Repair shops", "Small production lines", "Custom metal bending"],
          itemsAr: ["ورش صيانة", "خطوط إنتاج صغيرة", "ثني معدني مخصص"]
        }
      ],

      advantages: [
        "Affordable and practical bending solution",
        "Easy to learn and operate",
        "Low maintenance",
        "Excellent for small and medium production",
        "Strong hydraulic bending performance",
        "High reliability for daily workshop use"
      ],
      advantagesAr: [
        "حل اقتصادي وعملي",
        "تشغيل سهل",
        "صيانة قليلة",
        "ممتاز للإنتاج الخفيف والمتوسط",
        "قوة هيدروليكية عالية",
        "يعتمد عليه داخل الورش بشكل يومي"
      ]
    },

    TitleTag: "WC67K E310 NC Press Brake | Cost-Effective Sheet Metal Bending",
    MetaDescription: "Reliable NC press brake for sheet metal bending with hydraulic system and solid frame, suitable for workshops and small production.",
    Keywords: "NC press brake, hydraulic bending machine, sheet metal",
    SEOContent: ""
  },
  {
    id: 24,
    name: "2 Axis NC E21 Hydraulic Press Brake Machine",
    nameAr: "ماكينة القص – Shearing Machine",
    image: "/products/2 Axis NC E21 Hydraulic Press Brake Machine.jfif",
    image_small: "/products/2 Axis NC E21 Hydraulic Press Brake Machine.jfif",
    slug: "2-axis-nc-e21-hydraulic-press-brake-laser-machine",
    title: "2 Axis NC Press Brake",
    titleAr: "ماكينة القص – Shearing Machine",
    desc: "High-performance NC hydraulic press brake for precise metal bending and sheet fabrication.",
    descAr: "ماكينة NC Hydraulic Press Brake عالية الأداء لعمليات الثني الدقيق للمعادن وتشكيل الصفائح المعدنية.",

    overview: `
High-Performance Metal Cutting for Industrial Sheet Fabrication

The Shearing Machine is designed for fast, precise, and clean cutting of sheet metal.
Built with a heavy-duty frame, advanced hydraulic systems, and a reliable blade mechanism, it delivers smooth cutting performance for a wide range of metals—making it an essential machine in any metal fabrication workshop.
Available in Hydraulic Guillotine Shearing and Hydraulic Swing Beam Shearing types.
`,
    overviewAr: `
نظرة عامة

ماكينة قص عالية الأداء لقص صفائح المعادن بدقة وسرعة.
مصممة بهيكل ثقيل، نظام هيدروليكي قوي، وسكاكين عالية الجودة لقص نظيف وسلس.
متوفرة بنوعي:
● قص جيليوتين هيدروليكي
● قص سوينغ بيم هيدروليكي
`,

    details: {
      keyFeatures: [
        {
          title: "Available Cutting Lengths",
          titleAr: "أطوال القص المتوفرة",
          points: [
            "1.2 meters (1200 mm)",
            "1.6 meters (1600 mm)",
            "2.0 meters (2000 mm)",
            "2.5 meters (2500 mm)",
            "3.2 meters (3200 mm) – Most common",
            "4.0 meters (4000 mm)",
            "5.0 meters (5000 mm)",
            "6.0 meters (6000 mm)",
            "Custom lengths (7m, 8m, 10m) available upon request"
          ],
          pointsAr: [
            "1.2 م – 1.6 م – 2.0 م – 2.5 م",
            "3.2 م (الأكثر طلبًا)",
            "4.0 م – 5.0 م – 6.0 م",
            "إمكانية تصنيع 7م / 8م / 10م حسب الطلب"
          ]
        },
        {
          title: "Cutting Thickness Capacity",
          titleAr: "سماكات القص",
          points: [
            "0.5 mm – 2 mm (Light sheet metal)",
            "2 mm – 4 mm",
            "4 mm – 6 mm (Medium thickness)",
            "6 mm – 8 mm",
            "8 mm – 13 mm (Heavy-duty cutting)",
            "Up to 20 mm (High-strength industrial models)"
          ],
          pointsAr: [
            "0.5 – 2 مم → خفيف",
            "2 – 4 مم",
            "4 – 6 مم",
            "6 – 8 مم",
            "8 – 13 مم",
            "حتى 20 مم → موديلات صناعية ثقيلة"
          ]
        },
        {
          title: "High Cutting Precision",
          titleAr: "دقة قص عالية",
          points: [
            "Smooth, burr-free edges",
            "Adjustable blade clearance",
            "Stable performance for thin and medium sheets"
          ],
          pointsAr: [
            "حواف ناعمة بدون زوائد",
            "ضبط خلوص السكين",
            "أداء ثابت حتى مع التشغيل المتواصل"
          ]
        },
        {
          title: "Hydraulic System for Stable Power",
          titleAr: "نظام هيدروليكي قوي",
          points: [
            "High-efficiency hydraulic cylinders",
            "Fast cutting cycles",
            "Low noise and reduced vibration"
          ],
          pointsAr: [
            "أسطوانات عالية الكفاءة",
            "سرعة قص ممتازة",
            "اهتزاز وضوضاء منخفضة"
          ]
        },
        {
          title: "Robust Machine Body",
          titleAr: "هيكل قوي وثابت",
          points: [
            "Welded steel structure",
            "Stress-relieved frame",
            "Minimal deformation during heavy-duty cutting"
          ],
          pointsAr: [
            "فولاذ ملحوم",
            "معالجة لإزالة الإجهاد",
            "مقاوم للتشوه أثناء القص المستمر"
          ]
        },
        {
          title: "Easy Operation & Digital Control",
          titleAr: "تشغيل سهل وتحكم رقمي",
          points: [
            "NC or digital control for back gauge, cutting length, and stroke",
            "Interfaces: ESTUN E21S, MD series controllers"
          ],
          pointsAr: [
            "تحكم في: الباك جيج، طول القص، عدد ضربات القص",
            "وحدات التحكم: ESTUN E21S، سلسلة MD"
          ]
        },
        {
          title: "Adjustable Cutting Angle",
          titleAr: "زاوية قص قابلة للتعديل",
          points: [
            "Optimized performance for thick or long sheets",
            "Improved cutting quality and energy efficiency"
          ],
          pointsAr: [
            "لتحسين أداء القص في السماكات الكبيرة وتقليل استهلاك الطاقة"
          ]
        },
        {
          title: "High-Quality Blades",
          titleAr: "سكاكين عالية الجودة",
          points: [
            "Alloy tool steel (Cr12MoV or H13)",
            "Long service life",
            "Re-sharpenable multiple times"
          ],
          pointsAr: [
            "مصنوعة من Cr12MoV أو H13",
            "عمر طويل ويمكن شحذها أكثر من مرة"
          ]
        },
        {
          title: "Safety & Protection Systems",
          titleAr: "أنظمة الأمان",
          points: [
            "Front fences",
            "Emergency stop",
            "Finger protection guard",
            "Rear safety gates"
          ],
          pointsAr: [
            "حمايات أمامية",
            "زر طوارئ",
            "حماية أصابع",
            "حواجز خلفية"
          ]
        }
      ],

      applications: [
        {
          category: "Sheet Metal Fabrication",
          categoryAr: "تصنيع الصاج",
          items: ["Steel sheets", "Stainless steel", "Aluminum", "Galvanized sheets"],
          itemsAr: ["صفائح الحديد", "ستانلس ستيل", "ألمنيوم", "صفائح مجلفنة"]
        },
        {
          category: "HVAC & Duct Manufacturing",
          categoryAr: "صناعة الدكتات",
          items: ["Duct pieces", "Flanges", "Frames"],
          itemsAr: ["قطع الدكت", "فلنجات", "إطارات"]
        },
        {
          category: "Electrical Panels & Cabinets",
          categoryAr: "لوحات الكهرباء والكباين",
          items: ["Cutting panels", "Forming enclosure parts"],
          itemsAr: ["قص ألواح", "تشكيل أجزاء الكباين"]
        },
        {
          category: "Metal Furniture Production",
          categoryAr: "الأثاث المعدني",
          items: ["Shelves", "Frames", "Panels"],
          itemsAr: ["رفوف", "إطارات", "ألواح"]
        },
        {
          category: "Automotive & Machinery Parts",
          categoryAr: "قطع السيارات والميكانيكا",
          items: ["Brackets", "Covers", "Custom-cut plates"],
          itemsAr: ["حوامل", "أغطية", "صفائح مقطوعة مخصصة"]
        },
        {
          category: "General Industrial Cutting",
          categoryAr: "الورش وخطوط التصنيع",
          items: ["Workshops", "Factories", "Metal processing lines"],
          itemsAr: ["ورش", "مصانع", "خطوط تصنيع المعادن"]
        }
      ],

      advantages: [
        "Smooth, accurate cutting",
        "Low operating cost",
        "Long blade lifespan",
        "Easy maintenance",
        "High productivity for mass production",
        "Reliable hydraulic performance"
      ],
      advantagesAr: [
        "قص دقيق ونظيف",
        "تشغيل منخفض التكلفة",
        "سكاكين طويلة العمر",
        "صيانة سهلة",
        "إنتاجية عالية",
        "أداء هيدروليكي موثوق"
      ]
    },

    TitleTag: "2 Axis NC Hydraulic Shearing Machine | High-Performance Metal Cutting",
    MetaDescription: "High-performance NC hydraulic shearing machine for precise and fast sheet metal cutting, suitable for industrial workshops.",
    Keywords: "NC press brake, shearing machine, hydraulic cutting",
    SEOContent: ""
  }

];

export const productsWelding = [
  {
    id: 12,
    name: "2024 Ultra-Portable 500W air cooled handheld welding Machine",
    slug: "2024-ultra-portable-500w-air-cooled-handheld-welding-machine",
    image: "/../products/28.webp",
    title: "Previous Next Ultra portable 500w air cooled welding",
    desc: "1. Compact & Portable Design ...",
  },
  {
    id: 13,
    name: "2024 Best Portable Water cooled laser welding machine 4 in1",
    slug: "2024-best-portable-water-cooled-laser-welding-machine-4-in1",
    image: "/../products/29.webp",
    title: "Portable water cooled laser welding machine",
    desc: "1.JNTECH handheld laser welding machine ...",
  },
  {
    id: 14,
    name: "Affordable Price Five-axis platform laser welding machine",
    slug: "affordable-price-five-axis-platform-laser-welding-machine",
    image: "/../products/30.webp",
    title: "Platform Laser Welding Machine",
    desc: "1) High degree of automation ...",
  },
  {
    id: 15,
    name: "3 in 1 Fiber Laser Welding Cleaning Cutting Machine",
    slug: "3-in-1-fiber-laser-welding-cleaning-cutting-machine",
    image: "/../products/31.webp",
    title: "3 in 1 Fiber Laser Welding Cleaning Cutting Machine",
    desc: "3 in 1 Fiber Laser Welding Cleaning Cutting Machine ...",
  },
  {
    id: 16,
    name: "1kw-3kw Handheld Fiber Laser Welding Machine",
    slug: "1kw-3kw-handheld-fiber-laser-welding-machine",
    image: "/../products/32.webp",
    title: "Handheld Fiber Laser Welding Machine",
    desc: "JNW1000W JNW2000w JNW3000w Fiber Laser welding machine ...",
  },
];

export const productsPlasma = [
  {
    id: 17,
    name: "2023 Top Affordable JNP1530 CNC Plasma Cutting Table for Sale",
    slug: "2023-top-affordable-jnp1530-cnc-plasma-cutting-table-for-sale",
    image: "/../products/33.webp",
    title: "JNP1530 CNC Plasma Cutting Machine",
    desc: "JNP1530 CNC plasma cutting table ...",
  },
  {
    id: 18,
    name: "JNP1530R Sheet Metal & Tube Plasma Cutter on Sale",
    slug: "jnp1530r-sheet-metal-and-tube-plasma-cutter-on-sale",
    image: "/../products/34.webp",
    title: "JNP1530R Sheet Metal&Tube Plasma Machine",
    desc: "JNP1530R CNC plasma cutting machine ...",
  },
  {
    id: 19,
    name: "JNP2040 CNC Plasma Cutting Machine Gantry Model",
    slug: "jnp2040-cnc-plasma-cutting-machine-gantry-model",
    image: "/../products/35.webp",
    title: "CNC Plasma Cutting Machine Gantry",
    desc: "All kinds of metal materials ...",
  },
];

export const productsPress = [
  {
    id: 22,
    name: "DA53T 4+1Axis CNC Press Brake Machine",
    slug: "da53t-4-plus-1axis-cnc-press-brake-machine",
    image: "/../products/42.webp",
    title: "DA53T 4+1Axis CNC Press Brake Machine",
    desc: "1. Steel plate welded structure ...",
  },
  {
    id: 23,
    name: "WC67K E310 200T6000mm Heavy Duty Sheet Metal CNC Press",
    slug: "wc67k-e310-200t6000mm-heavy-duty-sheet-metal-cnc-press",
    image: "/../products/43.webp",
    title: "WC67K E310 200T6000mm Heavy Duty Sheet Metal CNC Press Brake",
    desc: "1. Steel plate welded structure ...",
  },
  {
    id: 24,
    name: "2 Axis NC E21 Hydraulic Press Brake Machine",
    slug: "2-axis-nc-e21-hydraulic-press-brake-machine",
    image: "/../products/45.webp",
    title: "2 Axis NC Press Brake",
    desc: "Model Type :WC67K",
  },
  {
    id: 25,
    name: "DA53T 300T3200mm 4+1 Axis CNC Hydraulic Press Brake",
    slug: "da53t-300t3200mm-4-plus-1-axis-cnc-hydraulic-press-brake",
    image: "/../products/47.webp",
    title: "DA53T 300T3200mm 4+1 Axis CNC Hydraulic Press Brake",
    desc: "1. Steel plate welded structure ...",
  },
  {
    id: 26,
    name: "DA66T 6+1 Axis CNC Press Brake With Feeder Brand :Rbqlty",
    slug: "da66t-6-plus-1-axis-cnc-press-brake-with-feeder-brand-rbqlty",
    image: "/../products/46.webp",
    title: "DA66T 6+1 Axis CNC Press Brake With Feeder",
    desc: "Model Type :WE67K",
  },
  {
    id: 27,
    name: "Panel Bending Machine",
    slug: "panel-bending-machine",
    image: "/../products/53.webp",
    title: "Panel Bending Machine",
    desc: "No description added",
  },
];

export const productsShearing = [
  {
    id: 28,
    name: "QC11K E21S 8x6000mm Hydraulic Guillotine Shearing Machine",
    slug: "qc11k-e21s-8x6000mm-hydraulic-guillotine-shearing-machine",
    image: "/../products/48.webp",
    title: "QC11K E21S 8x6000mm Hydraulic Guillotine Shearing Machine",
    desc: "Optional Numeric Control System ...",
  },
  {
    id: 29,
    name: "Swing beam shears",
    slug: "swing-beam-shears",
    image: "/../products/49.webp",
    title: "Swing Beam shearing Machine",
    desc: "1.rack,knife,vibration to eliminate stress ...",
  },
  {
    id: 30,
    name: "QC11K DAC360 16x3200 Servo Guillotine Shearing Machine",
    slug: "qc11k-dac360-16x3200-servo-guillotine-shearing-machine",
    image: "/../products/50.webp",
    title: "QC11K DAC360 16x3200 Servo Guillotine Shearing Machine",
    desc: "Optional Numeric Control System ...",
  },
  {
    id: 31,
    name: "DAC360 CNC Hydraulic Shearing",
    slug: "dac360-cnc-hydraulic-shearing",
    image: "/../products/51.webp",
    title: "DAC360 CNC Hydraulic Shearing",
    desc: "No description",
  },
  {
    id: 32,
    name: "Large Heavy Duty Guillotine Shears",
    slug: "large-heavy-duty-guillotine-shears",
    image: "/../products/52.webp",
    title: "Large Heavy Duty Guillotine Shears",
    desc: "Optional Numeric Control System ...",
  },
];